/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 432:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js + 2 modules
var defineProperty = __webpack_require__(167);
// EXTERNAL MODULE: ./node_modules/swiper/core/core.js + 61 modules
var core = __webpack_require__(557);
;// CONCATENATED MODULE: ./src/js/utils/swiper.js

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var matcher = window.matchMedia("(pointer: fine)");
core/* default.extendDefaults */.Z.extendDefaults(_objectSpread({
  preventClicks: false,
  preventClicksPropagation: false
}, matcher.matches && {
  longSwipesMs: 100,
  longSwipesRatio: 0.2,
  shortSwipes: false
}));

// https://github.com/nolimits4web/swiper/blob/d68a71bea14361010ef201b15359ed6a64c37f4c/src/core/core.js#L91-L98
var BetterClickHandler = function BetterClickHandler(_ref) {
  var swiper = _ref.swiper,
    on = _ref.on,
    emit = _ref.emit;
  var allowClick = false;
  var onClick = function onClick(e) {
    if (allowClick) {
      emit('ppClick', e);
    } else {
      e.preventDefault();

      // https://github.com/nolimits4web/swiper/blob/d68a71bea14361010ef201b15359ed6a64c37f4c/src/core/events/onClick.js
      if (swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  };
  var onTouchStart = function onTouchStart() {
    allowClick = false;
  };
  var onTouchEnd = function onTouchEnd() {
    var data = swiper.touchEventsData;
    var touchEndTime = Date.now();
    var timeDiff = touchEndTime - data.touchStartTime;
    var moveDiff = data.isMoved ? Math.abs(data.currentTranslate - data.startTranslate) : 0;
    // console.log(`touch end details ${timeDiff} ${moveDiff}`);
    allowClick = timeDiff < 200 && moveDiff < 5;
  };
  var onInit = function onInit() {
    swiper.el.addEventListener('click', onClick);
  };
  var onDestroy = function onDestroy() {
    swiper.el.removeEventListener('click', onClick);
  };
  on('init', onInit);
  on('destroy', onDestroy);
  on('touchStart', onTouchStart);
  on('touchEnd', onTouchEnd);
};
core/* default.use */.Z.use(BetterClickHandler);
// EXTERNAL MODULE: ./node_modules/alpinejs/dist/module.esm.js
var module_esm = __webpack_require__(306);
// EXTERNAL MODULE: ./node_modules/@alpinejs/focus/dist/module.esm.js
var dist_module_esm = __webpack_require__(678);
;// CONCATENATED MODULE: ./src/styles/main.css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/styles/account.css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/js/bundles/snippets/navigation.js
var navStore = function navStore() {
  return {
    navData: [],
    init: function init() {
      this.setData();
    },
    setData: function setData() {
      var submenus = document.querySelectorAll('.nav-submenu-data');
      this.navData = Array.from(submenus).map(function (submenu) {
        return JSON.parse(submenu.textContent);
      });
    }
  };
};
var navDesktopComponent = function navDesktopComponent() {
  return {
    selectedSubmenuIdx: null,
    isHoveringSubmenu: false,
    hoveringSubmenuIdx: null,
    keyboardOpen: false,
    handleTopCategoryHover: function handleTopCategoryHover(idx) {
      this.selectedSubmenuIdx = idx;
    },
    handleTopCategoryLeave: function handleTopCategoryLeave(idx) {
      var _this = this;
      if (!this.isHoveringSubmenu || this.hoveringSubmenuIdx !== idx) {
        setTimeout(function () {
          _this.selectedSubmenuIdx = null;
        }, 10);
      }
    },
    handleSubmenuMouseEnter: function handleSubmenuMouseEnter(idx) {
      this.isHoveringSubmenu = true;
      this.hoveringSubmenuIdx = idx;
    },
    handleSubmenuMouseLeave: function handleSubmenuMouseLeave() {
      var _this2 = this;
      setTimeout(function () {
        _this2.isHoveringSubmenu = false;
        _this2.hoveringSubmenuIdx = null;
      }, 10);
    }
  };
};
var navMobileComponent = function navMobileComponent() {
  return {
    expandedSubmenuIndexes: [],
    handleExpandSubmenuClick: function handleExpandSubmenuClick(index) {
      this.expandedSubmenuIndexes = [index];
    },
    handleBackNavigation: function handleBackNavigation() {
      this.expandedSubmenuIndexes = [];
    }
  };
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(2);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(611);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(687);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/js/utils/index.js




function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), (0,setPrototypeOf/* default */.Z)(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) k++; groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return (0,inherits/* default */.Z)(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != (0,esm_typeof/* default */.Z)(args[args.length - 1]) && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

var remToPixel = function remToPixel(rem) {
  var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
  var pixels = rem * rootFontSize;
  return pixels;
};
var createDebouncer = function createDebouncer(wait) {
  return function (fn) {
    var i = 0;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var currentI = ++i;
      wait(function () {
        if (currentI === i) {
          fn.apply(void 0, args);
        }
      });
    };
  };
};

// https://stackoverflow.com/questions/8495687/split-array-into-chunks#comment84212474_8495740
var arrayChunk = function arrayChunk(array, chunkSize) {
  return Array(Math.ceil(array.length / chunkSize)).fill().map(function (_, index) {
    return index * chunkSize;
  }).map(function (begin) {
    return array.slice(begin, begin + chunkSize);
  });
};
var request = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url, params) {
    var res, responseError;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch(url, params);
        case 2:
          res = _context.sent;
          if (res.ok) {
            _context.next = 9;
            break;
          }
          _context.next = 6;
          return res.json();
        case 6:
          responseError = _context.sent;
          console.error("NETWORK RESPONSE ERROR -- ".concat(responseError.status, ": "), responseError);
          throw responseError;
        case 9:
          return _context.abrupt("return", res.json());
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function request(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var convertToCamelCase = function convertToCamelCase(string) {
  if (!string) {
    return '';
  }
  return string.replace( /*#__PURE__*/_wrapRegExp(/.\b(\w)/g, {
    word: 1
  }), function (_, $1) {
    return $1.toUpperCase();
  }).replace(/[\s:'"]/g, '').replace( /*#__PURE__*/_wrapRegExp(/^((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/, {
    rest: 1
  }), function (_, $1) {
    return $1.toLowerCase();
  });
};

// https://github.com/sindresorhus/p-defer/blob/0abf7f56337a450cbff45074dd8c83f8ace4726c/index.js
var pDefer = function pDefer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};
var sortAlpha = function sortAlpha(arry, key) {
  return arry.sort(function (a, b) {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
};
;// CONCATENATED MODULE: ./src/js/alpine-plugins/x-on-shopify.js
/**
 * A custom directive that allows Alpine components to subscribe to Shopify theme editor events.
 * `x-on-shopify` requires a modifier and a value.
 *
 * Example: x-on-shopify:block-select="onShopifyBlockSelect"
 *
 * Modifier:
 * The modifier should be the name of the Shopify event you want to subscribe to in kebab case
 * e.g. shopify:section:select => x-on-shopify:section-select
 * For a list of all events see:
 * https://shopify.dev/docs/themes/architecture/sections/integrate-sections-with-the-theme-editor#javascript-events
 *
 * Value:
 * The value should be the name of the callback function you want to run when the event is emitted.
 * This should be a method on your Alpine component.
 *
 *
 * IMPORTANT:
 * Ensure you add `data-section-id` and `data-block-id` attributes to your elements where appropriate.
 * These are needed to scope events to specific section instances.
 *
 * You should also add {{ block.shopify_attributes }} to any blocks used. This is required by Shopify's
 * theme editor to correctly identify the target when emitting block events.
 *
 * e.g:
 *  <div data-section-id="{{ section.id }}">
 *    ...
 *    {% for block in section.blocks %}
 *      <div data-block-id="{{ block.id }}" {{ block.shopify_attributes }}>
 *        ...
 *      </div>
 *    {% endfor %}
 *  </div>
 */

var eventNames = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'];

/**
 * Pub/sub implementation to allow Alpine components to subscribe to
 * scoped Shopify theme events.
 */
var shopifyThemeEvents = {
  events: {},
  subscribe: function subscribe(eventName, fn) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(fn);
  },
  unsubscribe: function unsubscribe(eventName, fn) {
    if (this.events[eventName]) {
      for (var i = 0; i < this.events[eventName].length; i++) {
        if (this.events[eventName][i] === fn) {
          this.events[eventName].splice(i, 1);
          break;
        }
      }
    }
  },
  publish: function publish(eventName, payload) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(function (fn) {
        fn(payload);
      });
    }
  },
  setEventListeners: function setEventListeners() {
    var _this = this;
    eventNames.forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        return _this.emitEvent(event);
      });
    });
  },
  emitEvent: function emitEvent(event) {
    var _this2 = this;
    var sectionId = event.detail.sectionId;
    var normalizedEventName = convertToCamelCase(event.type);
    var container = document.querySelector("[data-section-id=\"".concat(sectionId, "\"]"));
    if (container !== null) {
      // Include the Shopify event object and the section container node in the payload
      var payload = {
        event: event,
        container: container
      };

      // After editing section content Shopify will re-render the entire section
      // setTimeout is needed to prevent the event from firing before this change
      setTimeout(function () {
        // Scope the event to the section id so we can subscribe to it
        // from each instance of a section
        _this2.publish("".concat(normalizedEventName, ":").concat(sectionId), payload);
      }, 0);
    }
  },
  init: function init() {
    // Only set event listeners in the theme editor
    if (window.Shopify.designMode) {
      this.setEventListeners();
    }
  }
};
/* harmony default export */ function x_on_shopify(Alpine) {
  shopifyThemeEvents.init();
  Alpine.directive('on-shopify', function (el, _ref, _ref2) {
    var _el$dataset;
    var value = _ref.value,
      expression = _ref.expression;
    var evaluate = _ref2.evaluate,
      cleanup = _ref2.cleanup;
    // Early return if not in the theme editor
    if (!window.Shopify.designMode) {
      return;
    }
    var sectionId = el === null || el === void 0 ? void 0 : (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.sectionId;
    var normalizedEventName = convertToCamelCase("shopify-".concat(value));
    var scopedEventName = "".concat(normalizedEventName, ":").concat(sectionId);
    var callback = function callback() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return evaluate(expression, {
        params: [].concat(args)
      });
    };
    if (sectionId) {
      shopifyThemeEvents.subscribe(scopedEventName, callback);
      cleanup(function () {
        shopifyThemeEvents.unsubscribe('scopedEventName', callback);
      });
    }
  });
}
;// CONCATENATED MODULE: ./src/js/utils/dom.js
var scrollPosition = 0;
function disableScrollForInputDrawer() {
  scrollPosition = window.scrollY; // Save the current scroll position

  // Lock the body scroll by setting position fixed and top
  document.body.style.position = 'fixed';
  document.body.style.top = "-".concat(scrollPosition, "px");
  document.body.style.width = '100%'; // Prevent horizontal scrollbar
}

function enableScrollForInputDrawer() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollPosition); // Restore the scroll position

  scrollPosition = 0; // Reset scroll position
}

function observeAttentiveOverlay() {
  var attentiveObserver = new MutationObserver(function () {
    var attentiveOverlay = document.getElementById('attentive_overlay');
    if (attentiveOverlay) {
      attentiveOverlay.style.setProperty('z-index', '99999999');
      attentiveObserver.disconnect(); // Stop observing
    }
  });

  // Start observing
  attentiveObserver.observe(document.body, {
    childList: true
  });
}
;// CONCATENATED MODULE: ./src/js/bundles/snippets/drawer-v2.js



var openDrawers = new Set();
var drawer = function drawer(name) {
  return {
    isClosing: false,
    isOpen: false,
    // Note: it's important to set up props here first b/c not doing and using
    // ...`this.mutationObserver = ...` for example would set mutationObserver for the parent component
    // ... and not necessarily this drawer component
    openDrawer: null,
    closeDrawer: null,
    animationEndHandler: null,
    mutationObserver: null,
    init: function init() {
      // bind 'this' so that openDrawers.delete works since it needs to reference 'this' in any instance of drawer-v2
      this.openDrawer = this._openDrawer.bind(this);
      this.closeDrawer = this._closeDrawer.bind(this);
      this.animationEndHandler = this._animationEndHandler.bind(this);
      this.mutationObserver = new MutationObserver(this.handleMutation.bind(this));
      this.mutationObserver.observe(this.$el, {
        attributes: true,
        attributeFilter: ['open']
      });
    },
    _openDrawer: function _openDrawer() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.$dispatch('drawer-open', {
                drawer: _this
              });
              _this.$el.showModal();
              _this.isOpen = true;

              // Immediately blur any focused element inside the dialog
              _this.$nextTick(function () {
                var activeEl = document.activeElement;
                if (activeEl && _this.$el.contains(activeEl)) {
                  activeEl.blur();
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    _animationEndHandler: function _animationEndHandler() {
      openDrawers["delete"](this);
      this.$dispatch('drawer-close', {
        drawer: this
      });
      this.$el.close();
      this.isClosing = false;
      this.isOpen = false;
      this.$el.removeEventListener('transitionend', this.animationEndHandler);
    },
    _closeDrawer: function _closeDrawer() {
      var _this2 = this;
      this.$el.addEventListener('transitionend', this.animationEndHandler);
      this.$nextTick(function () {
        _this2.isClosing = true;
      });
    },
    handleOpenDrawer: function handleOpenDrawer(evt) {
      if (evt.detail.drawerName === name) {
        this._openDrawer();
      }
    },
    handleCloseDrawer: function handleCloseDrawer(evt) {
      if (evt.detail.drawerName === name) {
        this._closeDrawer();
      }
    },
    destroy: function destroy() {
      openDrawers["delete"](this);
    },
    closeOpenDrawers: function closeOpenDrawers() {
      openDrawers.forEach(function (drawer) {
        drawer.closeDrawer();
      });
    },
    handleMutation: function handleMutation() {
      if (this.isClosing) return;
      var newOpen = this.$el.open;
      if (newOpen) {
        openDrawers.add(this);
        document.body.classList.add('scroll-lock');
        window.isMobile && disableScrollForInputDrawer();
      } else {
        openDrawers["delete"](this);
        if (openDrawers.size === 0) {
          document.body.classList.remove('scroll-lock');
          window.isMobile && enableScrollForInputDrawer();
        }
      }
      this.$dispatch(newOpen ? 'drawer-open' : 'drawer-close', {
        drawer: this
      });
    }
  };
};
/* harmony default export */ const drawer_v2 = (drawer);
;// CONCATENATED MODULE: ./src/js/utils/responsive-image-v2.js

var imageWidths = [100, 116, 134, 156, 182, 210, 244, 282, 328, 380, 442, 512, 594, 688, 798, 926, 1074, 1246, 1446, 1678, 1946, 2258, 2618, 3038, 3524, 4088, 4742, 5500];

// NOTE: if in a for loop, use 'x-bind:key' so that the image is updated
/* harmony default export */ const responsive_image_v2 = (function (_ref) {
  var imageUrl = _ref.imageUrl;
  return {
    get srcset() {
      if (!imageUrl) return false;
      var url = new URL(imageUrl.startsWith('//') ? "https:".concat(imageUrl) : imageUrl);
      return imageWidths.map(function (width) {
        url.searchParams.set('width', width);
        return "".concat(url.toString(), " ").concat(width, "w");
      }).join(', ');
    },
    imgAttributes: function imgAttributes(config) {
      var _ref2;
      return _ref2 = {
        "class": config.cover ? 'h-full object-cover' : 'h-full object-contain',
        loading: config.isLazy ? 'lazy' : 'eager'
      }, (0,defineProperty/* default */.Z)(_ref2, 'x-bind:srcset', function xBindSrcset() {
        return this.srcset;
      }), (0,defineProperty/* default */.Z)(_ref2, 'x-bind:src', function xBindSrc() {
        return imageUrl;
      }), (0,defineProperty/* default */.Z)(_ref2, "alt", config.alt || ''), _ref2;
    }
  };
});
;// CONCATENATED MODULE: ./src/js/bundles/sections/header.js
// Sticky Header
function stickyHeader() {
  document.addEventListener('DOMContentLoaded', function () {
    var headerSection = document.getElementById('shopify-section-header');
    if (headerSection) {
      var headerHeight = headerSection.getBoundingClientRect().bottom;
      document.body.style.setProperty('--header-height', "".concat(headerHeight, "px"));
      window.addEventListener('resize', function () {
        headerHeight = headerSection.getBoundingClientRect().bottom;
        document.body.style.setProperty('--header-height', "".concat(headerHeight, "px"));
      });
      if (window.stickyHeaderEnabled) {
        document.body.classList.add('header-is-sticky');
        headerSection.classList.add('sticky', 'top-0', 'z-30', 'shadow-sm');
        var lastScrollTop = 0;
        var scrollOffset = 150;
        window.addEventListener('scroll', function () {
          var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
          var stickyHeaderHeight = headerSection.getBoundingClientRect().bottom;
          if (currentScroll > 0) {
            document.body.classList.add('is-scrolled');
          } else {
            document.body.classList.remove('is-scrolled');
            stickyHeaderHeight = headerHeight;
          }
          if (currentScroll > scrollOffset) {
            document.body.classList.add('is-scrolled-offset');
          } else {
            document.body.classList.remove('is-scrolled-offset');
          }
          if (currentScroll > lastScrollTop) {
            document.body.classList.remove('is-scrolling-up');
            if (currentScroll > scrollOffset) stickyHeaderHeight = 0;
          } else {
            document.body.classList.add('is-scrolling-up');
          }
          lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
          document.body.style.setProperty('--header-height', "".concat(stickyHeaderHeight, "px"));
        });
      }
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(982);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(168);
;// CONCATENATED MODULE: ./src/js/utils/helpers.js
function debouncePromise(fn, time) {
  var timerId = undefined;
  return function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timerId) {
      clearTimeout(timerId);
    }
    return new Promise(function (resolve) {
      timerId = setTimeout(function () {
        return resolve(fn.apply(void 0, args));
      }, time);
    });
  };
}
function evaluateScreenSize() {
  window.isMobile = window.innerWidth <= 1023;
  function handleResize() {
    window.isMobile = window.innerWidth <= 1023;
  }
  window.addEventListener('resize', handleResize);
}
;// CONCATENATED MODULE: ./src/js/bundles/snippets/algolia-search.js





var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36;

function algolia_search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function algolia_search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? algolia_search_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : algolia_search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable */


function triggerAutoCompleteHooksCustomEvent(eventName) {
  var event = new Event(eventName);
  window.dispatchEvent(event);
}

// Helper function to get theme settings
function getThemeSettings() {
  try {
    var themeSettingsScript = document.querySelector('script[json-script="theme-settings"]');
    if (themeSettingsScript) {
      return JSON.parse(themeSettingsScript.textContent);
    }
  } catch (error) {
    console.warn('Could not parse theme settings:', error);
  }
  return {
    enablePlpCompare: true,
    enablePdpCompare: true
  }; // Default fallback
}

var algoliaHandler = function algoliaHandler() {
  return {
    init: function init() {
      this.algoliaAutocompleteEnhance();
      this.algoliaInstantSearchEnhance();
    },
    algoliaAutocompleteEnhance: function algoliaAutocompleteEnhance() {
      document.addEventListener('DOMContentLoaded', function () {
        // Reset Algolia Search input on cancel button click in Mobile Search drawer.
        var autocompleteInput = document.getElementById('algolia-autocomplete-input-id');
        if (autocompleteInput) {
          var listenerAdded = false;
          autocompleteInput.addEventListener('click', function (event) {
            if (!listenerAdded) {
              if (event.target.matches('.aa-DetachedSearchButton') || event.target.closest('.aa-DetachedSearchButton')) {
                var detachedContainer = document.querySelector('.aa-DetachedContainer');
                var cancelButton = document.querySelector('.aa-DetachedFormContainer .aa-DetachedCancelButton');
                var SearchInputForm = document.querySelector('.aa-DetachedFormContainer .aa-Form');
                if (detachedContainer && SearchInputForm) {
                  setTimeout(function () {
                    triggerAutoCompleteHooksCustomEvent('append-suggestions-mobile');
                  }, 0);
                }
                if (cancelButton && SearchInputForm) {
                  cancelButton.addEventListener('click', function () {
                    SearchInputForm.reset();
                    listenerAdded = true;
                  });
                }
              }
            }
          });
        }
      });

      // Detect Algolia Mobile Search drawer is opened or closed to disable body scroll handling for iPhones

      var wasDetached = document.body.classList.contains('aa-Detached');
      function updateOverflow() {
        var isDetached = document.body.classList.contains('aa-Detached');
        if (isDetached && !wasDetached) {
          disableScrollForInputDrawer();
        } else if (!isDetached && wasDetached) {
          enableScrollForInputDrawer();
        }
        wasDetached = isDetached; // Update the previous state
      }

      var observer = new MutationObserver(function (mutations) {
        // MutationObserver to monitor changes to the body class
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class') {
            updateOverflow();
          }
        });
      });
      observer.observe(document.body, {
        attributes: true
      }); // Start observing the body element for attribute changes

      // Accessibility Fix: Add aria-label="Search" to Algolia input
      var addAriaLabelToInput = function addAriaLabelToInput() {
        var input = document.querySelector('.aa-Input');
        if (input && !input.hasAttribute('aria-label')) {
          input.setAttribute('aria-label', 'Search');
          return true;
        }
        return false;
      };

      // Accessibility Fix: Update aria-label="Submit" to aria-label="Search" for Algolia submit button
      var updateAriaLabelOnSubmitButton = function updateAriaLabelOnSubmitButton() {
        var label = document.querySelector('.aa-InputWrapperPrefix .aa-Label');
        if (label && label.getAttribute('aria-label') === 'Submit') {
          label.setAttribute('aria-label', 'Search');
          return true;
        }
        return false;
      };

      // Utility: Run both fixes together
      var fixAlgoliaAriaLabels = function fixAlgoliaAriaLabels() {
        var inputFixed = addAriaLabelToInput();
        var labelFixed = updateAriaLabelOnSubmitButton();
        return inputFixed || labelFixed;
      };

      // Try immediately
      fixAlgoliaAriaLabels();

      // MutationObserver to handle dynamically added elements
      var inputLabelObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                var _node$classList, _node$classList2;
                // 1. Set aria-label="Search" on .aa-Input if missing
                var input = (_node$classList = node.classList) !== null && _node$classList !== void 0 && _node$classList.contains('aa-Input') ? node : node.querySelector('.aa-Input');
                if (input && !input.hasAttribute('aria-label')) {
                  input.setAttribute('aria-label', 'Search');
                }

                // 2. Update aria-label="Submit" to "Search" on .aa-Label (submit button wrapper)
                var label = (_node$classList2 = node.classList) !== null && _node$classList2 !== void 0 && _node$classList2.contains('aa-Label') ? node : node.querySelector('.aa-Label');
                if (label && label.getAttribute('aria-label') === 'Submit') {
                  label.setAttribute('aria-label', 'Search');
                }
              }
            });
          }
        });
      });
      inputLabelObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Fallback: Check periodically for the first few seconds
      var attempts = 0;
      var maxAttempts = 10;
      var fallbackInterval = setInterval(function () {
        attempts++;
        if (fixAlgoliaAriaLabels() || attempts >= maxAttempts) {
          clearInterval(fallbackInterval);
        }
      }, 100);

      // Also try when Algolia hooks initialize
      document.addEventListener('algolia.hooks.initialize', function () {
        setTimeout(fixAlgoliaAriaLabels, 0);
      });

      // Algolia Search Autocomplete custom hooks
      document.addEventListener('algolia.hooks.initialize', function () {
        // Add debounce delay to the Algolia search query for Products, Collections, Articles, and Pages.
        algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
          var searchQueryDelay = 1000;
          if (Array.isArray(options.plugins) && options.plugins.length > 0) {
            var _loop = function _loop() {
              if (typeof options.plugins[i].getSources === 'function') {
                var originalGetSources = options.plugins[i].getSources;
                var debouncedGetSourcesFunction = debouncePromise(function () {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }
                  return originalGetSources.apply(this, args);
                }, searchQueryDelay);
                options.plugins[i].getSources = function () {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }
                  return debouncedGetSourcesFunction.apply(this, args);
                };
              }
            };
            for (var i = 0; i <= Math.min(3, options.plugins.length); i++) {
              _loop();
            }
          }
          return options;
        });

        // Main Search Panel Customization.
        algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;
          return html(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div id=\"algolia-autocomplete-panel\" class=\"aa-PanelLayout aa-Panel--scrollable\">\n              <div class=\"aa-PanelSections\">\n                <div class=\"aa-PanelSection--left\">\n                  ", "\n                  <div class=\"aa-SourceHeader aa-RelatedListings\">\n                    <span class=\"aa-SourceHeaderTitle\">Related</span>\n                  </div>\n                  ", "", "", "", "\n                </div>\n                <div class=\"aa-PanelSection--right\">\n                  ", "\n                  ", "\n                </div>\n              </div>\n            </div>\n          "])), displaySuggestions && html(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-SourceHeader\">\n                      <span class=\"aa-SourceHeaderTitle\">", "</span>\n                      <div class=\"aa-SourceHeaderLine\"></div>\n                    </div>\n                    ", "\n                  "])), algoliaShopify.translations.suggestions, elements.querySuggestionsPlugin), elements.collections, elements.articles, elements.pages, elements.redirectUrlPlugin, elements.products, html(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-ViewAllBtnWrapper\">\n                      <a href=\"/search?q=", "\" class=\"component-btn aa-ViewAllBtn\">VIEW ALL SEARCH RESULTS</a>\n                    </div>\n                  "])), state.query));
        });

        // Main Products template - this comes when there are no other results except products and beforeAutocompleteMainTemplate doesn't work.
        algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function (_defaultTemplate, templateOptions, elements) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;
          return html(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div id=\"algolia-autocomplete-panel\" class=\"aa-PanelLayout aa-Panel--scrollable\">\n              <div class=\"aa-PanelSection\">\n                ", "\n                ", "\n              </div>\n            </div>\n          "])), elements.products, html(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <div class=\"aa-ViewAllBtnWrapper\">\n                    <a href=\"/search?q=", "\" class=\"component-btn aa-ViewAllBtn\">VIEW ALL SEARCH RESULTS</a>\n                  </div>\n                "])), state.query));
        });

        // Main Search Panel - No results
        algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function (_defaultTemplate, templateOptions) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;
          return html(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div id=\"algolia-autocomplete-panel\" class=\"aa-PanelLayout aa-Panel--scrollable\">\n              <p class=\"aa-NoResultsHeader\">", "</p>\n              <a class=\"aa-NoResultsLink\" href=\"", "search?q=\">\n                ", "\n              </a>\n            </div>\n          "])), algoliaShopify.translation_helpers.no_result_for(state.query), window.Shopify.routes.root, algoliaShopify.translations.allProducts);
        });

        // Set and remove title for Products, Pages and Articles sections.
        algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function (_defaultTemplate, templateOptions, resource) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;
          var customHtml = '';
          if (resource === 'Products') {
            customHtml = html(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["<span class=\"aa-SourceHeaderTitle aa-ProductsListTitle\">Top Products</span>"])));
          } else if (resource === 'Pages' || resource === 'Articles') {
            customHtml = '';
          } else {
            return _defaultTemplate;
          }
          return customHtml;
        });

        // Single Product Customization.
        algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function (_defaultTemplate, templateOptions, distinct, itemLink) {
          var _item$body_html_safe, _item$meta, _item$meta$okendo, _item$meta$okendo$Sta, _item$meta2, _item$meta2$okendo;
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            item = templateOptions.item,
            components = templateOptions.components;
          var productId = item.id;
          var productDescription = (_item$body_html_safe = item.body_html_safe) === null || _item$body_html_safe === void 0 ? void 0 : _item$body_html_safe.replace(/&amp;/g, '&');
          var isXlScreen = window.innerWidth <= 1279;
          var okendoReviewSnippet = isXlScreen ? (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : (_item$meta$okendo = _item$meta.okendo) === null || _item$meta$okendo === void 0 ? void 0 : (_item$meta$okendo$Sta = _item$meta$okendo.StarRatingSnippet) === null || _item$meta$okendo$Sta === void 0 ? void 0 : _item$meta$okendo$Sta.replace(/<span class="oke-sr-total-text">\s*\((\d+)\s*Review(s?)\)\s*<\/span>/, '<span class="oke-sr-total-text"> ($1)</span>') : (_item$meta2 = item.meta) === null || _item$meta2 === void 0 ? void 0 : (_item$meta2$okendo = _item$meta2.okendo) === null || _item$meta2$okendo === void 0 ? void 0 : _item$meta2$okendo.StarRatingSnippet;
          return html(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <a href=\"", "\" class=\"aa-ItemLink aa-ProductItem\">\n              <div class=\"aa-ItemContent\">\n                <div class=\"aa-ItemPicture aa-ItemPicture--loaded\">\n                  <img src=\"", "\" alt=\"", "\" />\n                </div>\n                <div class=\"aa-ItemContentBody\">\n                  ", "\n                  <div class=\"aa-ItemContentTitleWrapper\">\n                    <div class=\"aa-ItemContentTitle\">\n                      ", "\n                      <span class=\"algolia-variant\">\n                        ", "\n                      </span>\n                    </div>\n                  </div>\n                  ", "\n                </div>\n                <div class=\"aa-ItemContentPrice\">\n                  <div class=\"aa-ItemContentPriceCurrent\">", "</div>\n                </div>\n              </div>\n            </a>\n          "])), itemLink, algoliaShopify.helpers.largeImage(item), item.title, productId && okendoReviewSnippet && html(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-ItemReview oke-medium-size\">\n                      <div data-oke-star-rating data-oke-reviews-product-id=\"shopify-", "\">\n                        ", "\n                      </div>\n                    </div>\n                  "])), productId, html([okendoReviewSnippet])), components.Highlight({
            hit: item,
            attribute: 'title'
          }), algoliaShopify.helpers.variantTitleAddition(item, distinct), productDescription && html(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-ItemDescription\">\n                      ", "\n                    </div>\n                  "])), function () {
            return productDescription.length > 70 ? productDescription.substring(0, 67) + '...' : productDescription;
          }()), algoliaShopify.helpers.displayPrice(item, distinct));
        });
      });
    },
    algoliaInstantSearchEnhance: function algoliaInstantSearchEnhance() {
      var body = document.body;

      // ✅ Enhance all filter labels (Menu + Price RefinementList)
      function enhanceAlgoliaMenuFacets() {
        // 1️⃣ Enhance "Filter by Form" style filters
        document.querySelectorAll('.ais-Menu-label').forEach(function (label) {
          var _label$querySelector;
          if (label.hasAttribute('tabindex')) {
            return; // Skip if already enhanced
          }

          var icon = label.querySelector('.ais-facet--custom-icon');
          var count = (_label$querySelector = label.querySelector('.ais-Menu-count')) === null || _label$querySelector === void 0 ? void 0 : _label$querySelector.textContent.trim();
          var labelText = label.textContent.trim().replace(/\s+\d+$/, '');
          var isChecked = (icon === null || icon === void 0 ? void 0 : icon.querySelector('span:not(.hidden)')) !== null;
          label.setAttribute('role', 'checkbox');
          label.setAttribute('tabindex', '0');
          label.setAttribute('aria-checked', isChecked ? 'true' : 'false');
          label.setAttribute('aria-label', "Filter by ".concat(labelText).concat(count ? " (".concat(count, " items)") : ''));
          label.addEventListener('keydown', function (e) {
            if (e.key === 'Space' || e.key === ' ') {
              e.preventDefault();
              label.click();
            }
          });
        });
      }
      function enhanceFacetToggleHeaders() {
        document.querySelectorAll('.ais-facet--header').forEach(function (label) {
          if (label.hasAttribute('tabindex')) {
            return; // Already enhanced
          }

          var forId = label.getAttribute('for');
          var input = forId && document.getElementById(forId);
          var labelText = label.textContent.trim().replace(/\s+/g, ' ');
          var isExpanded = input === null || input === void 0 ? void 0 : input.checked;
          label.setAttribute('tabindex', '0');
          label.setAttribute('role', 'button');
          label.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          label.setAttribute('aria-controls', "".concat(forId, "-container"));
          label.setAttribute('aria-label', "".concat(labelText, " filter toggle"));
          label.addEventListener('keydown', function (e) {
            if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
              e.preventDefault();
              label.click();
              // Wait a bit and then reflect the updated aria-expanded value
              setTimeout(function () {
                var refreshedInput = forId && document.getElementById(forId);
                label.setAttribute('aria-expanded', refreshedInput !== null && refreshedInput !== void 0 && refreshedInput.checked ? 'true' : 'false');
              }, 100);
            }
          });

          // Optionally mark the container with matching ID for accessibility
          var container = document.querySelector("#".concat(forId, " ~ .ais-facet-dropdown-container"));
          if (container) {
            container.setAttribute('id', "".concat(forId, "-container"));
          }
        });
      }
      function enhanceAlgoliaPriceFilters() {
        document.querySelectorAll('.ais-RefinementList-label').forEach(function (label) {
          var _label$querySelector2, _label$childNodes$;
          var input = label.querySelector('input[type="checkbox"]');
          var count = (_label$querySelector2 = label.querySelector('.ais-RefinementList-count')) === null || _label$querySelector2 === void 0 ? void 0 : _label$querySelector2.textContent.trim();
          var labelText = (_label$childNodes$ = label.childNodes[2]) === null || _label$childNodes$ === void 0 ? void 0 : _label$childNodes$.textContent.trim();
          label.setAttribute('role', 'checkbox');
          label.setAttribute('tabindex', '0');
          label.setAttribute('aria-label', "Filter by price: ".concat(labelText).concat(count ? " (".concat(count, " items)") : ''));
          label.setAttribute('aria-checked', input !== null && input !== void 0 && input.checked ? 'true' : 'false');

          // ✅ Add Enter/Space keydown support
          label.addEventListener('keydown', function (e) {
            if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
              e.preventDefault();
              e.stopPropagation();

              // ✅ Only trigger click on the label itself (NOT input)
              label.click();

              // ✅ Let Algolia re-render, then reapply aria-checked
              setTimeout(function () {
                var refreshedInput = label.querySelector('input[type="checkbox"]');
                if (refreshedInput) {
                  label.setAttribute('aria-checked', refreshedInput.checked ? 'true' : 'false');
                }
              }, 200);
            }
          });
        });
      }

      // ✅ Enhance selected filters (refinements)
      function enhanceSelectedFiltersAccessibility() {
        document.querySelectorAll('.ais-current-refined-values--link').forEach(function (link) {
          if (link.hasAttribute('tabindex')) {
            return; // Skip if already enhanced
          }

          link.setAttribute('role', 'button');
          link.setAttribute('tabindex', '0');
          var labelEl = link.querySelector('.ais-current-refined-values--label');
          var valueText = link.textContent.trim().replace(/\s+/g, ' ').replace(':', '').trim();
          link.setAttribute('aria-label', "Remove filter: ".concat(valueText));
          link.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              link.click();
            }
          });
        });
      }

      // 🔁 Observe DOM updates
      function startObservingFacets() {
        var observer = new MutationObserver(function () {
          enhanceAlgoliaMenuFacets();
          enhanceFacetToggleHeaders();
          enhanceAlgoliaPriceFilters();
          enhanceSelectedFiltersAccessibility();
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      // Helper function to extract text from rich text metafield objects
      function extractTextFromRichText(richTextData) {
        if (!richTextData) return '';
        var richTextObj = richTextData;

        // If it's a string, try to parse it as JSON
        if (typeof richTextData === 'string') {
          try {
            richTextObj = JSON.parse(richTextData);
          } catch (e) {
            return richTextData; // If parsing fails, return the string as-is
          }
        }

        // If it's not an object after parsing, return empty
        if (!richTextObj || (0,esm_typeof/* default */.Z)(richTextObj) !== 'object') return '';
        var text = '';
        function traverse(node) {
          if (node.type === 'text') {
            text += node.value || '';
          } else if (node.children && Array.isArray(node.children)) {
            node.children.forEach(traverse);
          }
        }
        traverse(richTextObj);
        return text.trim();
      }
      function aisQuickBuyModal(event) {
        var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        event.stopPropagation();
        event.preventDefault();
        if (handle && Alpine.store('quickBuyModal')) {
          Alpine.store('quickBuyModal').loadModal(handle, event);
        } else {
          alert("Sorry, we couldn't load the Quick Buy feature");
        }
      }
      function aisToggleCompareFromCheckbox(event) {
        event.stopPropagation();
        var checkbox = event.target;
        var compareComponent = window.plpCompareComponent;
        if (!compareComponent) {
          console.warn('Compare component not available');
          return;
        }
        var productData = {
          id: parseInt(checkbox.dataset.productId),
          title: checkbox.dataset.productTitle,
          image: checkbox.dataset.productImage,
          url: checkbox.dataset.productUrl,
          price: checkbox.dataset.productPrice,
          priceMin: checkbox.dataset.productPriceMin,
          priceMax: checkbox.dataset.productPriceMax,
          variantsCount: parseInt(checkbox.dataset.productVariantsCount) || 1,
          handle: checkbox.dataset.productHandle,
          form: checkbox.dataset.productForm,
          suggestedUse: checkbox.dataset.productSuggestedUse,
          supplyPerBottle: checkbox.dataset.productSupplyPerBottle,
          keyIngredients: checkbox.dataset.productKeyIngredients,
          certifications: checkbox.dataset.productCertifications,
          allergenInfo: checkbox.dataset.productAllergenInfo,
          pricePerServing: checkbox.dataset.productPricePerServing,
          benefits: checkbox.dataset.productBenefits,
          starRating: checkbox.dataset.productStarRating,
          reviewCount: parseInt(checkbox.dataset.productReviewCount) || 0
        };
        compareComponent.toggleProduct(productData);
      }
      function aisToggleCompare(event, hit) {
        var _hit$meta, _hit$meta$custom, _hit$meta$custom$comp, _hit$meta2, _hit$meta2$custom, _hit$metafields, _hit$metafields$custo, _hit$metafields$custo2, _hit$meta3, _hit$meta3$custom, _hit$meta3$custom$com, _hit$meta4, _hit$meta4$custom, _hit$metafields2, _hit$metafields2$cust, _hit$metafields2$cust2, _hit$meta5, _hit$meta5$custom, _hit$meta5$custom$com, _hit$meta6, _hit$meta6$custom, _hit$metafields3, _hit$metafields3$cust, _hit$metafields3$cust2, _hit$meta7, _hit$meta7$custom, _hit$meta7$custom$com, _hit$meta8, _hit$meta8$custom, _hit$metafields4, _hit$metafields4$cust, _hit$metafields4$cust2, _hit$meta9, _hit$meta9$custom, _hit$meta9$custom$com, _hit$meta10, _hit$meta10$custom, _hit$metafields5, _hit$metafields5$cust, _hit$metafields5$cust2, _hit$meta11, _hit$meta11$custom, _hit$meta11$custom$co, _hit$meta12, _hit$meta12$custom, _hit$metafields6, _hit$metafields6$cust, _hit$metafields6$cust2, _hit$meta13, _hit$meta13$custom, _hit$meta13$custom$co, _hit$meta14, _hit$meta14$custom, _hit$metafields7, _hit$metafields7$cust, _hit$metafields7$cust2, _hit$meta15, _hit$meta15$custom, _hit$meta15$custom$co, _hit$meta16, _hit$meta16$custom, _hit$metafields8, _hit$metafields8$cust, _hit$metafields8$cust2, _hit$meta17, _hit$meta17$okendo, _hit$meta17$okendo$St, _hit$meta18, _hit$meta18$okendo, _hit$metafields9, _hit$metafields9$oken, _hit$metafields9$oken2, _hit$meta19, _hit$meta19$okendo, _hit$meta19$okendo$su, _hit$metafields10, _hit$metafields10$oke, _hit$metafields10$oke2;
        event.stopPropagation();
        event.preventDefault();

        // Find the PLP compare component instance
        var compareComponent = window.plpCompareComponent;
        if (!compareComponent) {
          console.warn('Compare component not available');
          return;
        }
        var productData = {
          id: hit.id,
          title: hit.title,
          image: algoliaShopify.helpers.largeImage(hit),
          url: algoliaShopify.helpers.instantsearchLink(hit),
          price: algoliaShopify.helpers.displayPrice(hit, hit._distinct),
          priceMin: hit.price_min ? algoliaShopify.helpers.formatMoney(hit.price_min) : '',
          priceMax: hit.price_max ? algoliaShopify.helpers.formatMoney(hit.price_max) : '',
          variantsCount: hit.variants ? hit.variants.length : 1,
          handle: hit.handle,
          // Try different possible paths for metafield data
          form: ((_hit$meta = hit.meta) === null || _hit$meta === void 0 ? void 0 : (_hit$meta$custom = _hit$meta.custom) === null || _hit$meta$custom === void 0 ? void 0 : (_hit$meta$custom$comp = _hit$meta$custom.compare_product_form) === null || _hit$meta$custom$comp === void 0 ? void 0 : _hit$meta$custom$comp.value) || ((_hit$meta2 = hit.meta) === null || _hit$meta2 === void 0 ? void 0 : (_hit$meta2$custom = _hit$meta2.custom) === null || _hit$meta2$custom === void 0 ? void 0 : _hit$meta2$custom.compare_product_form) || ((_hit$metafields = hit.metafields) === null || _hit$metafields === void 0 ? void 0 : (_hit$metafields$custo = _hit$metafields.custom) === null || _hit$metafields$custo === void 0 ? void 0 : (_hit$metafields$custo2 = _hit$metafields$custo.compare_product_form) === null || _hit$metafields$custo2 === void 0 ? void 0 : _hit$metafields$custo2.value) || 'N/A',
          suggestedUse: ((_hit$meta3 = hit.meta) === null || _hit$meta3 === void 0 ? void 0 : (_hit$meta3$custom = _hit$meta3.custom) === null || _hit$meta3$custom === void 0 ? void 0 : (_hit$meta3$custom$com = _hit$meta3$custom.compare_product_suggested_use) === null || _hit$meta3$custom$com === void 0 ? void 0 : _hit$meta3$custom$com.value) || ((_hit$meta4 = hit.meta) === null || _hit$meta4 === void 0 ? void 0 : (_hit$meta4$custom = _hit$meta4.custom) === null || _hit$meta4$custom === void 0 ? void 0 : _hit$meta4$custom.compare_product_suggested_use) || ((_hit$metafields2 = hit.metafields) === null || _hit$metafields2 === void 0 ? void 0 : (_hit$metafields2$cust = _hit$metafields2.custom) === null || _hit$metafields2$cust === void 0 ? void 0 : (_hit$metafields2$cust2 = _hit$metafields2$cust.compare_product_suggested_use) === null || _hit$metafields2$cust2 === void 0 ? void 0 : _hit$metafields2$cust2.value) || 'N/A',
          supplyPerBottle: ((_hit$meta5 = hit.meta) === null || _hit$meta5 === void 0 ? void 0 : (_hit$meta5$custom = _hit$meta5.custom) === null || _hit$meta5$custom === void 0 ? void 0 : (_hit$meta5$custom$com = _hit$meta5$custom.compare_product_supply_per_bottle) === null || _hit$meta5$custom$com === void 0 ? void 0 : _hit$meta5$custom$com.value) || ((_hit$meta6 = hit.meta) === null || _hit$meta6 === void 0 ? void 0 : (_hit$meta6$custom = _hit$meta6.custom) === null || _hit$meta6$custom === void 0 ? void 0 : _hit$meta6$custom.compare_product_supply_per_bottle) || ((_hit$metafields3 = hit.metafields) === null || _hit$metafields3 === void 0 ? void 0 : (_hit$metafields3$cust = _hit$metafields3.custom) === null || _hit$metafields3$cust === void 0 ? void 0 : (_hit$metafields3$cust2 = _hit$metafields3$cust.compare_product_supply_per_bottle) === null || _hit$metafields3$cust2 === void 0 ? void 0 : _hit$metafields3$cust2.value) || 'N/A',
          keyIngredients: ((_hit$meta7 = hit.meta) === null || _hit$meta7 === void 0 ? void 0 : (_hit$meta7$custom = _hit$meta7.custom) === null || _hit$meta7$custom === void 0 ? void 0 : (_hit$meta7$custom$com = _hit$meta7$custom.compare_product_key_ingredients) === null || _hit$meta7$custom$com === void 0 ? void 0 : _hit$meta7$custom$com.value) || ((_hit$meta8 = hit.meta) === null || _hit$meta8 === void 0 ? void 0 : (_hit$meta8$custom = _hit$meta8.custom) === null || _hit$meta8$custom === void 0 ? void 0 : _hit$meta8$custom.compare_product_key_ingredients) || ((_hit$metafields4 = hit.metafields) === null || _hit$metafields4 === void 0 ? void 0 : (_hit$metafields4$cust = _hit$metafields4.custom) === null || _hit$metafields4$cust === void 0 ? void 0 : (_hit$metafields4$cust2 = _hit$metafields4$cust.compare_product_key_ingredients) === null || _hit$metafields4$cust2 === void 0 ? void 0 : _hit$metafields4$cust2.value) || 'N/A',
          certifications: ((_hit$meta9 = hit.meta) === null || _hit$meta9 === void 0 ? void 0 : (_hit$meta9$custom = _hit$meta9.custom) === null || _hit$meta9$custom === void 0 ? void 0 : (_hit$meta9$custom$com = _hit$meta9$custom.compare_product_certifications) === null || _hit$meta9$custom$com === void 0 ? void 0 : _hit$meta9$custom$com.value) || ((_hit$meta10 = hit.meta) === null || _hit$meta10 === void 0 ? void 0 : (_hit$meta10$custom = _hit$meta10.custom) === null || _hit$meta10$custom === void 0 ? void 0 : _hit$meta10$custom.compare_product_certifications) || ((_hit$metafields5 = hit.metafields) === null || _hit$metafields5 === void 0 ? void 0 : (_hit$metafields5$cust = _hit$metafields5.custom) === null || _hit$metafields5$cust === void 0 ? void 0 : (_hit$metafields5$cust2 = _hit$metafields5$cust.compare_product_certifications) === null || _hit$metafields5$cust2 === void 0 ? void 0 : _hit$metafields5$cust2.value) || 'N/A',
          allergenInfo: ((_hit$meta11 = hit.meta) === null || _hit$meta11 === void 0 ? void 0 : (_hit$meta11$custom = _hit$meta11.custom) === null || _hit$meta11$custom === void 0 ? void 0 : (_hit$meta11$custom$co = _hit$meta11$custom.compare_product_allergen_info) === null || _hit$meta11$custom$co === void 0 ? void 0 : _hit$meta11$custom$co.value) || ((_hit$meta12 = hit.meta) === null || _hit$meta12 === void 0 ? void 0 : (_hit$meta12$custom = _hit$meta12.custom) === null || _hit$meta12$custom === void 0 ? void 0 : _hit$meta12$custom.compare_product_allergen_info) || ((_hit$metafields6 = hit.metafields) === null || _hit$metafields6 === void 0 ? void 0 : (_hit$metafields6$cust = _hit$metafields6.custom) === null || _hit$metafields6$cust === void 0 ? void 0 : (_hit$metafields6$cust2 = _hit$metafields6$cust.compare_product_allergen_info) === null || _hit$metafields6$cust2 === void 0 ? void 0 : _hit$metafields6$cust2.value) || 'N/A',
          pricePerServing: ((_hit$meta13 = hit.meta) === null || _hit$meta13 === void 0 ? void 0 : (_hit$meta13$custom = _hit$meta13.custom) === null || _hit$meta13$custom === void 0 ? void 0 : (_hit$meta13$custom$co = _hit$meta13$custom.compare_product_price_per_serving) === null || _hit$meta13$custom$co === void 0 ? void 0 : _hit$meta13$custom$co.value) || ((_hit$meta14 = hit.meta) === null || _hit$meta14 === void 0 ? void 0 : (_hit$meta14$custom = _hit$meta14.custom) === null || _hit$meta14$custom === void 0 ? void 0 : _hit$meta14$custom.compare_product_price_per_serving) || ((_hit$metafields7 = hit.metafields) === null || _hit$metafields7 === void 0 ? void 0 : (_hit$metafields7$cust = _hit$metafields7.custom) === null || _hit$metafields7$cust === void 0 ? void 0 : (_hit$metafields7$cust2 = _hit$metafields7$cust.compare_product_price_per_serving) === null || _hit$metafields7$cust2 === void 0 ? void 0 : _hit$metafields7$cust2.value) || 'N/A',
          benefits: extractTextFromRichText(((_hit$meta15 = hit.meta) === null || _hit$meta15 === void 0 ? void 0 : (_hit$meta15$custom = _hit$meta15.custom) === null || _hit$meta15$custom === void 0 ? void 0 : (_hit$meta15$custom$co = _hit$meta15$custom.compare_product_benefits) === null || _hit$meta15$custom$co === void 0 ? void 0 : _hit$meta15$custom$co.value) || ((_hit$meta16 = hit.meta) === null || _hit$meta16 === void 0 ? void 0 : (_hit$meta16$custom = _hit$meta16.custom) === null || _hit$meta16$custom === void 0 ? void 0 : _hit$meta16$custom.compare_product_benefits) || ((_hit$metafields8 = hit.metafields) === null || _hit$metafields8 === void 0 ? void 0 : (_hit$metafields8$cust = _hit$metafields8.custom) === null || _hit$metafields8$cust === void 0 ? void 0 : (_hit$metafields8$cust2 = _hit$metafields8$cust.compare_product_benefits) === null || _hit$metafields8$cust2 === void 0 ? void 0 : _hit$metafields8$cust2.value)) || 'N/A',
          starRating: ((_hit$meta17 = hit.meta) === null || _hit$meta17 === void 0 ? void 0 : (_hit$meta17$okendo = _hit$meta17.okendo) === null || _hit$meta17$okendo === void 0 ? void 0 : (_hit$meta17$okendo$St = _hit$meta17$okendo.StarRatingSnippet) === null || _hit$meta17$okendo$St === void 0 ? void 0 : _hit$meta17$okendo$St.value) || ((_hit$meta18 = hit.meta) === null || _hit$meta18 === void 0 ? void 0 : (_hit$meta18$okendo = _hit$meta18.okendo) === null || _hit$meta18$okendo === void 0 ? void 0 : _hit$meta18$okendo.StarRatingSnippet) || ((_hit$metafields9 = hit.metafields) === null || _hit$metafields9 === void 0 ? void 0 : (_hit$metafields9$oken = _hit$metafields9.okendo) === null || _hit$metafields9$oken === void 0 ? void 0 : (_hit$metafields9$oken2 = _hit$metafields9$oken.StarRatingSnippet) === null || _hit$metafields9$oken2 === void 0 ? void 0 : _hit$metafields9$oken2.value) || '',
          reviewCount: ((_hit$meta19 = hit.meta) === null || _hit$meta19 === void 0 ? void 0 : (_hit$meta19$okendo = _hit$meta19.okendo) === null || _hit$meta19$okendo === void 0 ? void 0 : (_hit$meta19$okendo$su = _hit$meta19$okendo.summaryData) === null || _hit$meta19$okendo$su === void 0 ? void 0 : _hit$meta19$okendo$su.reviewCount) || ((_hit$metafields10 = hit.metafields) === null || _hit$metafields10 === void 0 ? void 0 : (_hit$metafields10$oke = _hit$metafields10.okendo) === null || _hit$metafields10$oke === void 0 ? void 0 : (_hit$metafields10$oke2 = _hit$metafields10$oke.summaryData) === null || _hit$metafields10$oke2 === void 0 ? void 0 : _hit$metafields10$oke2.reviewCount) || 0
        };
        compareComponent.toggleProduct(productData);
      }
      function aisOpenFacetsDrawer(event) {
        event.preventDefault();
        body.classList.add('scroll-lock');
        body.classList.add('ais-show-facets-drawer');
        disableScrollForInputDrawer();
      }
      function aisCloseFacetsDrawer(event) {
        event.preventDefault();
        body.classList.remove('scroll-lock');
        body.classList.remove('ais-show-facets-drawer');
        enableScrollForInputDrawer();
      }
      document.addEventListener('algolia.instantSearch.onRender', function () {
        enhanceAlgoliaMenuFacets();
        enhanceFacetToggleHeaders();
        enhanceSelectedFiltersAccessibility();
      });
      document.addEventListener('algolia.instantSearch.afterInit', function () {
        if (!window.collectionBannerConfig) return; // Only run when we have the collectionBannerConfig

        var instantSearchWrapper = document.getElementById('algolia-shopify-instantsearch');
        var hitsContainer = instantSearchWrapper === null || instantSearchWrapper === void 0 ? void 0 : instantSearchWrapper.querySelector('.ais-hits-container');
        if (hitsContainer) {
          var banner = document.createElement('li');
          banner.className = 'ais-Hits-collection-banner';
          banner.innerHTML = "\n          <div class=\"relative bg-cover bg-center h-full w-full\" style=\"".concat(window.collectionBannerConfig.background_image ? "background-image: url(".concat(window.collectionBannerConfig.background_image, ");") : 'background-color: #F7F2DB;', "\">\n            \n            <div class=\"collection-banner-content h-full flex flex-col justify-between gap-5 text-center\">\n              <div class=\"top-content\">\n                <h2 class=\"text-white font-serif text-lg lg:text-xl xl:text-3xl tracking-s-wide xl:mb-2\">\n                  ").concat(window.collectionBannerConfig.title, "\n                </h2>\n                <h3 class=\"text-white uppercase text-[8px] leading-3 lg:text-xxs xl:text-sm xl:font-bold tracking-x-widest\">\n                  ").concat(window.collectionBannerConfig.subtitle, "\n                </h3>\n              </div>\n              <div class=\"cta-wrapper\">\n                <a href=\"").concat(window.collectionBannerConfig.cta_link, "\" class=\"inline-block rounded-full uppercase tracking-x-widest text-white border-0\"\n                  style=\"background-color: ").concat(window.collectionBannerConfig.cta_background_color, "; color: ").concat(window.collectionBannerConfig.cta_color, ";\">\n                  ").concat(window.collectionBannerConfig.cta_title, "\n                </a>\n              </div>\n            </div>\n          </div>\n        ");
          var observer = new MutationObserver(function () {
            var hitsList = hitsContainer.querySelector('.ais-InfiniteHits-list');
            if (hitsList) {
              observer.disconnect();
              hitsList.classList.add('has-collection-banner');
              if (hitsList.firstChild) {
                hitsList.insertBefore(banner, hitsList.firstChild);
              } else {
                hitsList.appendChild(banner);
              }
            }
          });
          observer.observe(hitsContainer, {
            childList: true,
            subtree: true
          });
        }
      });
      document.addEventListener('algolia.hooks.initialize', function () {
        var _window$instantsearch, _window$instantsearch2;
        var infiniteHits = (_window$instantsearch = window.instantsearch) === null || _window$instantsearch === void 0 ? void 0 : (_window$instantsearch2 = _window$instantsearch.widgets) === null || _window$instantsearch2 === void 0 ? void 0 : _window$instantsearch2.infiniteHits;
        var isCollectionPage = window.location.pathname.includes('/collections/');
        if (infiniteHits) {
          // Remove ais.hits, ais.pagination and ais.searchBox widgets
          algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function (defaultWidgets) {
            var hitsWidget = defaultWidgets.find(function (widget) {
              return widget.$$widgetType === 'ais.hits';
            });
            var paginationWidget = defaultWidgets.find(function (widget) {
              return widget.$$widgetType === 'ais.pagination';
            });
            if (isCollectionPage) {
              var searchBoxWidget = defaultWidgets.find(function (widget) {
                return widget.$$widgetType === 'ais.searchBox';
              });
              return [hitsWidget, paginationWidget, searchBoxWidget];
            }
            return [hitsWidget, paginationWidget];
          });

          // Add infiniteHits widget
          algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
            var _window$algoliaShopif, _window$algoliaShopif2, _window$algoliaShopif3;
            var infiniteHitsWidget = infiniteHits({
              container: '.ais-hits-container',
              templates: {
                item: function item(hit, _ref) {
                  var html = _ref.html,
                    components = _ref.components;
                  return window.algoliaShopify.instantsearch.templates.instantSearchProductTemplate(hit, html, components, window.algoliaShopify);
                },
                empty: function empty(results, _ref2) {
                  var html = _ref2.html;
                  return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(html, window.algoliaShopify);
                },
                showMoreText: function showMoreText(data, _ref3) {
                  var html = _ref3.html;
                  return html(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["Load more"])));
                }
              },
              transformItems: function transformItems(items) {
                var transformedItems = items.map(function (item) {
                  return algolia_search_objectSpread(algolia_search_objectSpread({}, item), {}, {
                    _distinct: window.algoliaShopify.instantsearch.distinct,
                    can_order: item.inventory_policy === 'continue' || item.inventory_quantity > 0,
                    queryID: item.__queryID,
                    productPosition: item.__position,
                    index: window.algoliaShopify.instantsearch.search.mainIndex.getIndexName()
                  });
                });
                return transformedItems;
              }
            });
            var configure = (_window$algoliaShopif = window.algoliaShopify) === null || _window$algoliaShopif === void 0 ? void 0 : (_window$algoliaShopif2 = _window$algoliaShopif.externals) === null || _window$algoliaShopif2 === void 0 ? void 0 : (_window$algoliaShopif3 = _window$algoliaShopif2.widgets) === null || _window$algoliaShopif3 === void 0 ? void 0 : _window$algoliaShopif3.configure;
            if (configure) {
              var configureWidget = configure({
                facetingAfterDistinct: false // Set facetingAfterDistinct to false so that proper filters are available on sorting
              });

              return [infiniteHitsWidget, configureWidget];
            }
            return [infiniteHitsWidget];
          });
        }
        algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
          var isMdlargeScreen = window.innerWidth <= 799;
          return html(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n          <div class=\"ais-page\">\n            <h1 class=\"ais-h2\">Search Results</h1>\n            <div class=\"ais-input\">\n              <div class=\"ais-search-box-container\"></div>\n              <div class=\"ais-input-button\">\n                <div class=\"ais-clear-input-icon\"></div>\n              </div>\n            </div>\n            <div class=\"ais-facets-and-blocks\">\n              <div\n                class=\"ais-facets-backdrop fixed inset-0 z-40 hidden bg-p-forest/70\"\n                onClick=\"", "\"\n              ></div>\n              <div class=\"ais-facets\">\n                <div class=\"ais-facets--content\">\n                  <div class=\"ais-facets--title flex items-center justify-between\">\n                    Filters\n                    <button\n                      class=\"ais-facets-drawer-close hidden\"\n                      type=\"button\"\n                      onClick=\"", "\"\n                      aria-label=\"Close panel\"\n                    >\n                      <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M18 6L6 18\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M6 6L18 18\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </button>\n                  </div>\n                  ", "\n                  ", "\n                </div>\n              </div>\n              <div class=\"ais-block\">\n                <div class=\"ais-search-header hidden\">\n                  <div class=\"ais-change-display\">\n                    <span class=\"ais-change-display-block ais-change-display-selected\">\n                      <i class=\"fa fa-th-large\"></i>\n                    </span>\n                    <span class=\"ais-change-display-list\">\n                      <i class=\"fa fa-th-list\"></i>\n                    </span>\n                  </div>\n                </div>\n                <div class=\"ais-block-header\">\n                  <div class=\"ais-stats-container\"></div>\n                  <button\n                    class=\"ais-facets-drawer-button flex shrink-0 items-center gap-x-1 border-b border-p-forest pb-0.5 text-sm font-bold text-p-forest mdl:hidden\"\n                    type=\"button\"\n                    onClick=\"", "\"\n                  >\n                    <span>\n                      <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M5 15.625V11.25\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M5 8.75V4.375\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M10 15.625V10\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M10 7.5V4.375\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M15 15.625V12.5\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M15 10V4.375\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M3.125 11.25H6.875\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M8.125 7.5H11.875\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M13.125 12.5H16.875\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </span>\n                    Filter & Sort\n                  </button>\n                  <div class=\"ais-facets-button hidden\">Show filters</div>\n                  ", "\n                </div>\n                <div class=\"ais-refined-values-wrapper\">\n                  <div class=\"ais-current-refined-values-container scrollbar-hide overflow-x-auto\"></div>\n                  <div class=\"ais-clear-refinements-container\"></div>\n                </div>\n                <div class=\"ais-hits-container ais-results-as-block\"></div>\n              </div>\n            </div>\n            <div class=\"ais-pagination-container\"></div>\n          </div>\n        "])), function (event) {
            return aisCloseFacetsDrawer(event);
          }, function (event) {
            return aisCloseFacetsDrawer(event);
          }, isMdlargeScreen && html(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"ais-sort mdl:hidden\">\n                      ", "\n                    </div>\n                  "])), data.multipleSortOrders ? html(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n                            <span class=\"ais-sort-text\">Sort by</span>\n                            <span class=\"ais-sort-orders-container\"></span>\n                          "]))) : html(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)([" <span class=\"ais-sort-text\">Sorted by</span> ", " "])), algoliaShopify.translations.relevance)), data.facets.map(function (facet) {
            return html(_templateObject16 || (_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n                      <div class=\"ais-facet-dropdown-wrapper ais-facet-", " ais-facet-", "\">\n                        <input\n                          class=\"ais-dropdown-checkbox\"\n                          type=\"checkbox\"\n                          id=\"", "\"\n                          name=\"dropdown\"\n                        />\n                        <label\n                          for=\"", "\"\n                          class=\"ais-range-slider--header ais-facet--header ais-header select-none\"\n                        >\n                          ", "\n                          <span class=\"ais-facet--header-icon transition-transform duration-300\">\n                            <svg\n                              width=\"20\"\n                              height=\"20\"\n                              viewBox=\"0 0 20 20\"\n                              fill=\"none\"\n                              xmlns=\"http://www.w3.org/2000/svg\"\n                            >\n                              <path\n                                d=\"M16.3725 13.125L10.3268 6.875L4.28101 13.125\"\n                                stroke=\"#47483B\"\n                                stroke-width=\"1.5\"\n                                stroke-linecap=\"round\"\n                                stroke-linejoin=\"round\"\n                              />\n                            </svg>\n                          </span>\n                        </label>\n                        <div\n                          class=\"ais-facet-", "-container ais-facet-dropdown-container animate-fade-in\"\n                        ></div>\n                      </div>\n                    "])), facet.type, facet.escapedName, facet.escapedName, facet.escapedName, facet.title, facet.escapedName);
          }), function (event) {
            return aisOpenFacetsDrawer(event);
          }, !isMdlargeScreen && html(_templateObject17 || (_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"ais-sort max-mdl:hidden\">\n                      ", "\n                    </div>\n                  "])), data.multipleSortOrders ? html(_templateObject18 || (_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n                            <span class=\"ais-sort-text\">Sort by</span>\n                            <span class=\"ais-sort-orders-container\"></span>\n                          "]))) : html(_templateObject19 || (_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)([" <span class=\"ais-sort-text\">Sorted by</span> ", " "])), algoliaShopify.translations.relevance)));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function (_defaultTemplate, item, html) {
          return html(_templateObject20 || (_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <label\n              class=\"", " ", "\"\n            >\n              ", "\n              ", "\n              ", "\n              <span class=\"", "\"> ", " </span>\n            </label>\n          "])), item.cssClasses.label, item.type === 'disjunctive' ? 'outline-2 outline-offset-2 outline-blue-600 focus:outline-none has-[input:focus-visible]:outline' : '', item.type === 'disjunctive' && (item.isRefined ? html(_templateObject21 || (_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <input type=\"checkbox\" class=\"", " sr-only\" checked />\n                    <span class=\"ais-facet--custom-icon\">\n                      <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z\"\n                          fill=\"#47483B\"\n                          stroke=\"#47483B\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M14 5.5L7.125 12.5L4 9.31818\"\n                          stroke=\"white\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </span>\n                  "])), item.cssClasses.checkbox) : html(_templateObject22 || (_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <input type=\"checkbox\" class=\"", " sr-only\" />\n                    <span class=\"ais-facet--custom-icon\">\n                      <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z\"\n                          stroke=\"#47483B\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </span>\n                  "])), item.cssClasses.checkbox)), item.type === 'menu' && html(_templateObject23 || (_templateObject23 = (0,taggedTemplateLiteral/* default */.Z)(["\n                <span\n                  class=\"ais-facet--custom-icon flex h-4 w-4 items-center justify-center rounded-full border border-black\"\n                >\n                  <span class=\"", " h-2 w-2 rounded-full bg-p-forest\"></span>\n                </span>\n              "])), item.isRefined ? '' : 'hidden'), item.label, item.cssClasses.count, algoliaShopify.helpers.formatNumber(item.count));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
          return html(_templateObject24 || (_templateObject24 = (0,taggedTemplateLiteral/* default */.Z)(["\n          ", "\n          ", "\n        "])), data.hasOneResult && html(_templateObject25 || (_templateObject25 = (0,taggedTemplateLiteral/* default */.Z)(["Showing ", " <span class=\"font-bold\"> 1 </span> item "])), ' '), data.hasManyResults && html(_templateObject26 || (_templateObject26 = (0,taggedTemplateLiteral/* default */.Z)(["\n            Showing ", "\n            <span class=\"font-bold\"> ", " </span>\n            ", " of ", "\n            <span class=\"font-bold\"> ", " </span>\n            ", " items\n          "])), ' ', Math.min((data.page + 1) * data.hitsPerPage, data.nbHits), ' ', ' ', algoliaShopify.helpers.formatNumber(data.nbHits), ' '));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function (_defaultTemplate, html) {
          return html(_templateObject27 || (_templateObject27 = (0,taggedTemplateLiteral/* default */.Z)(["\n          <div class=\"ais-hit-empty\">\n            <div class=\"ais-hit-empty--title\">", "</div>\n            <div class=\"ais-hit-empty--clears\">\n              ", " ", "\n              <a class=\"ais-hit-empty--clear-filters ais-link\"> ", " ", " </a>\n              ", "\n            </div>\n          </div>\n        "])), algoliaShopify.translations.noResultFound, algoliaShopify.translations["try"], ' ', algoliaShopify.translations.clearFilters, ' ', !isCollectionPage && html(_templateObject28 || (_templateObject28 = (0,taggedTemplateLiteral/* default */.Z)(["\n                ", " ", "\n                <a class=\"ais-hit-empty--clear-input ais-link\"> ", " </a>\n              "])), algoliaShopify.translations.or, ' ', algoliaShopify.translations.changeInput));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, handleItemClick) {
          var _hit$body_html_safe, _hit$meta20, _hit$meta20$okendo, _hit$meta21, _hit$meta21$custom, _hit$meta23, _hit$meta23$custom, _hit$meta23$custom$co, _hit$meta24, _hit$meta24$custom, _hit$metafields11, _hit$metafields11$cus, _hit$metafields11$cus2, _hit$meta25, _hit$meta25$custom, _hit$meta25$custom$co, _hit$meta26, _hit$meta26$custom, _hit$metafields12, _hit$metafields12$cus, _hit$metafields12$cus2, _hit$meta27, _hit$meta27$custom, _hit$meta27$custom$co, _hit$meta28, _hit$meta28$custom, _hit$metafields13, _hit$metafields13$cus, _hit$metafields13$cus2, _hit$meta29, _hit$meta29$custom, _hit$meta29$custom$co, _hit$meta30, _hit$meta30$custom, _hit$metafields14, _hit$metafields14$cus, _hit$metafields14$cus2, _hit$meta31, _hit$meta31$custom, _hit$meta31$custom$co, _hit$meta32, _hit$meta32$custom, _hit$metafields15, _hit$metafields15$cus, _hit$metafields15$cus2, _hit$meta33, _hit$meta33$custom, _hit$meta33$custom$co, _hit$meta34, _hit$meta34$custom, _hit$metafields16, _hit$metafields16$cus, _hit$metafields16$cus2, _hit$meta35, _hit$meta35$custom, _hit$meta35$custom$co, _hit$meta36, _hit$meta36$custom, _hit$metafields17, _hit$metafields17$cus, _hit$metafields17$cus2, _hit$meta37, _hit$meta37$custom, _hit$meta37$custom$co, _hit$meta38, _hit$meta38$custom, _hit$metafields18, _hit$metafields18$cus, _hit$metafields18$cus2, _hit$meta39, _hit$meta39$okendo, _hit$meta39$okendo$St, _hit$meta40, _hit$meta40$okendo, _hit$metafields19, _hit$metafields19$oke, _hit$metafields19$oke2, _hit$meta41, _hit$meta41$okendo, _hit$meta41$okendo$su, _hit$metafields20, _hit$metafields20$oke, _hit$metafields20$oke2;
          var productId = hit.id;
          var productDescription = (_hit$body_html_safe = hit.body_html_safe) === null || _hit$body_html_safe === void 0 ? void 0 : _hit$body_html_safe.replace(/&amp;/g, '&');
          var okendoReviewSnippet = (_hit$meta20 = hit.meta) === null || _hit$meta20 === void 0 ? void 0 : (_hit$meta20$okendo = _hit$meta20.okendo) === null || _hit$meta20$okendo === void 0 ? void 0 : _hit$meta20$okendo.StarRatingSnippet;
          var productAltObj = {
            showImage: false,
            showBadge: false
          };
          if ((_hit$meta21 = hit.meta) !== null && _hit$meta21 !== void 0 && (_hit$meta21$custom = _hit$meta21.custom) !== null && _hit$meta21$custom !== void 0 && _hit$meta21$custom.algolia_alt_image_url) {
            var _hit$meta22, _hit$meta22$custom;
            productAltObj.showImage = true;
            productAltObj.image = (_hit$meta22 = hit.meta) === null || _hit$meta22 === void 0 ? void 0 : (_hit$meta22$custom = _hit$meta22.custom) === null || _hit$meta22$custom === void 0 ? void 0 : _hit$meta22$custom.algolia_alt_image_url;
          }
          if (hit.tags && window.productBadgesConfigs) {
            if (Array.isArray(hit.tags)) {
              var badgeTag = hit.tags.find(function (tag) {
                return tag.includes('badge-');
              });
              if (badgeTag) {
                var badgeHandle = badgeTag.replace('badge-', '');
                if (window.productBadgesConfigs[badgeHandle]) {
                  productAltObj.showBadge = true;
                  productAltObj.badgeConfig = window.productBadgesConfigs[badgeHandle];
                }
              }
            }
          }

          // Get theme settings to check if compare is enabled
          var themeSettings = getThemeSettings();
          var isCompareEnabled = themeSettings.enablePlpCompare;
          return html(_templateObject29 || (_templateObject29 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div\n              class=\"ais-hit ais-product\"\n              data-algolia-index=\"", "\"\n              data-algolia-position=\"", "\"\n              data-algolia-queryid=\"", "\"\n              data-algolia-objectid=\"", "\"\n              data-handle=\"", "\"\n              data-variant-id=\"", "\"\n              data-distinct=\"", "\"\n              data-product-id=\"", "\"\n              onClick=\"", "\"\n            >\n              <div class=\"ais-hit--picture-wrapper ", "\">\n                <img\n                  class=\"ais-hit--picture\"\n                  src=\"", "\"\n                  alt=\"", "\"\n                  loading=\"lazy\"\n                />\n                ", "\n                ", "\n              </div>\n\n              <div class=\"ais-hit--content\">\n                ", "\n                <div class=\"ais-hit--title\">\n                  <a\n                    data-algolia-index=\"", "\"\n                    data-algolia-position=\"", "\"\n                    data-algolia-queryid=\"", "\"\n                    data-algolia-objectid=\"", "\"\n                    href=\"", "\"\n                    onclick=\"void(0)\"\n                    title=\"", "\"\n                  >\n                    ", "\n                    ", "\n                  </a>\n                </div>\n                ", "\n              </div>\n              <div class=\"ais-hit--price\">\n                ", "\n                ", "\n                ", "\n              </div>\n              <div\n                class=\"ais-hit--buttons-section ", " !mt-3 flex xl:!mt-5\"\n                onClick=\"", "\"\n              >\n                <button\n                  type=\"button\"\n                  class=\" flex w-full items-center justify-center rounded-full border border-[--atc-btn-bg-color] bg-[--atc-btn-bg-color] px-3 py-2 text-xxs font-bold uppercase tracking-x-widest text-[--atc-btn-text-color] outline-offset-4 lg:text-xs  xl:px-5 xl:py-[13px] xl:text-sm\"\n                  onClick=\"", "\"\n                >\n                  ", "\n                </button>\n\n                <!-- Compare Checkbox (conditionally rendered) -->\n                ", "\n              </div>\n            </div>\n          "])), hit.index, hit.productPosition, hit.queryID, hit.objectID, hit.handle, hit.objectID, hit._distinct, hit.id, function (event) {
            return handleItemClick(event, hit);
          }, productAltObj.showImage ? 'has-alt-picture' : '', algoliaShopify.helpers.largeImage(hit), hit.title, productAltObj.showImage && html(_templateObject30 || (_templateObject30 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <img\n                    class=\"ais-hit--alt-picture\"\n                    src=\"", "\"\n                    alt=\"", "\"\n                    loading=\"lazy\"\n                  />\n                "])), algoliaShopify.helpers.largeImage(productAltObj), hit.title), productAltObj.showBadge && html(_templateObject31 || (_templateObject31 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <div class=\"ais-hit--badge-container\">\n                    <span\n                      style=\"background-color: ", "; color: ", ";\"\n                      class=\"ais-hit--badge\"\n                    >\n                      ", "\n                    </span>\n                  </div>\n                "])), productAltObj.badgeConfig.backgroundColor, productAltObj.badgeConfig.textColor, productAltObj.badgeConfig.text), productId && okendoReviewSnippet && html(_templateObject32 || (_templateObject32 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <div class=\"ais-hit--review oke-small-size\">\n                    <div data-oke-star-rating data-oke-reviews-product-id=\"shopify-", "\">\n                      ", "\n                    </div>\n                  </div>\n                "])), productId, html([okendoReviewSnippet])), hit.index, hit.productPosition, hit.queryID, hit.objectID, algoliaShopify.helpers.instantsearchLink(hit), algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title), components.Highlight({
            attribute: 'title',
            hit: hit
          }), algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct), productDescription && html(_templateObject33 || (_templateObject33 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <div class=\"ais-hit--description\">\n                    ", "\n                  </div>\n                "])), function () {
            return productDescription.length > 70 ? productDescription.substring(0, 67) + '...' : productDescription;
          }()), algoliaShopify.helpers.displayPrice(hit, hit._distinct), !hit._distinct && html(_templateObject34 || (_templateObject34 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <span class=\"ais-hit--price-striked\">\n                    <span>", "</span>\n                  </span>\n                "])), algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)), !hit._distinct && html(_templateObject35 || (_templateObject35 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <span class=\"ais-hit--price-discount\">\n                    ", "\n                  </span>\n                "])), algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)), isCompareEnabled ? 'flex-col items-center justify-between gap-2 md:flex-row md:gap-4' : 'flex-row items-center justify-center', function (event) {
            return event.stopPropagation();
          }, function (event) {
            var isLowStock = hit.variants_inventory_count < 100;
            var isBackInStock = hit.tags.includes('back_in_stock');
            var isInStock = hit.variants_inventory_count !== 0;
            if (isLowStock && isBackInStock || isInStock) {
              aisQuickBuyModal(event, hit.handle);
            }
          }, hit.tags.includes('back_in_stock') ? 'Quick Buy' : hit.variants_inventory_count === 0 ? 'Coming Soon' : 'ADD TO BAG', isCompareEnabled ? html(_templateObject36 || (_templateObject36 = (0,taggedTemplateLiteral/* default */.Z)(["\n                      <div class=\"flex items-center justify-center gap-1\">\n                        <input\n                          type=\"checkbox\"\n                          id=\"compare-", "\"\n                          class=\"compare-checkbox border-1 text-p-forest focus:ring-0 focus:ring-p-forest disabled:cursor-not-allowed disabled:opacity-50\"\n                          data-product-id=\"", "\"\n                          data-product-title=\"", "\"\n                          data-product-image=\"", "\"\n                          data-product-url=\"", "\"\n                          data-product-price=\"", "\"\n                          data-product-price-min=\"", "\"\n                          data-product-price-max=\"", "\"\n                          data-product-variants-count=\"", "\"\n                          data-product-handle=\"", "\"\n                          data-product-form=\"", "\"\n                          data-product-suggested-use=\"", "\"\n                          data-product-supply-per-bottle=\"", "\"\n                          data-product-key-ingredients=\"", "\"\n                          data-product-certifications=\"", "\"\n                          data-product-allergen-info=\"", "\"\n                          data-product-price-per-serving=\"", "\"\n                          data-product-benefits=\"", "\"\n                          data-product-star-rating=\"", "\"\n                          data-product-review-count=\"", "\"\n                          onChange=\"", "\"\n                          x-bind:checked=\"window.plpCompareComponent?.isProductSelected(", ") || false\"\n                          x-bind:disabled=\"!window.plpCompareComponent?.isProductSelected(", ") && window.plpCompareComponent?.isMaxSelected\"\n                        />\n                        <label\n                          for=\"compare-", "\"\n                          class=\"cursor-pointer text-sm font-bold leading-6 text-p-forest\"\n                          onClick=\"", "\"\n                        >\n                          Compare\n                        </label>\n                      </div>\n                    "])), hit.id, hit.id, hit.title, algoliaShopify.helpers.largeImage(hit), algoliaShopify.helpers.instantsearchLink(hit), algoliaShopify.helpers.displayPrice(hit, hit._distinct), hit.price_min ? algoliaShopify.helpers.formatMoney(hit.price_min) : '', hit.price_max ? algoliaShopify.helpers.formatMoney(hit.price_max) : '', hit.variants ? hit.variants.length : 1, hit.handle, ((_hit$meta23 = hit.meta) === null || _hit$meta23 === void 0 ? void 0 : (_hit$meta23$custom = _hit$meta23.custom) === null || _hit$meta23$custom === void 0 ? void 0 : (_hit$meta23$custom$co = _hit$meta23$custom.compare_product_form) === null || _hit$meta23$custom$co === void 0 ? void 0 : _hit$meta23$custom$co.value) || ((_hit$meta24 = hit.meta) === null || _hit$meta24 === void 0 ? void 0 : (_hit$meta24$custom = _hit$meta24.custom) === null || _hit$meta24$custom === void 0 ? void 0 : _hit$meta24$custom.compare_product_form) || ((_hit$metafields11 = hit.metafields) === null || _hit$metafields11 === void 0 ? void 0 : (_hit$metafields11$cus = _hit$metafields11.custom) === null || _hit$metafields11$cus === void 0 ? void 0 : (_hit$metafields11$cus2 = _hit$metafields11$cus.compare_product_form) === null || _hit$metafields11$cus2 === void 0 ? void 0 : _hit$metafields11$cus2.value) || 'N/A', ((_hit$meta25 = hit.meta) === null || _hit$meta25 === void 0 ? void 0 : (_hit$meta25$custom = _hit$meta25.custom) === null || _hit$meta25$custom === void 0 ? void 0 : (_hit$meta25$custom$co = _hit$meta25$custom.compare_product_suggested_use) === null || _hit$meta25$custom$co === void 0 ? void 0 : _hit$meta25$custom$co.value) || ((_hit$meta26 = hit.meta) === null || _hit$meta26 === void 0 ? void 0 : (_hit$meta26$custom = _hit$meta26.custom) === null || _hit$meta26$custom === void 0 ? void 0 : _hit$meta26$custom.compare_product_suggested_use) || ((_hit$metafields12 = hit.metafields) === null || _hit$metafields12 === void 0 ? void 0 : (_hit$metafields12$cus = _hit$metafields12.custom) === null || _hit$metafields12$cus === void 0 ? void 0 : (_hit$metafields12$cus2 = _hit$metafields12$cus.compare_product_suggested_use) === null || _hit$metafields12$cus2 === void 0 ? void 0 : _hit$metafields12$cus2.value) || 'N/A', ((_hit$meta27 = hit.meta) === null || _hit$meta27 === void 0 ? void 0 : (_hit$meta27$custom = _hit$meta27.custom) === null || _hit$meta27$custom === void 0 ? void 0 : (_hit$meta27$custom$co = _hit$meta27$custom.compare_product_supply_per_bottle) === null || _hit$meta27$custom$co === void 0 ? void 0 : _hit$meta27$custom$co.value) || ((_hit$meta28 = hit.meta) === null || _hit$meta28 === void 0 ? void 0 : (_hit$meta28$custom = _hit$meta28.custom) === null || _hit$meta28$custom === void 0 ? void 0 : _hit$meta28$custom.compare_product_supply_per_bottle) || ((_hit$metafields13 = hit.metafields) === null || _hit$metafields13 === void 0 ? void 0 : (_hit$metafields13$cus = _hit$metafields13.custom) === null || _hit$metafields13$cus === void 0 ? void 0 : (_hit$metafields13$cus2 = _hit$metafields13$cus.compare_product_supply_per_bottle) === null || _hit$metafields13$cus2 === void 0 ? void 0 : _hit$metafields13$cus2.value) || 'N/A', ((_hit$meta29 = hit.meta) === null || _hit$meta29 === void 0 ? void 0 : (_hit$meta29$custom = _hit$meta29.custom) === null || _hit$meta29$custom === void 0 ? void 0 : (_hit$meta29$custom$co = _hit$meta29$custom.compare_product_key_ingredients) === null || _hit$meta29$custom$co === void 0 ? void 0 : _hit$meta29$custom$co.value) || ((_hit$meta30 = hit.meta) === null || _hit$meta30 === void 0 ? void 0 : (_hit$meta30$custom = _hit$meta30.custom) === null || _hit$meta30$custom === void 0 ? void 0 : _hit$meta30$custom.compare_product_key_ingredients) || ((_hit$metafields14 = hit.metafields) === null || _hit$metafields14 === void 0 ? void 0 : (_hit$metafields14$cus = _hit$metafields14.custom) === null || _hit$metafields14$cus === void 0 ? void 0 : (_hit$metafields14$cus2 = _hit$metafields14$cus.compare_product_key_ingredients) === null || _hit$metafields14$cus2 === void 0 ? void 0 : _hit$metafields14$cus2.value) || 'N/A', ((_hit$meta31 = hit.meta) === null || _hit$meta31 === void 0 ? void 0 : (_hit$meta31$custom = _hit$meta31.custom) === null || _hit$meta31$custom === void 0 ? void 0 : (_hit$meta31$custom$co = _hit$meta31$custom.compare_product_certifications) === null || _hit$meta31$custom$co === void 0 ? void 0 : _hit$meta31$custom$co.value) || ((_hit$meta32 = hit.meta) === null || _hit$meta32 === void 0 ? void 0 : (_hit$meta32$custom = _hit$meta32.custom) === null || _hit$meta32$custom === void 0 ? void 0 : _hit$meta32$custom.compare_product_certifications) || ((_hit$metafields15 = hit.metafields) === null || _hit$metafields15 === void 0 ? void 0 : (_hit$metafields15$cus = _hit$metafields15.custom) === null || _hit$metafields15$cus === void 0 ? void 0 : (_hit$metafields15$cus2 = _hit$metafields15$cus.compare_product_certifications) === null || _hit$metafields15$cus2 === void 0 ? void 0 : _hit$metafields15$cus2.value) || 'N/A', ((_hit$meta33 = hit.meta) === null || _hit$meta33 === void 0 ? void 0 : (_hit$meta33$custom = _hit$meta33.custom) === null || _hit$meta33$custom === void 0 ? void 0 : (_hit$meta33$custom$co = _hit$meta33$custom.compare_product_allergen_info) === null || _hit$meta33$custom$co === void 0 ? void 0 : _hit$meta33$custom$co.value) || ((_hit$meta34 = hit.meta) === null || _hit$meta34 === void 0 ? void 0 : (_hit$meta34$custom = _hit$meta34.custom) === null || _hit$meta34$custom === void 0 ? void 0 : _hit$meta34$custom.compare_product_allergen_info) || ((_hit$metafields16 = hit.metafields) === null || _hit$metafields16 === void 0 ? void 0 : (_hit$metafields16$cus = _hit$metafields16.custom) === null || _hit$metafields16$cus === void 0 ? void 0 : (_hit$metafields16$cus2 = _hit$metafields16$cus.compare_product_allergen_info) === null || _hit$metafields16$cus2 === void 0 ? void 0 : _hit$metafields16$cus2.value) || 'N/A', ((_hit$meta35 = hit.meta) === null || _hit$meta35 === void 0 ? void 0 : (_hit$meta35$custom = _hit$meta35.custom) === null || _hit$meta35$custom === void 0 ? void 0 : (_hit$meta35$custom$co = _hit$meta35$custom.compare_product_price_per_serving) === null || _hit$meta35$custom$co === void 0 ? void 0 : _hit$meta35$custom$co.value) || ((_hit$meta36 = hit.meta) === null || _hit$meta36 === void 0 ? void 0 : (_hit$meta36$custom = _hit$meta36.custom) === null || _hit$meta36$custom === void 0 ? void 0 : _hit$meta36$custom.compare_product_price_per_serving) || ((_hit$metafields17 = hit.metafields) === null || _hit$metafields17 === void 0 ? void 0 : (_hit$metafields17$cus = _hit$metafields17.custom) === null || _hit$metafields17$cus === void 0 ? void 0 : (_hit$metafields17$cus2 = _hit$metafields17$cus.compare_product_price_per_serving) === null || _hit$metafields17$cus2 === void 0 ? void 0 : _hit$metafields17$cus2.value) || 'N/A', extractTextFromRichText(((_hit$meta37 = hit.meta) === null || _hit$meta37 === void 0 ? void 0 : (_hit$meta37$custom = _hit$meta37.custom) === null || _hit$meta37$custom === void 0 ? void 0 : (_hit$meta37$custom$co = _hit$meta37$custom.compare_product_benefits) === null || _hit$meta37$custom$co === void 0 ? void 0 : _hit$meta37$custom$co.value) || ((_hit$meta38 = hit.meta) === null || _hit$meta38 === void 0 ? void 0 : (_hit$meta38$custom = _hit$meta38.custom) === null || _hit$meta38$custom === void 0 ? void 0 : _hit$meta38$custom.compare_product_benefits) || ((_hit$metafields18 = hit.metafields) === null || _hit$metafields18 === void 0 ? void 0 : (_hit$metafields18$cus = _hit$metafields18.custom) === null || _hit$metafields18$cus === void 0 ? void 0 : (_hit$metafields18$cus2 = _hit$metafields18$cus.compare_product_benefits) === null || _hit$metafields18$cus2 === void 0 ? void 0 : _hit$metafields18$cus2.value)) || '', ((_hit$meta39 = hit.meta) === null || _hit$meta39 === void 0 ? void 0 : (_hit$meta39$okendo = _hit$meta39.okendo) === null || _hit$meta39$okendo === void 0 ? void 0 : (_hit$meta39$okendo$St = _hit$meta39$okendo.StarRatingSnippet) === null || _hit$meta39$okendo$St === void 0 ? void 0 : _hit$meta39$okendo$St.value) || ((_hit$meta40 = hit.meta) === null || _hit$meta40 === void 0 ? void 0 : (_hit$meta40$okendo = _hit$meta40.okendo) === null || _hit$meta40$okendo === void 0 ? void 0 : _hit$meta40$okendo.StarRatingSnippet) || ((_hit$metafields19 = hit.metafields) === null || _hit$metafields19 === void 0 ? void 0 : (_hit$metafields19$oke = _hit$metafields19.okendo) === null || _hit$metafields19$oke === void 0 ? void 0 : (_hit$metafields19$oke2 = _hit$metafields19$oke.StarRatingSnippet) === null || _hit$metafields19$oke2 === void 0 ? void 0 : _hit$metafields19$oke2.value) || '', ((_hit$meta41 = hit.meta) === null || _hit$meta41 === void 0 ? void 0 : (_hit$meta41$okendo = _hit$meta41.okendo) === null || _hit$meta41$okendo === void 0 ? void 0 : (_hit$meta41$okendo$su = _hit$meta41$okendo.summaryData) === null || _hit$meta41$okendo$su === void 0 ? void 0 : _hit$meta41$okendo$su.reviewCount) || ((_hit$metafields20 = hit.metafields) === null || _hit$metafields20 === void 0 ? void 0 : (_hit$metafields20$oke = _hit$metafields20.okendo) === null || _hit$metafields20$oke === void 0 ? void 0 : (_hit$metafields20$oke2 = _hit$metafields20$oke.summaryData) === null || _hit$metafields20$oke2 === void 0 ? void 0 : _hit$metafields20$oke2.reviewCount) || 0, function (event) {
            event.stopPropagation();
            event.preventDefault();
            aisToggleCompareFromCheckbox(event);
          }, hit.id, hit.id, hit.id, function (event) {
            event.stopPropagation();
          }) : '');
        });
      });
    }
  };
};
var searchComponent = function searchComponent() {
  return {
    showSearchSuggestions: false,
    showSearchSuggestionsMobile: false,
    searchSuggestions: [],
    init: function init() {
      this.fetchTopSearches();
    },
    hideSuggestions: function hideSuggestions() {
      this.showSearchSuggestions = false;
      this.showSearchSuggestionsMobile = false;
    },
    inputClick: function inputClick(event) {
      var _target$value;
      var target = event.target;
      if ((target === null || target === void 0 ? void 0 : (_target$value = target.value) === null || _target$value === void 0 ? void 0 : _target$value.length) < 1) {
        this.showSearchSuggestions = true;
      }
    },
    inputHandler: function inputHandler(event) {
      var inputType = event.inputType,
        target = event.target;
      if (target.value.length === 0) this.showSearchSuggestions = true;
    },
    suggestionResizeHandler: function suggestionResizeHandler() {
      if (!window.isMobile) {
        this.hideSuggestions();
      }
    },
    appendSuggestionCloneToMobileSearch: function appendSuggestionCloneToMobileSearch() {
      var detachedContainer = document.querySelector('.aa-DetachedContainer');
      if (!detachedContainer) {
        return;
      }
      var mobileSearchSuggestions = document.querySelector('.alglolia-search-suggestions-mobile');
      if (mobileSearchSuggestions) {
        return;
      }
      var searchSuggestions = this.$refs.searchSuggestions.innerHTML;
      detachedContainer.insertAdjacentHTML('beforeend', "\n      <div\n        class=\"alglolia-search-suggestions-mobile\"\n        x-data=\"{\n        showSearchSuggestions: true,\n        showSearchSuggestionsMobile: true,\n        searchSuggestionData: [".concat(this.searchSuggestions.map(function (suggestion) {
        return "'".concat(suggestion, "'");
      }), "],\n      }\"\n      @before-autocomplete-load.window=\"showSearchSuggestionsMobile = false\"\n    >\n      <template x-if=\"showSearchSuggestionsMobile\">\n        <div class=\"relative bg-p-ivory p-4 capitalize shadow-lg lg:px-16 lg:py-8\" x-ref=\"searchSuggestions\">\n          <div class=\"m-auto w-full max-w-[1000px]\">\n            <h3 class=\"mb-4 font-sans font-bold md:text-base\">Popular Search Terms</h3>\n            <ul id=\"topresults\" class=\"list-none\">\n              <template x-for=\"suggestion in searchSuggestionData\">\n                <li class=\"inline-block mr-4 mb-4\">\n                  <a :href=\"'/search?q=' + suggestion\" class=\"btn--small btn--solid btn btn--secondary capitalize tracking-normal\" x-text=\"suggestion\"></a>\n                </li>\n              </template>\n            </ul>\n          </div>\n        </div>\n      </template>\n    </div>"));
    },
    sanitizeSearchTerm: function sanitizeSearchTerm(search) {
      return search.replace(/["'\\\n\r\t\b\f]/g, function (_char) {
        var escapeMap = {
          '"': '\\"',
          "'": "\\'",
          '\\': '\\\\',
          '\n': '\\n',
          '\r': '\\r',
          '\t': '\\t',
          '\b': '\\b',
          '\f': '\\f'
        };
        return escapeMap[_char] || _char;
      });
    },
    fetchTopSearches: function fetchTopSearches() {
      var _window$algoliaShopif5,
        _window$themeTopSearc,
        _window$themeTopSearc2,
        _this = this;
      var apiKey = '6603de15f2cc42b8d6b460ce0f473d86'; // Replace with your Algolia API Key
      var appId = 'J4W35K0ZQZ'; // Replace with your Algolia Application ID
      var _window$algoliaShopif4 = (_window$algoliaShopif5 = window.algoliaShopify) === null || _window$algoliaShopif5 === void 0 ? void 0 : _window$algoliaShopif5.config,
        index_prefix = _window$algoliaShopif4.index_prefix; // Replace with your index name
      var indexName = index_prefix ? "".concat(index_prefix, "products") : 'shopify_products'; // Replace with your index name
      var limit = ((_window$themeTopSearc = window.themeTopSearches) === null || _window$themeTopSearc === void 0 ? void 0 : _window$themeTopSearc.algoliaSearchesCount) || 10; // Number of results to return
      var customSearches = ((_window$themeTopSearc2 = window.themeTopSearches) === null || _window$themeTopSearc2 === void 0 ? void 0 : _window$themeTopSearc2.customSearches) || [];
      var sanitizedCustomSearches = customSearches.map(function (item) {
        return _this.sanitizeSearchTerm(item);
      });
      var url = "https://analytics.us.algolia.com/2/searches?index=".concat(indexName, "&limit=").concat(limit);
      (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var response, data, algoliaSearchSuggestions;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(url, {
                method: 'GET',
                headers: {
                  'X-Algolia-API-Key': apiKey,
                  'X-Algolia-Application-Id': appId
                }
              });
            case 3:
              response = _context.sent;
              if (response.ok) {
                _context.next = 6;
                break;
              }
              throw new Error("Error: ".concat(response.status, " ").concat(response.statusText));
            case 6:
              _context.next = 8;
              return response.json();
            case 8:
              data = _context.sent;
              algoliaSearchSuggestions = (0,toConsumableArray/* default */.Z)(data.searches).filter(function (_ref5) {
                var search = _ref5.search;
                return search.trim() !== '';
              }).sort(function (a, b) {
                return b.count - a.count;
              }).map(function (_ref6) {
                var search = _ref6.search;
                return _this.sanitizeSearchTerm(search);
              });
              _this.searchSuggestions = [].concat((0,toConsumableArray/* default */.Z)(sanitizedCustomSearches), (0,toConsumableArray/* default */.Z)(algoliaSearchSuggestions));
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error('Failed to fetch top searches:', _context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }))();
    }
  };
};
;// CONCATENATED MODULE: ./src/js/bundles/snippets/rebuy-cart.js


function rebuy_cart_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function rebuy_cart_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? rebuy_cart_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : rebuy_cart_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable */

var _window = window,
  STOREFRONT_ACCESS_TOKEN = _window.STOREFRONT_ACCESS_TOKEN;
var HAZARDOUS_GOODS_METAFIELD = /* GraphQL */"\n    query getProductById($id: ID!) {\n    product(id: $id) {\n      title\n      hazardousMaterial: metafield(namespace: \"custom\", key: \"hazardous_materials\") {\n        value\n        type\n        key\n        namespace\n        reference {\n          ... on Metaobject {\n            id\n            type\n            fields {\n              key\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n";
var HAZARDOUS_GOODS_METAFIELDS = /* GraphQL */"\n  query getProductsByIds($query: String!) {\n    products(first: 10, query: $query) {\n      edges {\n        node {\n          title\n          hazardousMaterial: metafield(namespace: \"custom\", key: \"hazardous_materials\") {\n            value\n            type\n            key\n            namespace\n            reference {\n              ... on Metaobject {\n                id\n                type\n                fields {\n                  key\n                  value\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }";
var fetchHazardousGoodsMetafield = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(productId) {
    var _data$product, response, _yield$response$json, data;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch('/api/graphql', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({
              query: HAZARDOUS_GOODS_METAFIELD,
              variables: JSON.stringify({
                id: "gid://shopify/Product/".concat(productId)
              })
            })
          });
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          _yield$response$json = _context.sent;
          data = _yield$response$json.data;
          return _context.abrupt("return", data === null || data === void 0 ? void 0 : (_data$product = data.product) === null || _data$product === void 0 ? void 0 : _data$product.hazardousMaterial);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          console.error('Failed to fetch metafield', _context.t0);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  }));
  return function fetchHazardousGoodsMetafield(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchHazardousGoodsMetafields = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(productTitles) {
    var _response$data, _response$data$produc, response, items;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch('/api/graphql', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({
              query: HAZARDOUS_GOODS_METAFIELDS,
              variables: JSON.stringify({
                query: "".concat(productTitles.join(' OR '))
              })
            })
          }).then(function (res) {
            return res.json();
          });
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$produc = _response$data.products) === null || _response$data$produc === void 0 ? void 0 : _response$data$produc.edges;
        case 6:
          items = _context2.sent;
          return _context2.abrupt("return", items);
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](0);
          console.error('Failed to fetch metafields', _context2.t0);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 10]]);
  }));
  return function fetchHazardousGoodsMetafields(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var rebuyCartHandler = function rebuyCartHandler() {
  return {
    init: function init() {
      this.rebuyCartLimitProductQty();
      this.rebuyItemAdded();
      this.closeQuickBuyModal();
      this.rebuyMobileBodyScrollFix();
    },
    rebuyItemAdded: function rebuyItemAdded() {
      var setHazardousTieredProps = /*#__PURE__*/function () {
        var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(items) {
          var hazardTieredProducts;
          return regenerator_default().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetchHazardousGoodsMetafields(items.map(function (_ref4) {
                  var product_title = _ref4.product_title;
                  return "title:'".concat(product_title, "'");
                }));
              case 2:
                hazardTieredProducts = _context3.sent;
                hazardTieredProducts.forEach(function (hazardProduct, index) {
                  var _hazardProduct$node, _hazardProduct$node$h, _hazardProduct$node2, _hazardProduct$node2$;
                  if (!(hazardProduct !== null && hazardProduct !== void 0 && (_hazardProduct$node = hazardProduct.node) !== null && _hazardProduct$node !== void 0 && (_hazardProduct$node$h = _hazardProduct$node.hazardousMaterial) !== null && _hazardProduct$node$h !== void 0 && _hazardProduct$node$h.reference)) {
                    return;
                  }
                  var _hazardProduct$node$h2 = hazardProduct === null || hazardProduct === void 0 ? void 0 : (_hazardProduct$node2 = hazardProduct.node) === null || _hazardProduct$node2 === void 0 ? void 0 : (_hazardProduct$node2$ = _hazardProduct$node2.hazardousMaterial) === null || _hazardProduct$node2$ === void 0 ? void 0 : _hazardProduct$node2$.reference,
                    fields = _hazardProduct$node$h2.fields;
                  var hazardProps = fields.filter(function (_ref5) {
                    var key = _ref5.key;
                    return key === 'notification_title' || key === 'notification_content';
                  }).reduce(function (acc, _ref6) {
                    var key = _ref6.key,
                      value = _ref6.value;
                    var sanitizedKey = key.split('_').pop();
                    acc["_hazardous_product_".concat(sanitizedKey)] = value;
                    return acc;
                  }, {});
                  if (!Object.keys(hazardProps).length) {
                    return;
                  }
                  var matchItem = items.find(function (_ref7) {
                    var product_title = _ref7.product_title;
                    return product_title === hazardProduct.node.title;
                  });
                  window.Rebuy.Cart.changeItem({
                    id: matchItem.key,
                    properties: rebuy_cart_objectSpread(rebuy_cart_objectSpread({}, matchItem.properties), hazardProps)
                  });
                });
              case 4:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function setHazardousTieredProps(_x3) {
          return _ref3.apply(this, arguments);
        };
      }();
      var setHazardousProps = /*#__PURE__*/function () {
        var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(event) {
          var _item$items, _item$properties;
          var _event$detail, cart, item, hazardProduct, _hazardProduct$refere, fields, hazardProps;
          return regenerator_default().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _event$detail = event.detail, cart = _event$detail.cart, item = _event$detail.item;
                if (!(item !== null && item !== void 0 && (_item$items = item.items) !== null && _item$items !== void 0 && _item$items.length)) {
                  _context4.next = 5;
                  break;
                }
                _context4.next = 4;
                return setHazardousTieredProps(item.items);
              case 4:
                return _context4.abrupt("return");
              case 5:
                if (!((item === null || item === void 0 ? void 0 : (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties._source) !== 'Rebuy')) {
                  _context4.next = 7;
                  break;
                }
                return _context4.abrupt("return");
              case 7:
                _context4.next = 9;
                return fetchHazardousGoodsMetafield(item.product_id);
              case 9:
                hazardProduct = _context4.sent;
                _hazardProduct$refere = hazardProduct === null || hazardProduct === void 0 ? void 0 : hazardProduct.reference, fields = _hazardProduct$refere.fields;
                if (!(!fields || !fields.length)) {
                  _context4.next = 13;
                  break;
                }
                return _context4.abrupt("return");
              case 13:
                hazardProps = fields.filter(function (_ref9) {
                  var key = _ref9.key;
                  return key === 'notification_title' || key === 'notification_content';
                }).reduce(function (acc, _ref10) {
                  var key = _ref10.key,
                    value = _ref10.value;
                  var sanitizedKey = key.split('_').pop();
                  acc["_hazardous_product_".concat(sanitizedKey)] = value;
                  return acc;
                }, {});
                if (Object.keys(hazardProps).length) {
                  _context4.next = 16;
                  break;
                }
                return _context4.abrupt("return");
              case 16:
                cart.changeItem({
                  id: item.key,
                  properties: rebuy_cart_objectSpread(rebuy_cart_objectSpread({}, item.properties), hazardProps)
                });
              case 17:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function setHazardousProps(_x4) {
          return _ref8.apply(this, arguments);
        };
      }();
      document.addEventListener('rebuy:cart.add', setHazardousProps);
    },
    rebuyCartLimitProductQty: function rebuyCartLimitProductQty() {
      var limitItemQuantities = function limitItemQuantities() {
        setTimeout(function () {
          var cartItems = Rebuy.SmartCart.items(); // Pull in all the cart items
          // Check and limit the quantity
          cartItems.forEach(function (item) {
            if (item.quantity > 10) {
              Rebuy.Cart.setItemQuantity(item, 10);
              alert('Oops! You can add maximum 10 quantity for this item');
            }
          });
        }, 400);
      };
      document.addEventListener('rebuy:cart.change', limitItemQuantities);
    },
    closeQuickBuyModal: function closeQuickBuyModal() {
      var showRebuyCart = function showRebuyCart() {
        Alpine.store('quickBuyModal') && Alpine.store('quickBuyModal').hide();
      };
      document.addEventListener('rebuy:smartcart.show', showRebuyCart);
    },
    rebuyMobileBodyScrollFix: function rebuyMobileBodyScrollFix() {
      var showRebuyCart = function showRebuyCart() {
        setTimeout(function () {
          window.isMobile && disableScrollForInputDrawer();
        }, 10); // delay because quickBuyModal hide calls enableScrollForInputDrawer
      };

      var hideRebuyCart = function hideRebuyCart() {
        window.isMobile && enableScrollForInputDrawer();
      };
      document.addEventListener('rebuy:smartcart.show', showRebuyCart);
      document.addEventListener('rebuy:smartcart.hide', hideRebuyCart);
    }
  };
};
var rebuyCartState = function rebuyCartState() {
  return {
    itemCount: 0,
    retries: 0,
    maxRetries: 10,
    init: function init() {
      var _this = this;
      document.addEventListener('rebuy:cart.ready', function () {
        return _this.updateItemCount();
      });
      document.addEventListener('rebuy:cart.change', function () {
        return _this.updateItemCount();
      });
    },
    updateItemCount: function updateItemCount() {
      var _Rebuy,
        _this2 = this;
      if ((_Rebuy = Rebuy) !== null && _Rebuy !== void 0 && _Rebuy.SmartCart) {
        this.itemCount = Rebuy.SmartCart.itemCount();
      } else if (this.retries++ < this.maxRetries) {
        console.warn('updateItemCount - Rebuy.SmartCart is not initialized yet. Retrying...');
        setTimeout(function () {
          return _this2.updateItemCount();
        }, 300); // Retry after 300ms
      } else {
        console.error('updateItemCount - Failed to initialize Rebuy.SmartCart after maximum retries.');
      }
    }
  };
};
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.js
var navigation = __webpack_require__(739);
// EXTERNAL MODULE: ./node_modules/swiper/modules/mousewheel/mousewheel.js
var mousewheel = __webpack_require__(372);
// EXTERNAL MODULE: ./node_modules/swiper/modules/a11y/a11y.js
var a11y = __webpack_require__(799);
// EXTERNAL MODULE: ./node_modules/swiper/modules/keyboard/keyboard.js
var keyboard = __webpack_require__(376);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/unified-compare.js


function unified_compare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function unified_compare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? unified_compare_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : unified_compare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var STORAGE_KEY = 'nms.compare.items';
var STORAGE_PAGE_KEY = 'nms.compare.page';
var MAX_COMPARE_ITEMS = 4;

// Swiper config for PDP product grid
var pdpSwiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchSlidesProgress: false,
  slideVisibleClass: 'swiper-slide-visible',
  autoPlay: false,
  modules: [navigation/* default */.Z, mousewheel/* default */.Z, a11y/* default */.Z, keyboard/* default */.Z],
  keyboard: {
    enabled: false,
    onlyInViewport: false
  },
  navigation: {
    prevEl: '.pdp-compare-swiper-button-prev',
    nextEl: '.pdp-compare-swiper-button-next',
    disabledClass: 'swiper-button-hidden'
  },
  a11y: {
    enabled: true,
    prevSlideMessage: 'Previous product',
    nextSlideMessage: 'Next product',
    firstSlideMessage: 'This is the first product',
    lastSlideMessage: 'This is the last product'
  },
  mousewheel: {
    forceToAxis: true
  },
  breakpoints: {
    320: {
      slidesPerView: 1.5,
      spaceBetween: 16
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 24
    },
    1024: {
      slidesPerView: 4.5,
      spaceBetween: 24
    },
    1440: {
      slidesPerView: 6.5,
      spaceBetween: 24
    }
  }
};

// Swiper config for compare products popup
var compareProductsSwiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  watchSlidesProgress: true,
  slideVisibleClass: 'swiper-slide-visible',
  autoHeight: false,
  modules: [a11y/* default */.Z, mousewheel/* default */.Z],
  enabled: true,
  a11y: {
    enabled: true,
    prevSlideMessage: 'Previous compared product',
    nextSlideMessage: 'Next compared product',
    firstSlideMessage: 'This is the first compared product',
    lastSlideMessage: 'This is the last compared product'
  },
  mousewheel: {
    forceToAxis: true
  },
  breakpoints: {
    320: {
      slidesPerView: 2.5,
      spaceBetween: 30,
      enabled: true
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 20,
      enabled: true
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 24,
      enabled: true
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 40,
      enabled: true
    }
  }
};

// Product data loader for comparison modal - following quick-buy-modal pattern
var loadProductData = function loadProductData(handle) {
  return {
    loading: true,
    productHtml: '',
    init: function init() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!handle) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.fetchProductSection(handle);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchProductSection: function fetchProductSection(handle) {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var response, productHtml;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _this2.loading = true;

              // Fetch the complete product section HTML like quick-buy-modal does
              _context2.next = 4;
              return fetch("/products/".concat(handle, "?section_id=quick-buy-product"));
            case 4:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 7;
                break;
              }
              throw new Error('Product not found');
            case 7:
              _context2.next = 9;
              return response.text();
            case 9:
              productHtml = _context2.sent;
              _this2.productHtml = productHtml;
              _context2.next = 16;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](0);
              // Failed to load product data - will show fallback link
              _this2.productHtml = '';
            case 16:
              _context2.prev = 16;
              _this2.loading = false;
              return _context2.finish(16);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 13, 16, 19]]);
      }))();
    }
  };
};

// Unified compare component that works for both PLP and PDP
var unifiedCompareComponent = function unifiedCompareComponent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    // Configuration options
    isPDP: options.isPDP || false,
    // Whether this is PDP or PLP
    hasProductGrid: options.hasProductGrid || false,
    // Whether PDP has product grid

    // State
    selectedProducts: [],
    showCompareModal: false,
    addingToCart: null,
    swiper: null,
    compareSwiper: null,
    // Computed properties
    get selectedCount() {
      return this.selectedProducts.length;
    },
    get canCompare() {
      return this.selectedProducts.length >= 2;
    },
    get isMaxSelected() {
      return this.selectedProducts.length >= MAX_COMPARE_ITEMS;
    },
    get compareTitle() {
      return "Compare Products (".concat(this.selectedCount, ")");
    },
    get compareSlots() {
      // Create 4 slots, fill with products where available
      var slots = [];
      for (var i = 0; i < MAX_COMPARE_ITEMS; i++) {
        slots.push({
          product: this.selectedProducts[i] || null
        });
      }
      return slots;
    },
    init: function init() {
      var _this3 = this;
      // Check if we're on a different page and clear data if needed
      this.checkPageChange();

      // Load from sessionStorage
      this.loadFromStorage();

      // For PDP: Add current page product automatically when first product is selected
      if (this.isPDP) {
        // Initialize swipers after DOM is ready
        this.$nextTick(function () {
          // Initialize main product grid swiper
          var swiperEl = _this3.$el.querySelector('.pdp-compare-swiper');
          if (swiperEl) {
            _this3.swiper = new core/* default */.Z(swiperEl, pdpSwiperConfig);
          }

          // Initialize compare products swiper
          _this3.initCompareSwiper();

          // Sync checkbox states after DOM is ready
          _this3.syncCheckboxStates();
        });

        // Watch for changes and save to storage
        this.$watch('selectedProducts', function () {
          _this3.saveToStorage();
          _this3.syncCheckboxStates();
          _this3.announceCount();
          // Re-initialize compare swiper when products change
          _this3.$nextTick(function () {
            _this3.initCompareSwiper();
          });
        });

        // Add resize handler to handle responsive behavior
        this.resizeHandler = function () {
          if (_this3.compareSwiper) {
            _this3.compareSwiper.update();
          }
        };
        window.addEventListener('resize', this.resizeHandler);
      } else {
        // For PLP: Initialize compare swiper and watch for changes
        this.$nextTick(function () {
          _this3.initCompareSwiper();
          // Trigger initial Alpine.js reactivity update
          _this3.updateAlpineReactivity();
        });
        this.$watch('selectedProducts', function () {
          _this3.saveToStorage();
          _this3.announceCount();
          // Re-initialize compare swiper when products change
          _this3.$nextTick(function () {
            _this3.initCompareSwiper();
          });
          // Update Alpine.js reactivity for checkboxes
          _this3.updateAlpineReactivity();
        });
      }

      // Listen for page navigation events
      this.setupPageNavigationListener();

      // For PLP: Make component globally accessible for Algolia search
      if (!this.isPDP) {
        window.plpCompareComponent = this;
      }
    },
    isProductSelected: function isProductSelected(productId) {
      return this.selectedProducts.some(function (p) {
        return p.id === productId;
      });
    },
    checkPageChange: function checkPageChange() {
      var currentPage = window.location.pathname;
      var storedPage = sessionStorage.getItem(STORAGE_PAGE_KEY);

      // If we're on a different page than what's stored, clear the data
      if (storedPage && storedPage !== currentPage) {
        this.clearStorage();
        this.selectedProducts = [];
      }
    },
    setupPageNavigationListener: function setupPageNavigationListener() {
      var _this4 = this;
      // Store the current page when the component initializes
      sessionStorage.setItem(STORAGE_PAGE_KEY, window.location.pathname);

      // Listen for beforeunload to clear data when navigating away
      this.beforeUnloadHandler = function () {
        // Mark that we're navigating away
        sessionStorage.setItem('nms.compare.navigating', 'true');
      };

      // Listen for page show event to detect if we're coming back from navigation
      this.pageShowHandler = function () {
        var isNavigating = sessionStorage.getItem('nms.compare.navigating');
        if (isNavigating === 'true') {
          // We navigated away and came back, clear the navigation flag
          sessionStorage.removeItem('nms.compare.navigating');
          // Check if we're on a different page
          _this4.checkPageChange();
        }
      };
      window.addEventListener('beforeunload', this.beforeUnloadHandler);
      window.addEventListener('pageshow', this.pageShowHandler);
    },
    loadFromStorage: function loadFromStorage() {
      try {
        var stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
          this.selectedProducts = JSON.parse(stored);
        }
      } catch (error) {
        this.selectedProducts = [];
      }
    },
    saveToStorage: function saveToStorage() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.selectedProducts));
        sessionStorage.setItem(STORAGE_PAGE_KEY, window.location.pathname);
      } catch (error) {
        // Failed to save compare products to storage
      }
    },
    // PDP-specific method to add current page product
    addCurrentPageProduct: function addCurrentPageProduct() {
      if (!this.isPDP) return;
      try {
        // Get current page product data from the JSON script tag
        var currentProductScript = document.getElementById('current-product-data');
        if (!currentProductScript) return;
        var currentProduct = JSON.parse(currentProductScript.textContent);

        // Check if current product is already in the comparison
        var isAlreadyAdded = this.selectedProducts.some(function (p) {
          return p.id === currentProduct.id;
        });
        if (!isAlreadyAdded) {
          // Determine display price based on variant count
          var displayPrice = currentProduct.price;
          if (currentProduct.variantsCount && parseInt(currentProduct.variantsCount) > 1) {
            var priceMin = currentProduct.priceMin;
            var priceMax = currentProduct.priceMax;
            if (priceMin && priceMax && priceMin !== priceMax) {
              displayPrice = "".concat(priceMin, " - ").concat(priceMax);
            }
          }

          // Add current product as the first item
          this.selectedProducts.unshift({
            id: currentProduct.id,
            title: currentProduct.title,
            image: currentProduct.image,
            url: currentProduct.url,
            price: displayPrice,
            handle: currentProduct.handle,
            form: currentProduct.form || 'N/A',
            suggestedUse: currentProduct.suggestedUse || 'N/A',
            supplyPerBottle: currentProduct.supplyPerBottle || 'N/A',
            keyIngredients: currentProduct.keyIngredients || 'N/A',
            certifications: currentProduct.certifications || 'N/A',
            allergenInfo: currentProduct.allergenInfo || 'N/A',
            pricePerServing: currentProduct.pricePerServing || 'N/A',
            benefits: currentProduct.benefits || 'N/A',
            starRating: currentProduct.starRating || '',
            reviewCount: currentProduct.reviewCount || 0
          });
        }
      } catch (error) {
        // Failed to add current page product
        // eslint-disable-next-line no-console
        console.warn('Could not add current page product to comparison:', error);
      }
    },
    // PDP-specific method to sync checkbox states
    syncCheckboxStates: function syncCheckboxStates() {
      var _this$$el,
        _this5 = this;
      if (!this.isPDP) return;
      var checkboxes = (_this$$el = this.$el) === null || _this$$el === void 0 ? void 0 : _this$$el.querySelectorAll('input[type="checkbox"][data-product-id]');
      if (!checkboxes || checkboxes.length === 0) return;
      checkboxes.forEach(function (checkbox) {
        var productId = parseInt(checkbox.dataset.productId);
        var isSelected = _this5.selectedProducts.some(function (p) {
          return p.id === productId;
        });
        checkbox.checked = isSelected;
        checkbox.disabled = !isSelected && _this5.isMaxSelected;
      });
    },
    // PLP-specific method to sync Algolia checkbox states
    updateAlpineReactivity: function updateAlpineReactivity() {
      var _this6 = this;
      if (this.isPDP) return;

      // For PLP, we need to manually update the Algolia checkboxes since they're not in our $el scope
      var checkboxes = document.querySelectorAll('input[type="checkbox"][data-product-id]');
      checkboxes.forEach(function (checkbox) {
        var productId = parseInt(checkbox.dataset.productId);
        var isSelected = _this6.selectedProducts.some(function (p) {
          return p.id === productId;
        });

        // Manually set the checkbox state
        checkbox.checked = isSelected;
        checkbox.disabled = !isSelected && _this6.isMaxSelected;
      });
    },
    toggleProduct: function toggleProduct(productData) {
      var existingIndex = this.selectedProducts.findIndex(function (p) {
        return p.id === productData.id;
      });
      if (existingIndex > -1) {
        // Remove product
        this.selectedProducts.splice(existingIndex, 1);
      } else {
        // Add product (if not at max)
        if (!this.isMaxSelected) {
          // Determine display price based on variant count
          var displayPrice = productData.price;
          if (productData.variantsCount && parseInt(productData.variantsCount) > 1) {
            var priceMin = productData.priceMin;
            var priceMax = productData.priceMax;
            if (priceMin && priceMax && priceMin !== priceMax) {
              displayPrice = "".concat(priceMin, " - ").concat(priceMax);
            }
          }
          this.selectedProducts.push(unified_compare_objectSpread(unified_compare_objectSpread({}, productData), {}, {
            price: displayPrice
          }));
        }
      }
      this.saveToStorage();
      this.announceCount();
    },
    // PDP-specific method to handle form events
    toggleProductFromEvent: function toggleProductFromEvent(event) {
      var _url$split$;
      if (!this.isPDP) return;
      var checkbox = event.target;
      var productId = parseInt(checkbox.dataset.productId);
      var title = checkbox.dataset.productTitle;
      var image = checkbox.dataset.productImage;
      var url = checkbox.dataset.productUrl;
      var price = checkbox.dataset.productPrice;

      // Capture metafield data
      var metafields = {
        form: checkbox.dataset.productForm,
        suggestedUse: checkbox.dataset.productSuggestedUse,
        supplyPerBottle: checkbox.dataset.productSupplyPerBottle,
        keyIngredients: checkbox.dataset.productKeyIngredients,
        certifications: checkbox.dataset.productCertifications,
        allergenInfo: checkbox.dataset.productAllergenInfo,
        pricePerServing: checkbox.dataset.productPricePerServing,
        benefits: checkbox.dataset.productBenefits,
        starRating: checkbox.dataset.productStarRating,
        reviewCount: checkbox.dataset.productReviewCount,
        priceMin: checkbox.dataset.productPriceMin,
        priceMax: checkbox.dataset.productPriceMax,
        variantsCount: checkbox.dataset.productVariantsCount
      };

      // If this is the first product being selected, add current page product first
      if (this.selectedProducts.length === 0 && checkbox.checked) {
        this.addCurrentPageProduct();
      }

      // Extract handle from URL for API calls
      var handle = ((_url$split$ = url.split('/products/')[1]) === null || _url$split$ === void 0 ? void 0 : _url$split$.split('?')[0]) || '';

      // Determine display price based on variant count
      var displayPrice = price;
      if (metafields.variantsCount && parseInt(metafields.variantsCount) > 1) {
        var priceMin = metafields.priceMin;
        var priceMax = metafields.priceMax;
        if (priceMin && priceMax && priceMin !== priceMax) {
          displayPrice = "".concat(priceMin, " - ").concat(priceMax);
        }
      }
      var productData = {
        id: productId,
        title: title,
        image: image,
        url: url,
        price: displayPrice,
        handle: handle,
        form: metafields.form || 'N/A',
        suggestedUse: metafields.suggestedUse || 'N/A',
        supplyPerBottle: metafields.supplyPerBottle || 'N/A',
        keyIngredients: metafields.keyIngredients || 'N/A',
        certifications: metafields.certifications || 'N/A',
        allergenInfo: metafields.allergenInfo || 'N/A',
        pricePerServing: metafields.pricePerServing || 'N/A',
        benefits: metafields.benefits || 'N/A',
        starRating: metafields.starRating || '',
        reviewCount: metafields.reviewCount || 0,
        priceMin: metafields.priceMin,
        priceMax: metafields.priceMax,
        variantsCount: metafields.variantsCount
      };
      this.toggleProduct(productData);
    },
    removeProduct: function removeProduct(productId) {
      var index = this.selectedProducts.findIndex(function (p) {
        return p.id === productId;
      });
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
        this.saveToStorage();

        // Auto-close modal if no products remain
        if (this.showCompareModal && this.selectedProducts.length === 0) {
          this.closeCompareModal();
        }
      }
    },
    clearStorage: function clearStorage() {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_PAGE_KEY);
      } catch (error) {
        // Failed to clear storage
      }
    },
    clearAll: function clearAll() {
      this.selectedProducts = [];
      this.clearStorage();

      // Auto-close modal if it's open (no products to compare)
      if (this.showCompareModal) {
        this.closeCompareModal();
      }
    },
    openCompareModal: function openCompareModal() {
      if (this.canCompare) {
        this.showCompareModal = true;
        // Focus management for accessibility
        var focusModal = function focusModal() {
          var modal = document.querySelector('[data-compare-modal]');
          if (modal) {
            modal.focus();
          }
        };
        if (this.isPDP) {
          this.$nextTick(focusModal);
        } else {
          setTimeout(focusModal, 100);
        }
      }
    },
    closeCompareModal: function closeCompareModal() {
      this.showCompareModal = false;
    },
    initCompareSwiper: function initCompareSwiper() {
      // Destroy existing swiper if it exists
      if (this.compareSwiper) {
        this.compareSwiper.destroy(true, true);
        this.compareSwiper = null;
      }

      // Always initialize swiper since we always have 4 slots to show
      var compareSwiperEl = this.isPDP ? this.$refs.compareSwiper : document.querySelector('.compare-products-swiper');
      if (compareSwiperEl) {
        this.compareSwiper = new core/* default */.Z(compareSwiperEl, compareProductsSwiperConfig);
      }
    },
    addToCart: function addToCart(productHandle) {
      var _this7 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        var response, productData, availableVariant, addResponse, errorData;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Set loading state
              _this7.addingToCart = productHandle;
              _context3.prev = 1;
              _context3.next = 4;
              return fetch("".concat(window.Shopify.routes.root, "products/").concat(productHandle, ".js"));
            case 4:
              response = _context3.sent;
              if (response.ok) {
                _context3.next = 7;
                break;
              }
              throw new Error('Failed to fetch product data');
            case 7:
              _context3.next = 9;
              return response.json();
            case 9:
              productData = _context3.sent;
              // Find the first available variant
              availableVariant = productData.variants.find(function (variant) {
                return variant.available;
              });
              if (availableVariant) {
                _context3.next = 13;
                break;
              }
              throw new Error('Product is out of stock');
            case 13:
              _context3.next = 15;
              return fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: [{
                    id: availableVariant.id,
                    quantity: 1
                  }]
                })
              });
            case 15:
              addResponse = _context3.sent;
              if (addResponse.ok) {
                _context3.next = 21;
                break;
              }
              _context3.next = 19;
              return addResponse.json();
            case 19:
              errorData = _context3.sent;
              throw new Error(errorData.message || errorData.description || 'Failed to add to cart');
            case 21:
              if (!(_this7.isPDP && _this7.$store && _this7.$store.cart)) {
                _context3.next = 26;
                break;
              }
              _context3.next = 24;
              return _this7.$store.cart.fetchCart();
            case 24:
              _context3.next = 29;
              break;
            case 26:
              if (!(window.Alpine && window.Alpine.store('cart'))) {
                _context3.next = 29;
                break;
              }
              _context3.next = 29;
              return window.Alpine.store('cart').fetchCart();
            case 29:
              _context3.next = 35;
              break;
            case 31:
              _context3.prev = 31;
              _context3.t0 = _context3["catch"](1);
              // eslint-disable-next-line no-console
              console.error('Error adding to cart:', _context3.t0);
              alert(_context3.t0.message || 'Failed to add product to cart');
            case 35:
              _context3.prev = 35;
              // Clear loading state
              _this7.addingToCart = null;
              return _context3.finish(35);
            case 38:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 31, 35, 38]]);
      }))();
    },
    announceCount: function announceCount() {
      // Update aria-live region for screen readers
      var ariaLive = document.querySelector('[data-compare-count-live]');
      if (ariaLive) {
        ariaLive.textContent = "".concat(this.selectedCount, " products selected for comparison");
      }
    },
    // PDP-specific method for keyboard navigation
    handleKeydown: function handleKeydown(event) {
      if (!this.isPDP) return;

      // Handle keyboard navigation for accessibility
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        var checkbox = event.target.querySelector('input[type="checkbox"]') || event.target;
        if (checkbox && !checkbox.disabled) {
          var productData = this.getProductDataFromElement(checkbox);
          if (productData) {
            this.toggleProduct(productData);
          }
        }
      }
    },
    // PDP-specific method to get product data from DOM element
    getProductDataFromElement: function getProductDataFromElement(element) {
      var _productCard$dataset$, _productCard$dataset$2;
      if (!this.isPDP) return null;
      var productCard = element.closest('[data-product-card]');
      if (!productCard) return null;
      return {
        id: parseInt(element.dataset.productId),
        title: productCard.dataset.productTitle || '',
        image: productCard.dataset.productImage || '',
        url: productCard.dataset.productUrl || '#',
        price: productCard.dataset.productPrice || null,
        handle: ((_productCard$dataset$ = productCard.dataset.productUrl) === null || _productCard$dataset$ === void 0 ? void 0 : (_productCard$dataset$2 = _productCard$dataset$.split('/products/')[1]) === null || _productCard$dataset$2 === void 0 ? void 0 : _productCard$dataset$2.split('?')[0]) || '',
        form: productCard.dataset.productForm || 'N/A',
        suggestedUse: productCard.dataset.productSuggestedUse || 'N/A',
        supplyPerBottle: productCard.dataset.productSupplyPerBottle || 'N/A',
        keyIngredients: productCard.dataset.productKeyIngredients || 'N/A',
        certifications: productCard.dataset.productCertifications || 'N/A',
        allergenInfo: productCard.dataset.productAllergenInfo || 'N/A',
        pricePerServing: productCard.dataset.productPricePerServing || 'N/A',
        benefits: productCard.dataset.productBenefits || 'N/A',
        starRating: productCard.dataset.productStarRating || '',
        reviewCount: productCard.dataset.productReviewCount || 0,
        priceMin: productCard.dataset.productPriceMin,
        priceMax: productCard.dataset.productPriceMax,
        variantsCount: productCard.dataset.productVariantsCount
      };
    },
    destroy: function destroy() {
      // Clean up main swiper (PDP only)
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }

      // Clean up compare swiper
      if (this.compareSwiper) {
        this.compareSwiper.destroy(true, true);
        this.compareSwiper = null;
      }

      // Remove resize handler (PDP only)
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
        this.resizeHandler = null;
      }

      // Remove page navigation listeners
      if (this.beforeUnloadHandler) {
        window.removeEventListener('beforeunload', this.beforeUnloadHandler);
        this.beforeUnloadHandler = null;
      }
      if (this.pageShowHandler) {
        window.removeEventListener('pageshow', this.pageShowHandler);
        this.pageShowHandler = null;
      }

      // Clean up global reference (PLP only)
      if (!this.isPDP && window.plpCompareComponent === this) {
        window.plpCompareComponent = null;
      }
    }
  };
};

// Factory functions for different contexts
var plpCompareComponent = function plpCompareComponent() {
  return unifiedCompareComponent({
    isPDP: false
  });
};
var pdpCompareComponent = function pdpCompareComponent() {
  return unifiedCompareComponent({
    isPDP: true,
    hasProductGrid: true
  });
};

;// CONCATENATED MODULE: ./src/js/utils/products-and-collections.js



function products_and_collections_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function products_and_collections_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? products_and_collections_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : products_and_collections_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var products_and_collections_window = window,
  products_and_collections_STOREFRONT_ACCESS_TOKEN = products_and_collections_window.STOREFRONT_ACCESS_TOKEN;

// https://github.com/sindresorhus/p-defer/blob/0abf7f56337a450cbff45074dd8c83f8ace4726c/index.js
var products_and_collections_pDefer = function pDefer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};
var STOREFRONT_PRODUCT_QUERY = /* GraphQL */"\n  fragment ProductFields on Product {\n    id\n    title\n    description\n    handle\n    tags\n    onlineStoreUrl\n    availableForSale\n    productType\n    options {\n      id\n      name\n      values\n    }\n    priceRange {\n      maxVariantPrice {\n        amount\n        currencyCode\n      }\n      minVariantPrice {\n        amount\n        currencyCode\n      }\n    }\n\n    compareAtPriceRange {\n      maxVariantPrice {\n        amount\n        currencyCode\n      }\n      minVariantPrice {\n        amount\n        currencyCode\n      }\n    }\n\n    category: metafield(namespace: \"custom\", key: \"category\") {\n      value\n    }\n\n    color: metafield(namespace: \"custom\", key: \"color\") {\n      value\n    }\n\n    images(first: 2) {\n      nodes {\n        id\n        altText\n        url\n      }\n    }\n\n    variants(first: 250) {\n      nodes {\n        id\n        sku\n        quantityAvailable\n        availableForSale\n        title\n\n        price {\n          amount\n          currencyCode\n        }\n\n        compareAtPrice {\n          amount\n          currencyCode\n        }\n\n        selectedOptions {\n          name\n          value\n        }\n\n        image {\n          url\n        }\n\n        metafield(namespace: \"custom\", key: \"color_swatch\") {\n          reference {\n            ... on Metaobject {\n              color_name: field(key: \"name\") {\n                value\n              }\n              color_code: field(key: \"color_code\") {\n                value\n              }\n              color_gradient: field(key: \"color_gradient\") {\n                value\n              }\n              color_image: field(key: \"image\") {\n                reference {\n                  ... on MediaImage {\n                    image {\n                      url\n                      altText\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        sellingPlanAllocations(first: 10) {\n          nodes {\n            priceAdjustments {\n              compareAtPrice {\n                amount\n                currencyCode\n              }\n              price {\n                amount\n                currencyCode\n              }\n            }\n            sellingPlan {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n\n    sellingPlanGroups(first: 10) {\n      nodes {\n        name\n        sellingPlans(first: 10) {\n          nodes {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n";
var STOREFRONT_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCT_QUERY, "\n  query Products(\n    $country: CountryCode!\n    $id1: ID!\n    $include2: Boolean!\n    $id2: ID\n    $include3: Boolean!\n    $id3: ID\n    $include4: Boolean!\n    $id4: ID\n    $include5: Boolean!\n    $id5: ID\n    $include6: Boolean!\n    $id6: ID\n    $include7: Boolean!\n    $id7: ID\n    $include8: Boolean!\n    $id8: ID\n    $include9: Boolean!\n    $id9: ID\n    $include10: Boolean!\n    $id10: ID\n  ) @inContext(country: $country) {\n    p1: product(id: $id1) {\n      ...ProductFields\n    }\n    p2: product(id: $id2) @include(if: $include2) {\n      ...ProductFields\n    }\n    p3: product(id: $id3) @include(if: $include3) {\n      ...ProductFields\n    }\n    p4: product(id: $id4) @include(if: $include4) {\n      ...ProductFields\n    }\n    p5: product(id: $id5) @include(if: $include5) {\n      ...ProductFields\n    }\n    p6: product(id: $id6) @include(if: $include6) {\n      ...ProductFields\n    }\n    p7: product(id: $id7) @include(if: $include7) {\n      ...ProductFields\n    }\n    p8: product(id: $id8) @include(if: $include8) {\n      ...ProductFields\n    }\n    p9: product(id: $id9) @include(if: $include9) {\n      ...ProductFields\n    }\n    p10: product(id: $id10) @include(if: $include10) {\n      ...ProductFields\n    }\n  }\n");
var productsData = {};
var variantsData = {};
var productsToFetch = new Set();
var productsInProgress = {};
var fetchDataBackground = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(ids, query, dataObject, inProgressDataObject, processItemFunction) {
    var chunks;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(ids.size === 0)) {
            _context2.next = 3;
            break;
          }
          // eslint-disable-next-line no-console
          console.warn('No data to fetch');
          return _context2.abrupt("return");
        case 3:
          chunks = arrayChunk((0,toConsumableArray/* default */.Z)(ids), 10);
          _context2.next = 6;
          return Promise.all(chunks.map( /*#__PURE__*/function () {
            var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(chunk) {
              var variables, data, error, res, _yield$res$json, d, errors;
              return regenerator_default().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    variables = new Array(10).fill().reduce(function (acc, _, index) {
                      var id = chunk[index];
                      acc["id".concat(index + 1)] = id;
                      acc["include".concat(index + 1)] = !!id;
                      return acc;
                    }, {});
                    variables.country = Shopify.country;
                    _context.prev = 2;
                    _context.next = 5;
                    return fetch("https://".concat(Shopify.shop, "/api/2023-07/graphql.json"), {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': products_and_collections_STOREFRONT_ACCESS_TOKEN
                      },
                      body: JSON.stringify({
                        query: query,
                        variables: variables
                      })
                    });
                  case 5:
                    res = _context.sent;
                    _context.next = 8;
                    return res.json();
                  case 8:
                    _yield$res$json = _context.sent;
                    d = _yield$res$json.data;
                    errors = _yield$res$json.errors;
                    data = d;
                    if (!errors) {
                      _context.next = 14;
                      break;
                    }
                    throw new Error("Failed to fetch: ".concat(errors.map(function (error) {
                      return error.message;
                    }).join(', ')));
                  case 14:
                    _context.next = 20;
                    break;
                  case 16:
                    _context.prev = 16;
                    _context.t0 = _context["catch"](2);
                    // eslint-disable-next-line no-console
                    console.error(error);
                    error = _context.t0;
                  case 20:
                    if (!error) {
                      Object.values(data).filter(Boolean).forEach(processItemFunction);
                    }
                    chunk.forEach(function (id) {
                      var product = dataObject[id];
                      if (product) {
                        inProgressDataObject[id].resolve(product);
                      } else {
                        var err = error || new Error("".concat(id, " not found"));
                        inProgressDataObject[id].reject(err);
                      }
                      delete inProgressDataObject[id];
                    });
                  case 22:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[2, 16]]);
            }));
            return function (_x6) {
              return _ref2.apply(this, arguments);
            };
          }()));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchDataBackground(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
var fetchData = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(ids, prefix, idsToFetchSet, dataObject, inProgressDataObject, fetchBackgroundFunction) {
    var normalizedIds, idsToFetch, idsInProgress;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          normalizedIds = ids.map(function (id) {
            if (typeof id === 'string' && id.startsWith(prefix)) {
              return id;
            }
            if (typeof id === 'number' || typeof id === 'string' && /^\d+$/.test(id)) {
              return "".concat(prefix).concat(id);
            }
          }).filter(Boolean);
          idsToFetch = normalizedIds.filter(function (id) {
            return !dataObject[id] && !inProgressDataObject[id];
          });
          idsToFetch.forEach(function (id) {
            idsToFetchSet.add(id);
            inProgressDataObject[id] = products_and_collections_pDefer();
          });
          idsInProgress = normalizedIds.filter(function (id) {
            return inProgressDataObject[id];
          });
          if (idsToFetch.length > 0) {
            fetchBackgroundFunction();
          }
          if (!(idsInProgress.length > 0)) {
            _context3.next = 8;
            break;
          }
          _context3.next = 8;
          return Promise.all(idsInProgress.map(function (id) {
            return inProgressDataObject[id].promise;
          }));
        case 8:
          return _context3.abrupt("return", dataObject);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function fetchData(_x7, _x8, _x9, _x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}();
var priceFormatters = {};
var getPriceFormatter = function getPriceFormatter(currency) {
  if (!priceFormatters[currency]) {
    priceFormatters[currency] = new Intl.NumberFormat(Shopify.locale, {
      style: 'currency',
      currency: currency
    });
  }
  return priceFormatters[currency];
};
var formatPrice = function formatPrice(price) {
  var ignoreZeros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (ignoreZeros && Number(price.amount) === 0) {
    return '';
  }
  var priceFormatter = getPriceFormatter(price.currencyCode);
  return priceFormatter.format(price.amount);
};
var formatPriceRange = function formatPriceRange(min, max) {
  var ignoreZeros = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (min.amount === max.amount) {
    return formatPrice(min, ignoreZeros);
  }
  var priceFormatter = getPriceFormatter(min.currencyCode);
  if (priceFormatter.formatRange) {
    return priceFormatter.formatRange(min.amount, max.amount);
  }
  return "".concat(priceFormatter.format(min.amount), " - ").concat(priceFormatter.format(max.amount));
};
var formatProductPrices = function formatProductPrices(product) {
  var _product$sellingPlanG, _product$sellingPlanG2;
  product.priceRangeFormatted = formatPriceRange(product.priceRange.minVariantPrice, product.priceRange.maxVariantPrice);
  product.compareAtPriceRangeFormatted = formatPriceRange(product.compareAtPriceRange.minVariantPrice, product.compareAtPriceRange.maxVariantPrice, true);
  product.variants.forEach(function (variant) {
    var _variant$sellingPlanA, _variant$sellingPlanA2;
    variant.priceFormatted = formatPrice(variant.price);
    if (variant.compareAtPrice) {
      variant.compareAtPriceFormatted = formatPrice(variant.compareAtPrice, true);
    }

    // Add subscription pricing from selling plan allocations
    if (((_variant$sellingPlanA = variant.sellingPlanAllocations) === null || _variant$sellingPlanA === void 0 ? void 0 : (_variant$sellingPlanA2 = _variant$sellingPlanA.nodes) === null || _variant$sellingPlanA2 === void 0 ? void 0 : _variant$sellingPlanA2.length) > 0) {
      var _firstAllocation$pric;
      var firstAllocation = variant.sellingPlanAllocations.nodes[0];
      if ((_firstAllocation$pric = firstAllocation.priceAdjustments) !== null && _firstAllocation$pric !== void 0 && _firstAllocation$pric.price) {
        variant.sellingPlanAllocationsPrice = formatPrice(firstAllocation.priceAdjustments.price);
      }
    }
  });

  // Add selling plan groups processing
  if (((_product$sellingPlanG = product.sellingPlanGroups) === null || _product$sellingPlanG === void 0 ? void 0 : (_product$sellingPlanG2 = _product$sellingPlanG.nodes) === null || _product$sellingPlanG2 === void 0 ? void 0 : _product$sellingPlanG2.length) > 0) {
    product.sellingPlanGroups = product.sellingPlanGroups.nodes.map(function (group) {
      return products_and_collections_objectSpread(products_and_collections_objectSpread({}, group), {}, {
        selling_plans: group.sellingPlans.nodes
      });
    });
  }
};
var fetchProductsBackground = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var productsToFetchSet;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          productsToFetchSet = productsToFetch;
          productsToFetch = new Set();
          return _context4.abrupt("return", fetchDataBackground(productsToFetchSet, STOREFRONT_PRODUCTS_QUERY, productsData, productsInProgress, function (product) {
            product.variants = product.variants.nodes;
            formatProductPrices(product);
            product.images = product.images.nodes;
            productsData[product.id] = product;
            productsData[product.id.replace('gid://shopify/Product/', '')] = product;
            // product.variants.forEach((variant) => {
            //   variant.product = product;
            //   variantsData[variant.id] = variant;
            //   variantsData[variant.id.replace('gid://shopify/ProductVariant/', '')] = variant;
            // });
          }));
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function fetchProductsBackground() {
    return _ref4.apply(this, arguments);
  };
}();
var fetchProductsBackgroundDebounced = createDebouncer(function (cb) {
  return setTimeout(cb, 0);
})(fetchProductsBackground);
var fetchProducts = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(ids) {
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", fetchData(ids, 'gid://shopify/Product/', productsToFetch, productsData, productsInProgress, fetchProductsBackgroundDebounced));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function fetchProducts(_x13) {
    return _ref5.apply(this, arguments);
  };
}();
var STOREFRONT_PRODUCTS_AND_FILTERS = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCT_QUERY, "\n\n  fragment FilterFields on Filter {\n    id\n    label\n    type\n    values {\n      id\n      label\n      count\n      input\n    }\n  }\n\n  fragment PageInfoFields on PageInfo {\n    hasPreviousPage\n    hasNextPage\n    endCursor\n  }\n");
var FETCH_COLLECTION_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCTS_AND_FILTERS, "\n\n  query Collection(\n    $handle: String\n    $afterCursor: String\n    $noOfProducts: Int!\n    $filtersArray: [ProductFilter!]\n    $sortField: ProductCollectionSortKeys\n    $reverse: Boolean\n  ) {\n    collection(handle: $handle) {\n      handle\n      products(\n        first: $noOfProducts\n        after: $afterCursor\n        filters: $filtersArray\n        sortKey: $sortField\n        reverse: $reverse\n      ) {\n        nodes {\n          ...ProductFields\n        }\n        filters {\n          ...FilterFields\n        }\n        pageInfo {\n          ...PageInfoFields\n        }\n      }\n      metafields(identifiers: { key: \"collection_cards\", namespace: \"custom\" }) {\n        references(first: 10) {\n          nodes {\n            ... on Metaobject {\n              id\n              cta_link: field(key: \"cta_link\") {\n                reference {\n                  ... on Page {\n                    handle\n                    onlineStoreUrl\n                  }\n                }\n              }\n              cta_text: field(key: \"cta_text\") {\n                value\n              }\n              block_position: field(key: \"block_position\") {\n                value\n              }\n              asset: field(key: \"asset\") {\n                reference {\n                  ... on MediaImage {\n                    image {\n                      url\n                      width\n                      height\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n");
var FETCH_SEARCH_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCTS_AND_FILTERS, "\n\n  query Search(\n    $query: String!\n    $afterCursor: String\n    $noOfProducts: Int!\n    $filtersArray: [ProductFilter!]\n    $sortField: SearchSortKeys\n    $reverse: Boolean\n  ) {\n    products: search(\n      query: $query\n      first: $noOfProducts\n      after: $afterCursor\n      productFilters: $filtersArray\n      sortKey: $sortField\n      reverse: $reverse\n      types: [PRODUCT]\n      prefix: LAST\n    ) {\n      nodes {\n        ...ProductFields\n      }\n      productFilters {\n        ...FilterFields\n      }\n      pageInfo {\n        ...PageInfoFields\n      }\n      totalCount\n    }\n  }\n");
var FETCH_RECOMMENDED_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCT_QUERY, "\n\n  query ProductRecommendations($intent: ProductRecommendationIntent, $productId: ID!) {\n    productRecommendations(intent: $intent, productId: $productId) {\n      ...ProductFields\n    }\n  }\n");
var FETCH_SWATCHES_VALUES_QUERY = "\nquery {\n  metaobjects(type: \"color_metaobject\", first: 20) {\n    nodes {\n      color_name: field(key: \"name\") {\n        value\n      }\n      color_code: field(key: \"color_code\") {\n        value\n      }\n      color_gradient: field(key: \"color_gradient\") {\n        value\n      }\n      color_image: field(key: \"image\") {\n        reference {\n          ... on MediaImage {\n            image {\n              url\n              altText\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n";
var fetchColorMetaobjectsQuery = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(query) {
    var response, data;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request("https://".concat(Shopify.shop, "/api/2023-07/graphql.json"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': products_and_collections_STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({
              query: query
            })
          });
        case 2:
          response = _context6.sent;
          data = response.data;
          return _context6.abrupt("return", data.metaobjects);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function fetchColorMetaobjectsQuery(_x14) {
    return _ref6.apply(this, arguments);
  };
}();
var fetchProductsWithQuery = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(query, variables, getObjectWithProducts) {
    var _objectWithProducts$p;
    var normalize,
      response,
      data,
      objectWithProducts,
      products,
      _args7 = arguments;
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          normalize = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : function () {};
          _context7.next = 3;
          return request("https://".concat(Shopify.shop, "/api/2023-07/graphql.json"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': products_and_collections_STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({
              query: query,
              variables: variables
            })
          });
        case 3:
          response = _context7.sent;
          data = response.data;
          objectWithProducts = getObjectWithProducts(data);
          normalize(objectWithProducts);
          products = (objectWithProducts === null || objectWithProducts === void 0 ? void 0 : (_objectWithProducts$p = objectWithProducts.products) === null || _objectWithProducts$p === void 0 ? void 0 : _objectWithProducts$p.nodes) || [];
          products.forEach(function (product) {
            product.variants = product.variants.nodes;
            formatProductPrices(product);
            product.images = product.images.nodes;
            productsData[product.id] = product;
            productsData[product.id.replace('gid://shopify/Product/', '')] = product;
          });
          return _context7.abrupt("return", objectWithProducts);
        case 10:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function fetchProductsWithQuery(_x15, _x16, _x17) {
    return _ref7.apply(this, arguments);
  };
}();
var fetchCollection = /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(collectionHandle) {
    var afterCursor,
      noOfProducts,
      filtersArray,
      sortField,
      reverse,
      _args8 = arguments;
    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          afterCursor = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
          noOfProducts = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : 12;
          filtersArray = _args8.length > 3 ? _args8[3] : undefined;
          sortField = _args8.length > 4 ? _args8[4] : undefined;
          reverse = _args8.length > 5 ? _args8[5] : undefined;
          return _context8.abrupt("return", fetchProductsWithQuery(FETCH_COLLECTION_PRODUCTS_QUERY, {
            handle: collectionHandle,
            afterCursor: afterCursor,
            noOfProducts: noOfProducts,
            filtersArray: filtersArray,
            sortField: sortField,
            reverse: reverse
          }, function (data) {
            return data.collection;
          }));
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fetchCollection(_x18) {
    return _ref8.apply(this, arguments);
  };
}();
var fetchSearch = /*#__PURE__*/function () {
  var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(query) {
    var afterCursor,
      noOfProducts,
      filtersArray,
      sortField,
      reverse,
      _args9 = arguments;
    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          afterCursor = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
          noOfProducts = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 12;
          filtersArray = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : [];
          sortField = _args9.length > 4 && _args9[4] !== undefined ? _args9[4] : 'RELEVANCE';
          reverse = _args9.length > 5 && _args9[5] !== undefined ? _args9[5] : false;
          return _context9.abrupt("return", fetchProductsWithQuery(FETCH_SEARCH_PRODUCTS_QUERY, {
            query: query,
            afterCursor: afterCursor,
            noOfProducts: noOfProducts,
            filtersArray: filtersArray,
            sortField: sortField,
            reverse: reverse
          }, function (data) {
            return data;
          }, function (search) {
            search.products.filters = search.products.productFilters;
            delete search.products.productFilters;
          }));
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function fetchSearch(_x19) {
    return _ref9.apply(this, arguments);
  };
}();
var fetchRecommendedProducts = /*#__PURE__*/function () {
  var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10(intent, productId) {
    return regenerator_default().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", fetchProductsWithQuery(FETCH_RECOMMENDED_PRODUCTS_QUERY, {
            intent: intent,
            productId: productId
          }, function (data) {
            return {
              products: {
                nodes: data.productRecommendations || []
              }
            };
          }));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function fetchRecommendedProducts(_x20, _x21) {
    return _ref10.apply(this, arguments);
  };
}();
var fetchColorMetaobjects = /*#__PURE__*/function () {
  var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
    return regenerator_default().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", fetchColorMetaobjectsQuery(FETCH_SWATCHES_VALUES_QUERY));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function fetchColorMetaobjects() {
    return _ref11.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/js/bundles/snippets/product-card.js

var productCard = function productCard(productId) {
  return {
    loading: false,
    error: '',
    productId: productId,
    get shopifyData() {
      if (!this.productId) return null;
      if (this.loading) return null;
      return productsData[this.productId];
    },
    get link() {
      var _this$shopifyData;
      if (!this.shopifyData) return '/';
      return "".concat(window.Shopify.routes.root, "products/").concat((_this$shopifyData = this.shopifyData) === null || _this$shopifyData === void 0 ? void 0 : _this$shopifyData.handle);
    },
    get images() {
      var _this$shopifyData2;
      return ((_this$shopifyData2 = this.shopifyData) === null || _this$shopifyData2 === void 0 ? void 0 : _this$shopifyData2.images) || [];
    },
    get description() {
      var _this$shopifyData3;
      return (_this$shopifyData3 = this.shopifyData) === null || _this$shopifyData3 === void 0 ? void 0 : _this$shopifyData3.description;
    },
    get productReviewCount() {
      var _this$shopifyData4, _this$shopifyData4$ra;
      var rating = (_this$shopifyData4 = this.shopifyData) === null || _this$shopifyData4 === void 0 ? void 0 : (_this$shopifyData4$ra = _this$shopifyData4.ratingCount) === null || _this$shopifyData4$ra === void 0 ? void 0 : _this$shopifyData4$ra.value;
      var ratingNormalized = Number(rating) || 0;
      return "".concat(ratingNormalized, " Review").concat(ratingNormalized === 1 ? '' : 's');
    },
    get qualifiersParsed() {
      var qualifiers = this.shopifyData.qualifiers;
      if (!(qualifiers !== null && qualifiers !== void 0 && qualifiers.value)) return '';
      try {
        return JSON.parse(qualifiers.value).join(' ');
      } catch (e) {
        return '';
      }
    },
    get title() {
      var _this$shopifyData5;
      var description = this.shopifyData.description;
      if (description !== null && description !== void 0 && description.value) return description.value;
      return "".concat(this.qualifiersParsed, " ").concat((_this$shopifyData5 = this.shopifyData) === null || _this$shopifyData5 === void 0 ? void 0 : _this$shopifyData5.type.value);
    },
    get starRating() {
      var _this$shopifyData6;
      return (_this$shopifyData6 = this.shopifyData) === null || _this$shopifyData6 === void 0 ? void 0 : _this$shopifyData6.starRatingSnippet;
    },
    get legacyTitle() {
      var _this$shopifyData7;
      return (_this$shopifyData7 = this.shopifyData) === null || _this$shopifyData7 === void 0 ? void 0 : _this$shopifyData7.title;
    },
    get extractProductId() {
      // Split the string by the '/' character and get the last part
      var gid = this.productId;
      var parts = gid.split('/');
      return parts[parts.length - 1];
    },
    get okendoRating() {
      return 'shopify-' + this.extractProductId;
    },
    get price() {
      var _this$shopifyData8;
      return (_this$shopifyData8 = this.shopifyData) === null || _this$shopifyData8 === void 0 ? void 0 : _this$shopifyData8.priceRangeFormatted;
    },
    get priceRegular() {
      var _this$shopifyData9;
      return (_this$shopifyData9 = this.shopifyData) === null || _this$shopifyData9 === void 0 ? void 0 : _this$shopifyData9.compareAtPriceRangeFormatted;
    },
    get hasReducedPrice() {
      var priceRegular = this.priceRegular,
        price = this.price;
      return priceRegular && priceRegular !== price;
    },
    get pricingText() {
      return "reduced price: ".concat(this.price, ", regular price: ").concat(this.priceRegular);
    },
    get pricingExtraText() {
      var tags = this.shopifyData.tags;
      var tag = tags.find(function (tag) {
        return tag.startsWith('Off:');
      });
      if (!tag) return '';
      var pct = tag.replace('Off:', '');
      return "Extra ".concat(pct, "% off on Checkout");
    },
    get quickBuyTitle() {
      var _shopifyData$seasonal;
      var shopifyData = this.shopifyData;
      if (shopifyData.availableForSale) {
        return 'Add To Bag';
      }
      if (shopifyData.tags.includes('Coming Soon') || ((_shopifyData$seasonal = shopifyData.seasonalCore) === null || _shopifyData$seasonal === void 0 ? void 0 : _shopifyData$seasonal.value) === 'Core') {
        return 'Notify Me';
      }
      return 'Sold Out';
    },
    get isSoldOut() {
      return this.quickBuyTitle === 'Sold Out';
    },
    get variantsCount() {
      var _this$shopifyData10;
      return "".concat((_this$shopifyData10 = this.shopifyData) === null || _this$shopifyData10 === void 0 ? void 0 : _this$shopifyData10.variants.length, " variant(s)");
    },
    init: function init() {
      var _this = this;
      if (!this.shopifyData) {
        this.loading = true;
        fetchProducts([this.productId]).then(function () {
          _this.loading = false;
        })["catch"](function (e) {
          _this.error = "Error: ".concat(e.message || 'Unknown error');
        });
      }
    }
  };
};
/* harmony default export */ const product_card = (productCard);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(885);
// EXTERNAL MODULE: ./node_modules/lodash.keyby/index.js
var lodash_keyby = __webpack_require__(587);
var lodash_keyby_default = /*#__PURE__*/__webpack_require__.n(lodash_keyby);
// EXTERNAL MODULE: ./node_modules/just-compare/index.mjs
var just_compare = __webpack_require__(147);
// EXTERNAL MODULE: ./node_modules/just-clone/index.mjs
var just_clone = __webpack_require__(508);
;// CONCATENATED MODULE: ./src/js/bundles/sections/products-browser.js





function products_browser_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function products_browser_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? products_browser_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : products_browser_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var RESULTS_PER_PAGE = 12;
var productsBrowser = function productsBrowser(context, collectionHandle) {
  return {
    context: context,
    isLoading: false,
    isLoadingInitial: true,
    // data will be Shopify StoreFront API response
    // https://shopify.dev/docs/custom-storefronts/building-with-the-storefront-api/products-collections/filter-products#step-1-query-products
    data: null,
    error: '',
    activeFacets: {},
    activeFacetsOld: {},
    sort: '',
    sortOld: '',
    currentPage: 1,
    loadId: 0,
    ignoreUpdates: false,
    filtersDesktopVisible: true,
    printCollectionsState: {},
    afterCursor: null,
    currentFilters: {},
    filtersObj: {},
    swatchesMetaobjectIds: {},
    swatchesMetaobjectKeys: {},
    sortingOptions: [context === 'collection' && {
      field: 'BEST_SELLING',
      direction: 'desc',
      label: 'Bestsellers',
      reverse: false
    }, {
      field: 'RELEVANCE',
      label: 'Relevance',
      direction: 'desc',
      reverse: false
    }, {
      field: 'PRICE',
      direction: 'asc',
      label: 'Price Low to High',
      reverse: false
    }, {
      field: 'PRICE',
      direction: 'desc',
      label: 'Price High to Low',
      reverse: true
    }].filter(Boolean),
    get products() {
      var _this$data;
      var products = (((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.products.nodes) || []).map(function (node) {
        return {
          product: node,
          type: 'product'
        };
      });
      // Commenting as this causes the search to break
      // const collectionFields = this.data.metafields[0]?.references.nodes.map((node) => {
      //   const order = parseInt(node?.block_position.value) - 1;
      //   if (order >= 0) {
      //     products.splice(order, 0, { product: node, type: 'collection-card' });
      //   }
      // });
      return products;
    },
    get facets() {
      var _this$data2,
        _this = this;
      var filters = (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.products.filters;
      var result = (filters || []).map(function (facet) {
        if (_this.activeFacets[facet.id] && _this.activeFacets[facet.id].length) {
          facet.expanded = true;
        }
        if (facet.id.startsWith('filter.v.m.custom.color_swatch')) {
          facet.type = 'SWATCH';
          facet.values = facet.values.map(function (value) {
            var m = _this.swatchesMetaobjectIds;
            var _JSON$parse = JSON.parse(value.input),
              variantMetafield = _JSON$parse.variantMetafield;
            var swatchObj = m[variantMetafield.value];
            return products_browser_objectSpread(products_browser_objectSpread({}, value), {}, {
              swatch: swatchObj
            });
          });
        } else if (facet.id === 'filter.v.availability') {
          facet.type = 'RADIO';
        }
        return facet;
      });
      this.filtersObj = lodash_keyby_default()(result, 'id');
      return result || [];
    },
    get hasLoadMore() {
      var _this$data3, _this$data3$products;
      var pageInfo = (_this$data3 = this.data) === null || _this$data3 === void 0 ? void 0 : (_this$data3$products = _this$data3.products) === null || _this$data3$products === void 0 ? void 0 : _this$data3$products.pageInfo;
      return pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage;
    },
    get hasNoActiveFacetsAndEmptyResults() {
      if (this.isLoadingInitial || this.isLoading) return false;
      return this.products.length === 0 && Object.values(this.activeFacets).every(function (value) {
        return !value.length;
      });
    },
    init: function init() {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.debounceNextTick = createDebouncer(_this2.$nextTick.bind(_this2));
              _this2.setStateFromUrl();
              _context.prev = 2;
              _context.next = 5;
              return _this2.queryProducts();
            case 5:
              _context.prev = 5;
              _this2.isLoadingInitial = false;
              return _context.finish(5);
            case 8:
              _this2.$watch('activeFacets', _this2.debounceNextTick(function (value) {
                // we have the code that in some cases updated the activeFacets immediately
                // so we wait one tick before fetching products

                if (_this2.ignoreUpdates) return;
                if (_this2.hasNoActiveFacetsAndEmptyResults) return;
                // TODO: UI for this
                if (!(0,just_compare/* default */.Z)(value, _this2.activeFacetsOld)) {
                  _this2.currentPage = 1;
                  _this2.queryProducts();
                }
              }));
              _this2.$watch('ignoreUpdates', function (value) {
                if (value) {
                  _this2.activeFacetsCopy = (0,just_clone/* default */.Z)(_this2.activeFacets);
                  _this2.sortCopy = _this2.sort;
                } else {
                  _this2.activeFacets = _this2.activeFacetsCopy;
                  _this2.sort = _this2.sortCopy;
                }
              });
              _this2.$watch('sort', function (value) {
                if (value === _this2.sortOld) return;
                if (_this2.ignoreUpdates) return;
                _this2.queryProducts();
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2,, 5, 8]]);
      }))();
    },
    queryProducts: function queryProducts() {
      var _arguments = arguments,
        _this3 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _ref, _ref$loadMore, loadMore, loadId, _this3$sort$split, _this3$sort$split2, sortField, sortDirection, searchParams, reverse, swatches, swatchesNode, swatchesIDs, swatchesKeys, filtersArray, args, data, oldData;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$loadMore = _ref.loadMore, loadMore = _ref$loadMore === void 0 ? false : _ref$loadMore;
              loadId = ++_this3.loadId;
              _this3$sort$split = _this3.sort.split('::'), _this3$sort$split2 = (0,slicedToArray/* default */.Z)(_this3$sort$split, 2), sortField = _this3$sort$split2[0], sortDirection = _this3$sort$split2[1];
              searchParams = new URLSearchParams({
                page: _this3.currentPage
              });
              if (context === 'search-results') {
                searchParams.set('q', new URLSearchParams(window.location.search).get('q') || '');
              }
              reverse = false; // to reverse the price sorting
              if (sortField && sortDirection) {
                searchParams.append("sort.".concat(sortField), sortDirection);
                if (sortField === 'PRICE' && sortDirection === 'desc') {
                  reverse = true;
                }
              }
              _context2.next = 9;
              return fetchColorMetaobjects();
            case 9:
              swatches = _context2.sent;
              if (swatches) {
                swatchesNode = swatches.nodes;
                swatchesIDs = lodash_keyby_default()(swatchesNode, 'id');
                swatchesKeys = lodash_keyby_default()(swatchesNode, 'color_name.value');
                Object.assign(_this3.swatchesMetaobjectIds, swatchesIDs);
                Object.assign(_this3.swatchesMetaobjectKeys, swatchesKeys);
              }
              filtersArray = []; // take the activefacets and convert into filtersArray which would be fed into the collection query
              Object.entries(_this3.activeFacets).forEach(function (_ref2) {
                var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
                  key = _ref3[0],
                  values = _ref3[1];
                // filtersObj will have value when we go for filtering but not when we are reloading the page.
                if (values && values.length) {
                  values.forEach(function (value) {
                    var productMetafieldRegex = new RegExp(/filter.p.m.([\w]+).([\w]+)/);
                    if (key.match(productMetafieldRegex)) {
                      // eslint-disable-next-line
                      var _key$match = key.match(productMetafieldRegex),
                        _key$match2 = (0,slicedToArray/* default */.Z)(_key$match, 3),
                        _ = _key$match2[0],
                        namespace = _key$match2[1],
                        mfKey = _key$match2[2];
                      filtersArray.push({
                        productMetafield: {
                          namespace: namespace,
                          key: mfKey,
                          value: value
                        }
                      });
                      searchParams.append(key, value);
                    }
                    var variantMetafieldRegex = new RegExp(/filter.v.option.([\w]+)/);
                    if (key.match(variantMetafieldRegex)) {
                      // eslint-disable-next-line
                      var _key$match3 = key.match(variantMetafieldRegex),
                        _key$match4 = (0,slicedToArray/* default */.Z)(_key$match3, 2),
                        _2 = _key$match4[0],
                        name = _key$match4[1];
                      filtersArray.push({
                        variantOption: {
                          name: name,
                          value: value
                        }
                      });
                      searchParams.append(key, value);
                    }
                    var productVariantMetafieldRegex = new RegExp(/filter.v.m.([\w]+).([\w]+)/);
                    if (key.match(productVariantMetafieldRegex)) {
                      // eslint-disable-next-line
                      var _key$match5 = key.match(productVariantMetafieldRegex),
                        _key$match6 = (0,slicedToArray/* default */.Z)(_key$match5, 3),
                        _3 = _key$match6[0],
                        _namespace = _key$match6[1],
                        _mfKey = _key$match6[2];
                      searchParams.append(key, value);
                      if (_mfKey === 'color_swatch') {
                        value = _this3.swatchesMetaobjectKeys[value].id;
                      }
                      filtersArray.push({
                        variantMetafield: {
                          namespace: _namespace,
                          key: _mfKey,
                          value: value
                        }
                      });
                    }
                    if (key === 'filter.v.availability') {
                      var valueBoolean = value === 'In stock';
                      filtersArray.push({
                        available: valueBoolean
                      });
                      searchParams.append(key, value);
                    }
                    if (value && key === 'filter.v.price') {
                      var obj = typeof value === 'string' ? JSON.parse(value) : value;
                      filtersArray.push({
                        price: {
                          min: +obj.min,
                          max: +obj.max
                        }
                      });
                      searchParams.append("".concat(key, ".min"), obj.min);
                      searchParams.append("".concat(key, ".max"), obj.max);
                    }
                    if (key === 'filter.v.price.min' || key === 'filter.v.price.max') {
                      // find if there's a key by price if not add to the filtersArray otherwise update the value
                      var priceFilter = filtersArray.find(function (filter) {
                        return filter.price;
                      });
                      if (!priceFilter) {
                        if (key === 'filter.v.price.min') {
                          filtersArray.push({
                            price: {
                              min: value,
                              max: 0
                            }
                          });
                        }
                        filtersArray.push({
                          price: {
                            min: 0,
                            max: 0
                          }
                        });
                      }
                      if (priceFilter) {
                        if (key === 'filter.v.price.min') {
                          priceFilter.price.min = +value;
                        } else {
                          priceFilter.price.max = +value;
                        }
                      }
                    }
                  });
                }
              });
              _this3.activeFacetsOld = (0,just_clone/* default */.Z)(_this3.activeFacets);
              _this3.sortOld = _this3.sort;
              _context2.prev = 15;
              _this3.isLoading = true;
              _this3.error = '';
              args = [context === 'collection' ? collectionHandle : context === 'search-results' ? searchParams.get('q') : '', loadMore ? _this3.afterCursor : null, RESULTS_PER_PAGE, filtersArray, sortField, reverse];
              _context2.next = 21;
              return context === 'collection' ? fetchCollection.apply(void 0, args) : fetchSearch.apply(void 0, args);
            case 21:
              data = _context2.sent;
              _context2.prev = 22;
              _context2.next = 25;
              return fetchProducts(data.products.nodes.map(function (obj) {
                return obj.id;
              }));
            case 25:
              _context2.next = 30;
              break;
            case 27:
              _context2.prev = 27;
              _context2.t0 = _context2["catch"](22);
              // if we fail here we'll retry and display error inside product card
              // eslint-disable-next-line no-console
              console.warn(_context2.t0);
            case 30:
              if (!(loadId !== _this3.loadId)) {
                _context2.next = 32;
                break;
              }
              return _context2.abrupt("return");
            case 32:
              oldData = _this3.data;
              _this3.$dispatch('products-browser-data', {
                searchParams: searchParams,
                data: data
              });
              _this3.data = (0,just_clone/* default */.Z)(data);
              if (loadMore) {
                _this3.data.products.nodes = [].concat((0,toConsumableArray/* default */.Z)(oldData.products.nodes), (0,toConsumableArray/* default */.Z)(_this3.data.products.nodes));
              }
              _this3.activeFacets = products_browser_objectSpread(products_browser_objectSpread({}, _this3.getEmptyFacets()), _this3.activeFacets);
              _this3.activeFacetsOld = (0,just_clone/* default */.Z)(_this3.activeFacets);
              _this3.sortOld = _this3.sort;
              if (_this3.data.products.pageInfo.hasNextPage) {
                _this3.afterCursor = _this3.data.products.pageInfo.endCursor;
              }
              _this3.updateUrl(searchParams);
              _context2.next = 47;
              break;
            case 43:
              _context2.prev = 43;
              _context2.t1 = _context2["catch"](15);
              // TODO: analytics? sentry?
              _this3.error = _context2.t1.message;
              throw _this3.error;
            case 47:
              _context2.prev = 47;
              if (loadId === _this3.loadId) {
                _this3.isLoading = false;
              }
              return _context2.finish(47);
            case 50:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[15, 43, 47, 50], [22, 27]]);
      }))();
    },
    getEmptyFacets: function getEmptyFacets() {
      return Object.fromEntries(this.data.products.filters.map(function (filter) {
        return [filter.id, []];
      }));
    },
    updateUrl: function updateUrl(searchParams) {
      var url = new URL(window.location.href);
      var currentParams = new URLSearchParams(window.location.search);
      url.search = new URLSearchParams(searchParams);
      var firstSort = this.sortingOptions[0];
      if (searchParams.get("sort.".concat(firstSort.field)) === firstSort.direction) {
        url.searchParams["delete"]("sort.".concat(firstSort.field));
      }
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.startsWith('bgfilter.')) {
          url.searchParams["delete"](key);
        }
      });
      url.searchParams["delete"]('page'); // no classic pagination

      var currentParamsEntries = Array.from(currentParams.entries());
      var newParamsEntries = Array.from(url.searchParams.entries());
      if (currentParamsEntries.length !== newParamsEntries.length || currentParamsEntries.some(function (_ref4, index) {
        var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 2),
          value = _ref5[1];
        return value !== newParamsEntries[index][1];
      })) {
        window.history.pushState({}, '', url.toString());
      }
    },
    // to reconstruct the activeFacets object from the queryParams in the URL
    setStateFromUrl: function setStateFromUrl() {
      var _this4 = this;
      var activeFacets = this.data ? this.getEmptyFacets() : {};
      this.currentPage = 1;
      var firstSort = this.sortingOptions[0];
      if (firstSort) {
        this.sort = "".concat(firstSort.field, "::").concat(firstSort.direction);
      }
      /* we need to recreate the object that comes with the activeFacets.
       * so for productMetafields the object is {productMetafield: {namespace: 'custom', key: 'category', value: '<coming from URL param>'}}
       * for variantOption the object is {variantOption: {name: 'size', value: 'S'}}
       * convert filter.p.m.custom.category => {productMetafield: {namespace: 'custom', key: 'category', value: '<coming from URL param>'}}
       * convert filter.v.option.size => variantOption: {name: 'size', value: 'S'}}
       * activeFacets is an object like this
       * {
       * filter.p.m.custom.category: ['Bags']
       * filter.v.option.size: []
       * }
       */
      // we can write simple Regex to convert filter.p.m.custom.category => {productMetafield: {namespace: 'custom', key: 'category', value: '<coming from URL param>'}
      Array.from(new URLSearchParams(window.location.search)).forEach(function (_ref6) {
        var _ref7 = (0,slicedToArray/* default */.Z)(_ref6, 2),
          key = _ref7[0],
          value = _ref7[1];
        if (key.startsWith('filter.')) {
          if (key.includes('filter.v.price')) {
            if (!activeFacets['filter.v.price']) {
              activeFacets['filter.v.price'] = [];
            }
            var priceRegex = new RegExp(/filter.v.price.([\w]+)/);
            var _key$match7 = key.match(priceRegex),
              _key$match8 = (0,slicedToArray/* default */.Z)(_key$match7, 2),
              priceKey = _key$match8[1];
            activeFacets['filter.v.price'].length === 0 ? activeFacets['filter.v.price'].push((0,defineProperty/* default */.Z)({}, priceKey, +value)) : activeFacets['filter.v.price'][0][priceKey] = +value;
          } else if (!activeFacets[key]) {
            activeFacets[key] = [value];
          } else {
            activeFacets[key].push(value);
          }
        } else if (key.startsWith('sort.')) {
          var sortField = key.replace('sort.', '');
          var sortDirection = value;
          _this4.sort = "".concat(sortField, "::").concat(sortDirection);
        } else if (key === 'page') {
          // ignore page from url
          // this.currentPage = Number(value);
        }
      });
      this.activeFacets = activeFacets;
    },
    handlePopstate: function handlePopstate() {
      this.setStateFromUrl();
    },
    loadMore: function loadMore() {
      this.currentPage += 1;
      return this.queryProducts({
        loadMore: true
      });
    },
    clearAllFacets: function clearAllFacets() {
      this.activeFacets = this.getEmptyFacets();
      this.queryProducts();
    },
    removeFilter: function removeFilter(filter) {
      if (Array.isArray(this.activeFacets[filter.field])) {
        this.activeFacets[filter.field] = this.activeFacets[filter.field].filter(function (v) {
          return v !== filter.value;
        });
      } else {
        this.activeFacets[filter.field] = [];
      }
    }
  };
};
/* harmony default export */ const products_browser = (productsBrowser);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/products-browser-facets-wrapper.js



var productsBrowserFacetsWrapper = function productsBrowserFacetsWrapper() {
  return {
    isSpecialOpen: false,
    filterCollectionsCache: {},
    isFiltersDrawerOpen: false,
    get appliedFilters() {
      /**
       * Expected Object Structure
       * {
       *  "p.m.category": ['Bags', 'Shoes'],
       *  "p.m.color": ['Black', 'Blue']
       * }
       * Output
       * [
       *   { field: "p.m.category", value: "Bags" },
       *   { field: "p.m.category", value: "Shoes" },
       *   { field: "p.m.color", value: "Black" },
       *   { field: "p.m.color", value: "Blue" },
       * ]
       */
      var appliedFilters = Object.entries(this.activeFacets).reduce(function (acc, facet) {
        // key = p.m.category & value = ['Bags', 'Shoes']
        acc.push.apply(acc, (0,toConsumableArray/* default */.Z)(Object.values(facet[1]).filter(function (value) {
          return value !== '';
        }).map(function (value) {
          return {
            field: facet[0],
            value: value
          };
        })));
        return acc;
      }, []);
      return appliedFilters;
    },
    get facetCount() {
      return this.appliedFilters.length;
    },
    handleMobileOpen: function handleMobileOpen() {
      this.isFiltersDrawerOpen = true;
    },
    handleMobileClose: function handleMobileClose() {
      this.isFiltersDrawerOpen = false;
    },
    applyFacets: function applyFacets() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var newActiveFacets, newSort;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // updates things in parent context
              newActiveFacets = _this.activeFacets;
              newSort = _this.sort;
              _context.next = 4;
              return _this.$nextTick();
            case 4:
              _this.activeFacets = newActiveFacets;
              _this.sort = newSort;
              _this.isFiltersDrawerOpen = false;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    clearAllFacets: function clearAllFacets() {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // updates activeFacets in parent context

              _this2.activeFacets = _this2.getEmptyFacets();
              _context2.next = 3;
              return _this2.$nextTick();
            case 3:
              _this2.applyFacets();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleMobileToggleSpecial: function handleMobileToggleSpecial() {
      this.isSpecialOpen = !this.isSpecialOpen;
    }
  };
};
/* harmony default export */ const products_browser_facets_wrapper = (productsBrowserFacetsWrapper);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/products-browser-facet.js
var handleFacetOnChange = function handleFacetOnChange(facet, value, event) {
  /*
   * We are trying to implement Radio Button also as a checkbox, why? Because if we don't users don't have a way to unselect the radio button.
   * So if a facet type is Radio like availability we take the first value from the input and set it as an input
   */
  var target = event.target;
  if (facet.type === 'RADIO') {
    var val = target._x_model.get();
    if (Array.isArray(val) && val.includes(value.label)) {
      target._x_model.set([value.label]);
    }
  }
};
var productsBrowserFacet = function productsBrowserFacet() {
  return {
    expanded: false,
    showAll: false,
    get label() {
      return this.facet.label;
    },
    get values() {
      return this.facet.values;
    },
    onChange: function onChange(facet, value, event) {
      handleFacetOnChange(facet, value, event);
    }
  };
};
/* harmony default export */ const products_browser_facet = (productsBrowserFacet);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/products-browser-facet-slider.js
var productsBrowserFacetSlider = function productsBrowserFacetSlider() {
  return {
    inputLow: 0,
    inputHigh: 0,
    get normalizedValueFromSlider() {
      if (this.inputLow === this.originalRange[0] && this.inputHigh === this.originalRange[1]) {
        return '';
      }
      return "".concat(JSON.stringify({
        min: String(this.inputLow),
        max: String(this.inputHigh)
      }));
    },
    get normalizedValueActive() {
      return this.$refs.activeFacetModel._x_model.get();
    },
    get range() {
      var _JSON$parse = JSON.parse(this.facet.values[0].input),
        price = _JSON$parse.price;
      return [price.min, price.max];
    },
    init: function init() {
      var _this = this;
      this.setValues();
      this.originalRange = this.range;
      this.normalizedStep = 1;
      this.$nextTick(function () {
        _this.$watch('normalizedValueActive', function (value) {
          value = Array.isArray(value) ? value[0] : value;
          if (value) {
            var _JSON$parse2 = JSON.parse(value),
              min = _JSON$parse2.min,
              max = _JSON$parse2.max;
            _this.inputLow = Math.min(Math.max(Number(min), _this.originalRange[0]), _this.originalRange[1]);
            _this.inputHigh = Math.max(Math.min(Number(max), _this.originalRange[1]), _this.originalRange[0]);
          } else {
            _this.inputLow = _this.originalRange[0];
            _this.inputHigh = _this.originalRange[1];
          }
        });
      });
      this.$watch('normalizedValueFromSlider', function (value) {
        _this.$refs.activeFacetModel._x_model.set([value]);
      });
    },
    setValues: function setValues() {
      this.inputLow = this.range[0];
      this.inputHigh = this.range[1];
    }
  };
};
/* harmony default export */ const products_browser_facet_slider = (productsBrowserFacetSlider);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/products-browser-sort.js



var productsBrowserSort = function productsBrowserSort() {
  return {
    open: false,
    openDelayed: false,
    get options() {
      return this.sortingOptions;
    },
    get activeLabel() {
      var options = this.options,
        sort = this.sort;
      if (!sort) return options[0].label;
      var _sort$split = sort.split('::'),
        _sort$split2 = (0,slicedToArray/* default */.Z)(_sort$split, 2),
        field = _sort$split2[0],
        direction = _sort$split2[1];
      var activeOption = options.find(function (option) {
        return option.field === field && option.direction === direction;
      });
      return activeOption.label;
    },
    init: function init() {
      var _this = this;
      this.$watch('open', /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(open) {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$nextTick();
              case 2:
                _this.openDelayed = open;
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.$watch('activeLabel', function (activeLabel, oldActiveLabel) {
        if (activeLabel === oldActiveLabel) return;
        _this.open = false;
      });
    },
    handleClickOutside: function handleClickOutside() {
      if (this.openDelayed) {
        this.open = false;
      }
    }
  };
};
/* harmony default export */ const products_browser_sort = (productsBrowserSort);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/subscribe-save.js




var subscribeSave = function subscribeSave(collectionHandle) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  return {
    collectionHandle: collectionHandle,
    limit: limit,
    products: [],
    allProducts: [],
    // Store all products for filtering
    isLoading: true,
    error: null,
    hasLoaded: false,
    selectedBenefit: 'all',
    // Default filter value
    // Helper methods for individual products
    getProductLink: function getProductLink(product) {
      return "".concat(window.Shopify.routes.root, "products/").concat(product.handle);
    },
    getProductImages: function getProductImages(product) {
      return product.images || [];
    },
    getProductPrice: function getProductPrice(product) {
      return product.priceRangeFormatted;
    },
    getFirstVariantPrice: function getFirstVariantPrice(product) {
      var _product$variants;
      var firstVariant = (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants[0];
      return (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.priceFormatted) || product.priceRangeFormatted;
    },
    getDiscountPercentage: function getDiscountPercentage(product) {
      var _product$variants2, _firstVariant$selling, _firstVariant$selling2;
      var firstVariant = (_product$variants2 = product.variants) === null || _product$variants2 === void 0 ? void 0 : _product$variants2[0];
      if (!firstVariant) return null;

      // Get discount from GraphQL data directly
      if (((_firstVariant$selling = firstVariant.sellingPlanAllocations) === null || _firstVariant$selling === void 0 ? void 0 : (_firstVariant$selling2 = _firstVariant$selling.nodes) === null || _firstVariant$selling2 === void 0 ? void 0 : _firstVariant$selling2.length) > 0) {
        var _firstAllocation$pric;
        var firstAllocation = firstVariant.sellingPlanAllocations.nodes[0];
        if (((_firstAllocation$pric = firstAllocation.priceAdjustments) === null || _firstAllocation$pric === void 0 ? void 0 : _firstAllocation$pric.length) > 0) {
          var _firstPriceAdjustment, _firstPriceAdjustment2;
          var firstPriceAdjustment = firstAllocation.priceAdjustments[0];

          // Use compareAtPrice as original price and price as subscription price
          var originalPrice = parseFloat((_firstPriceAdjustment = firstPriceAdjustment.compareAtPrice) === null || _firstPriceAdjustment === void 0 ? void 0 : _firstPriceAdjustment.amount);
          var subscriptionPrice = parseFloat((_firstPriceAdjustment2 = firstPriceAdjustment.price) === null || _firstPriceAdjustment2 === void 0 ? void 0 : _firstPriceAdjustment2.amount);
          if (originalPrice && subscriptionPrice && originalPrice > subscriptionPrice) {
            var discount = (originalPrice - subscriptionPrice) / originalPrice * 100;
            return Math.round(discount);
          }
        }
      }
      return null;
    },
    getSubscriptionPrice: function getSubscriptionPrice(product) {
      var _product$variants3, _firstVariant$selling3, _firstVariant$selling4;
      var firstVariant = (_product$variants3 = product.variants) === null || _product$variants3 === void 0 ? void 0 : _product$variants3[0];
      if (!firstVariant) return null;

      // Method 1: Check sellingPlanAllocationsPrice
      if (firstVariant.sellingPlanAllocationsPrice) {
        return firstVariant.sellingPlanAllocationsPrice;
      }

      // Method 2: Check sellingPlanAllocations directly
      if (((_firstVariant$selling3 = firstVariant.sellingPlanAllocations) === null || _firstVariant$selling3 === void 0 ? void 0 : (_firstVariant$selling4 = _firstVariant$selling3.nodes) === null || _firstVariant$selling4 === void 0 ? void 0 : _firstVariant$selling4.length) > 0) {
        var _firstAllocation$pric2;
        var firstAllocation = firstVariant.sellingPlanAllocations.nodes[0];
        if (((_firstAllocation$pric2 = firstAllocation.priceAdjustments) === null || _firstAllocation$pric2 === void 0 ? void 0 : _firstAllocation$pric2.length) > 0) {
          var firstPriceAdjustment = firstAllocation.priceAdjustments[0];
          if (firstPriceAdjustment.price) {
            return this.formatPrice(firstPriceAdjustment.price);
          }
        }
      }
      return null;
    },
    formatPrice: function formatPrice(price) {
      if (!price || !price.amount || !price.currencyCode) return null;
      var formatter = new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: price.currencyCode
      });
      return formatter.format(price.amount);
    },
    hasSubscriptionPrice: function hasSubscriptionPrice(product) {
      return Boolean(this.getSubscriptionPrice(product));
    },
    getOkendoRating: function getOkendoRating(product) {
      var gid = product.id;
      var parts = gid.split('/');
      var productId = parts[parts.length - 1];
      return 'shopify-' + productId;
    },
    // Filter products by benefit tag
    filterByBenefit: function filterByBenefit(benefit) {
      this.selectedBenefit = benefit;
      if (benefit === 'all') {
        this.products = (0,toConsumableArray/* default */.Z)(this.allProducts);
      } else {
        // Convert benefit to tag format (e.g., "Brain Health" -> "brain-health")
        var benefitTag = benefit.toLowerCase().replace(/\s+/g, '-').replace(/'/g, '');
        this.products = this.allProducts.filter(function (product) {
          if (!product.tags || !Array.isArray(product.tags)) return false;

          // Check if product has the benefit tag
          return product.tags.some(function (tag) {
            return tag.toLowerCase().replace(/\s+/g, '-').replace(/'/g, '') === benefitTag;
          });
        });
      }
    },
    // Get available benefits from all products
    get availableBenefits() {
      var benefits = ['Active Lifestyle', 'Brain Health', 'Digestive Support', 'Immune Support', 'Heart Support', "Kid's Health", 'Liver Support & Cleanse', "Men's Health", 'Respiratory Support', 'Sleep Support', 'Stress Support', "Women's Health"];
      return benefits;
    },
    init: function init() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.collectionHandle) {
                _context.next = 4;
                break;
              }
              _this.error = 'No collection selected';
              _this.isLoading = false;
              return _context.abrupt("return");
            case 4:
              _context.prev = 4;
              _context.next = 7;
              return _this.loadProducts();
            case 7:
              _this.hasLoaded = true;
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4);
              _this.error = _context.t0.message || 'Failed to load products';
            case 13:
              _context.prev = 13;
              _this.isLoading = false;
              return _context.finish(13);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 10, 13, 16]]);
      }))();
    },
    loadProducts: function loadProducts() {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var data;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.collectionHandle) {
                _context2.next = 2;
                break;
              }
              throw new Error('Collection handle is required');
            case 2:
              _context2.next = 4;
              return fetchCollection(_this2.collectionHandle, null,
              // afterCursor
              _this2.limit,
              // noOfProducts
              [],
              // filtersArray
              'RELEVANCE',
              // sortField
              false // reverse
              );
            case 4:
              data = _context2.sent;
              if (data && data.products && data.products.nodes) {
                _this2.allProducts = data.products.nodes;
                _this2.products = (0,toConsumableArray/* default */.Z)(_this2.allProducts); // Initialize products with all products
              } else {
                _this2.allProducts = [];
                _this2.products = [];
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // Method to refresh products (useful for theme editor)
    refresh: function refresh() {
      var _this3 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isLoading = true;
              _this3.error = null;
              _context3.prev = 2;
              _context3.next = 5;
              return _this3.loadProducts();
            case 5:
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](2);
              _this3.error = _context3.t0.message || 'Failed to refresh products';
            case 10:
              _context3.prev = 10;
              _this3.isLoading = false;
              return _context3.finish(10);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 7, 10, 13]]);
      }))();
    }
  };
};
/* harmony default export */ const subscribe_save = (subscribeSave);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/cart.js



function cart_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function cart_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cart_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cart_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var CART_GET_URL = window.Shopify.routes.root + 'cart.js';
var CART_ADD_URL = window.Shopify.routes.root + 'cart/add.js';
var CART_UPDATE_URL = window.Shopify.routes.root + 'cart/update.js';
var CART_CHANGE_URL = window.Shopify.routes.root + 'cart/change.js';
var cartDataInitial = pDefer();
var cartStore = function cartStore() {
  return {
    cartData: null,
    giftBoxProductData: null,
    init: function init() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var productData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchCart();
            case 2:
              cartDataInitial.resolve(_this.cartData);
              _context.next = 5;
              return fetchProducts([window.GIFT_BOX_PRODUCT_ID]);
            case 5:
              productData = _context.sent;
              _this.giftBoxProductData = productData[window.GIFT_BOX_PRODUCT_ID];
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * START: FIRST-CLASS ACTIONS
     * These interact with AJAX API and must set cartData
     * consequentially.
     */
    fetchCart: function fetchCart() {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var url, params, data;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = new URL(window.location.href);
              url.pathname = CART_GET_URL;
              url.search = new URLSearchParams({
                t: Date.now()
              });
              params = {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              };
              _context2.next = 6;
              return request(url, params);
            case 6:
              data = _context2.sent;
              _this2.cartData = data;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addToCart: function addToCart(body) {
      var _this3 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return request(CART_ADD_URL, {
                method: 'post',
                body: JSON.stringify(body),
                headers: {
                  'content-type': 'application/json'
                }
              });
            case 2:
              _this3.fetchCart();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updateCart: function updateCart(body) {
      var _this4 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
        var url, params, data;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = CART_UPDATE_URL;
              params = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              };
              _context4.next = 4;
              return request(url, params);
            case 4:
              data = _context4.sent;
              if (!(data.items.length === 1 && data.items[0].product_id === window.GIFT_BOX_PRODUCT_ID && !_this4.clearingGiftBox)) {
                _context4.next = 14;
                break;
              }
              // note, recursive
              // should only be entered once, clearingGiftBox is saftey flag against infinite loop
              _this4.clearingGiftBox = true;
              _context4.next = 9;
              return _this4.removeLineItem(data.items[0].key);
            case 9:
              _context4.next = 11;
              return _this4.clearGiftBoxAttributes();
            case 11:
              _this4.clearingGiftBox = false;
              _context4.next = 15;
              break;
            case 14:
              // normal case
              _this4.cartData = data;
            case 15:
              _this4.clearingGiftBox = false;
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    changeLineItem: function changeLineItem(body) {
      var _this5 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
        var url, params, data;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = CART_CHANGE_URL;
              params = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              };
              _context5.next = 4;
              return request(url, params);
            case 4:
              data = _context5.sent;
              _this5.cartData = data;
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    /**
     * SECOND-CLASS ACTIONS
     * These call POST method FIRST-CLASS ACTIONS with predetermined bodies
     * They should not handle response data, but do return awaitable promises.
     */
    removeLineItem: function removeLineItem(key) {
      var _this6 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.changeLineItem({
                id: key,
                quantity: 0
              });
            case 2:
              return _context6.abrupt("return", _context6.sent);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    clearGiftBoxAttributes: function clearGiftBoxAttributes() {
      var _this7 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
        var cartAttributes;
        return regenerator_default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              cartAttributes = cart_objectSpread({}, _this7.cartData.attributes);
              cartAttributes['gift-wrapping'] = null;
              cartAttributes['gift-note'] = null;
              _context7.next = 5;
              return _this7.updateCart({
                attributes: cartAttributes
              });
            case 5:
              return _context7.abrupt("return", _context7.sent);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    get normalizedCartQty() {
      var _this$cartData;
      return ((_this$cartData = this.cartData) === null || _this$cartData === void 0 ? void 0 : _this$cartData.items.filter(function (item) {
        return item.product_id !== window.GIFT_BOX_PRODUCT_ID;
      }).reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0)) || 0;
    },
    get lineItemsNormalized() {
      // currently normalization consists only of ensuring
      // that any gift box product is last in order

      return (0,toConsumableArray/* default */.Z)(this.cartData.items).sort(function (a, b) {
        return a.product_id === window.GIFT_BOX_PRODUCT_ID ? 1 : b.product_id === window.GIFT_BOX_PRODUCT_ID ? -1 : 0;
      });
    },
    get giftBoxItemOnCart() {
      return this.cartData.items.find(function (item) {
        return item.product_id === window.GIFT_BOX_PRODUCT_ID;
      });
    },
    get giftBoxPrice() {
      var giftBoxProductData = this.giftBoxProductData;
      if (giftBoxProductData) {
        return giftBoxProductData.variants[0].priceFormatted;
      }
      return '';
    }
  };
};
var cartComponent = function cartComponent() {
  return {
    get cartHasDiscounts() {
      return this.$store.cart.cartData.total_discount > 0;
    },
    get discountTotal() {
      var _this$$store$cart$car, _this$$store$cart;
      if ((_this$$store$cart$car = this.$store.cart.cartData) !== null && _this$$store$cart$car !== void 0 && _this$$store$cart$car.currency && (_this$$store$cart = this.$store.cart) !== null && _this$$store$cart !== void 0 && _this$$store$cart.cartData.total_discount) {
        var _this$$store$cart2, _this$$store$cart3, _this$$store$cart4;
        return formatPrice({
          currencyCode: (_this$$store$cart2 = this.$store.cart) === null || _this$$store$cart2 === void 0 ? void 0 : _this$$store$cart2.cartData.currency,
          amount: (_this$$store$cart3 = this.$store.cart) !== null && _this$$store$cart3 !== void 0 && _this$$store$cart3.cartData.total_discount ? ((_this$$store$cart4 = this.$store.cart) === null || _this$$store$cart4 === void 0 ? void 0 : _this$$store$cart4.cartData.total_discount) / -100 : 0
        });
      } else return '';
    },
    get subtotal() {
      var _this$$store$cart$car2;
      if ((_this$$store$cart$car2 = this.$store.cart.cartData) !== null && _this$$store$cart$car2 !== void 0 && _this$$store$cart$car2.currency) {
        return formatPrice({
          currencyCode: this.$store.cart.cartData.currency,
          amount: this.$store.cart.cartData.total_price ? this.$store.cart.cartData.total_price / 100 : 0
        });
      } else {
        return '';
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/js/bundles/snippets/line-item.js




// INHERITS cartItem in scope

var lineItemComponent = function lineItemComponent(lowStockThreshold, lowStockMessage, normalStockMessage) {
  return {
    lowStockThreshold: lowStockThreshold,
    lowStockMessage: lowStockMessage,
    normalStockMessage: normalStockMessage,
    isRemoving: false,
    fullVariantData: {},
    init: function init() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var currentAllProducts, cartItemProductData, cartItemVariantData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchProducts([_this.cartItem.product_id]);
            case 2:
              currentAllProducts = _context.sent;
              cartItemProductData = currentAllProducts[_this.cartItem.product_id];
              cartItemVariantData = cartItemProductData.variants.find(function (variant) {
                return variant.id.replace('gid://shopify/ProductVariant/', '') === _this.cartItem.variant_id.toString();
              });
              _this.fullVariantData = cartItemVariantData;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    removeItem: function removeItem(key) {
      var _arguments = arguments,
        _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var isGiftBox, $store;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isGiftBox = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              $store = _this2.$store;
              _context2.prev = 2;
              _this2.isRemoving = true;
              if (!isGiftBox) {
                _context2.next = 7;
                break;
              }
              _context2.next = 7;
              return $store.cart.clearGiftBoxAttributes();
            case 7:
              _context2.next = 9;
              return $store.cart.removeLineItem(key);
            case 9:
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](2);
              alert('sorry, there was an error removing this item from your cart');
            case 14:
              _context2.prev = 14;
              _this2.isRemoving = false;
              return _context2.finish(14);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 11, 14, 17]]);
      }))();
    },
    updateQuantity: function updateQuantity(quantity) {
      var _this3 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this3.$store.cart.changeLineItem({
                id: _this3.cartItem.key,
                quantity: quantity
              });
            case 3:
              _context3.next = 8;
              break;
            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3["catch"](0);
              alert(_context3.t0.message);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 5]]);
      }))();
    },
    get imageUrl() {
      return this.cartItem.featured_image.url;
    },
    get imageAlt() {
      return this.cartItem.featured_image.alt;
    },
    get imageWidth() {
      return this.cartItem.featured_image.width;
    },
    get imageHeight() {
      return this.cartItem.featured_image.height;
    },
    get isLowStock() {
      var fullVariantData = this.fullVariantData,
        lowStockThreshold = this.lowStockThreshold;
      if (fullVariantData.quantityAvailable) {
        return fullVariantData.quantityAvailable <= lowStockThreshold;
      } else return true;
    },
    get discountStatus() {
      var fullVariantData = this.fullVariantData,
        cartItem = this.cartItem;
      if (cartItem.discounts.length) {
        return 'APPLIED';
      } else if (fullVariantData.compareAtPrice && parseFloat(fullVariantData.compareAtPrice.amount) > parseFloat(fullVariantData.price.amount)) {
        return 'MARKDOWN';
      }
      return null;
    },
    get originalPrice() {
      var discountStatus = this.discountStatus,
        fullVariantData = this.fullVariantData,
        $store = this.$store,
        cartItem = this.cartItem;
      if (discountStatus === 'MARKDOWN') {
        var compareAtPrice = parseFloat(fullVariantData.compareAtPrice.amount);
        var quantity = cartItem.quantity;
        return formatPrice({
          currencyCode: $store.cart.cartData.currency,
          amount: compareAtPrice * quantity
        });
      } else if (discountStatus === 'APPLIED') {
        return formatPrice({
          currencyCode: $store.cart.cartData.currency,
          amount: cartItem.original_line_price / 100
        });
      }
      return '';
    },
    get finalPrice() {
      var $store = this.$store,
        cartItem = this.cartItem;
      return formatPrice({
        currencyCode: $store.cart.cartData.currency,
        amount: cartItem.final_line_price / 100
      });
    }
  };
};
/* harmony default export */ const line_item = (lineItemComponent);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.js
var scrollbar = __webpack_require__(652);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/recommended-products.js





var recommendedProducts = function recommendedProducts(recommendedProductIds, productId) {
  return {
    swiperInstance: null,
    recommendedProducts: [],
    init: function init() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var productsIds, productsObj;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = recommendedProductIds;
              if (_context.t0) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return fetchRecommendedProducts('COMPLEMENTARY', "gid://shopify/Product/".concat(productId));
            case 4:
              _context.t0 = _context.sent.products.nodes.map(function (product) {
                return product.id;
              });
            case 5:
              productsIds = _context.t0;
              _context.next = 8;
              return fetchProducts(productsIds);
            case 8:
              productsObj = _context.sent;
              _this.recommendedProducts = productsIds.map(function (id) {
                return productsObj[id];
              });
              _this.swiperEl = _this.$refs.swiper;
              _this.buildSwiper();

              // UPDATE SLIDES whenever recommendedProducts changes
              _this.$watch('recommendedProducts', function () {
                _this.swiperInstance.update();
                _this.swiperInstance.slideTo(0, 750);
              });
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    buildSwiper: function buildSwiper() {
      var _this2 = this;
      if (!this.swiperEl) {
        return;
      }
      this.swiperInstance = new core/* default */.Z(this.swiperEl, {
        slidesPerView: 'auto',
        modules: [navigation/* default */.Z, scrollbar/* default */.Z],
        scrollbar: {
          el: this.swiperEl.querySelector('.swiper-scrollbar'),
          hide: true
        },
        navigation: {
          nextEl: this.swiperEl.querySelector('.swiper-btn-next'),
          prevEl: this.swiperEl.querySelector('.swiper-btn-prev'),
          disabledClass: 'pointer-events-none opacity-30'
        },
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 16,
        breakpoints: {
          1024: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 16
          }
        }
      });
      setTimeout(function () {
        _this2.swiperInstance.init();
      }, 0);
    }
  };
};
/* harmony default export */ const recommended_products = (recommendedProducts);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/product-variant-selection.js




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function product_variant_selection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function product_variant_selection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? product_variant_selection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : product_variant_selection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var productData = function productData(product) {
  var isModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    product: product,
    options: product.options,
    selectedVariants: [product.firstAvailableOrSelectedVariant],
    selectedOptions: Object.fromEntries(product.firstAvailableOrSelectedVariant.selectedOptions.map(function (option) {
      return [option.name, option.value];
    })),
    isWorking: false,
    drawerSide: '',
    get optionsWithState() {
      var _this = this;
      var options = this.options,
        selectedOptions = this.selectedOptions,
        product = this.product;
      return options.map(function (option) {
        var name = option.name,
          values = option.values;
        return {
          name: name,
          values: values.map(function (value) {
            var _swatches$image, _availableVariants$, _availableVariants$$m, _availableVariants$2;
            var newSelectedOptions = product_variant_selection_objectSpread({}, selectedOptions);
            delete newSelectedOptions[name];
            var newSelectedOptionsArray = [[name, value]].concat((0,toConsumableArray/* default */.Z)(Object.entries(newSelectedOptions)));
            var _this$calculateOption = _this.calculateOptionsAndVariants(newSelectedOptionsArray),
              availableVariants = _this$calculateOption.availableVariants;
            var swatches = product.variants.find(function (v) {
              return v.title.includes(value);
            });
            var variant_image = swatches && swatches !== null && swatches !== void 0 && swatches.image ? swatches === null || swatches === void 0 ? void 0 : (_swatches$image = swatches.image) === null || _swatches$image === void 0 ? void 0 : _swatches$image.url : null;
            return {
              value: value,
              variant_image: variant_image,
              variants: availableVariants.length,
              variantsInStock: availableVariants.filter(function (variant) {
                return variant.availableForSale;
              }).length,
              hideVariant: (_availableVariants$ = availableVariants[0]) !== null && _availableVariants$ !== void 0 && (_availableVariants$$m = _availableVariants$.metafield) !== null && _availableVariants$$m !== void 0 && _availableVariants$$m.hideVariant ? true : false,
              media_id: (_availableVariants$2 = availableVariants[0]) === null || _availableVariants$2 === void 0 ? void 0 : _availableVariants$2.media_id
            };
          })
        };
      });
    },
    // coming-soon, many-variants, sold-out-permanently, sold-out-notify, available
    get stateBase() {
      var _selectedVariant$meta;
      var availableForSale = product.availableForSale;

      // if (!availableForSale) {
      //   return `sold-out-permanently`;
      // }

      var selectedVariants = this.selectedVariants;
      var _selectedVariants = (0,slicedToArray/* default */.Z)(selectedVariants, 1),
        selectedVariant = _selectedVariants[0];

      // Check if product has back_in_stock tag and variant has low inventory
      var hasBackInStockTag = this.product.tags.includes('back_in_stock');
      var isLowInventory = selectedVariant.inventoryQuantity < 100;
      if (hasBackInStockTag && isLowInventory) {
        return 'back-in-stock';
      }
      if (!selectedVariant.availableForSale) {
        return "sold-out-permanently";
      }
      if ((_selectedVariant$meta = selectedVariant.metafield) !== null && _selectedVariant$meta !== void 0 && _selectedVariant$meta.hideVariant) {
        return "sold-out-permanently";
      }
      return 'available';
    },
    init: function init() {
      console.log('initial variant', this.selectedVariants);
      this.handleInitialVariantSlide();
    },
    get buttonLabelBase() {
      if (this.isWorking) return 'Adding…';
      var stateBase = this.stateBase;
      switch (stateBase) {
        case 'sold-out-permanently':
          return 'Sold Out';
        case 'available':
          return 'Add to Bag';
        case 'back-in-stock':
          return 'Notify me when back in stock';
        default:
          return '';
      }
    },
    get isButtonDisabled() {
      // Only disable the button if it's sold out permanently
      var stateBase = this.stateBase;
      return stateBase === 'sold-out-permanently';
    },
    klaviyoBISForm: function klaviyoBISForm() {
      var _Alpine$store,
        _this2 = this;
      (_Alpine$store = Alpine.store('quickBuyModal')) === null || _Alpine$store === void 0 ? void 0 : _Alpine$store.hide();
      if (document.getElementById('klaviyo-bis-modal')) return;
      var title = this.product.title;
      var lowStockVariants = this.product.variants.filter(function (variant) {
        return variant.inventoryQuantity < 100;
      });
      var hasMultipleVariants = lowStockVariants.length > 1;
      var defaultVariantId = lowStockVariants.length > 0 ? lowStockVariants[0].id : '';
      var modal = document.createElement('div');
      modal.id = 'klaviyo-bis-modal';
      modal.innerHTML = "\n        <div id=\"klaviyo-overlay\" class='fixed inset-0 bg-p-forest/70 flex justify-center items-center transition-opacity duration-300 ease-in-out z-[35]'>\n          <div class='bg-white p-6 rounded-lg shadow-lg w-96 min-w-[400px] relative' id=\"klaviyo-content\">\n            <button id='klaviyo-close' class=' text-[25px] absolute top-3 right-3 text-gray-800 hover:text-gray-700'>&times;</button>\n            <h2 class='text-xl font-semibold text-gray-900 mb-1'>".concat(title, "</h2>\n            <p class=\"text-base mb-4\">Register to receive a notification when this item comes back in stock.</p>\n            ").concat(hasMultipleVariants ? "\n              <label class='block mb-2 text-gray-800 font-bold text-sm'>Select Variant:</label>\n              <select id='klaviyo-variant' class='border pt-2 px-3  w-full rounded-full  mb-4'>\n                ".concat(lowStockVariants.map(function (variant) {
        return "\n                  <option value=\"".concat(variant.id, "\" ").concat(variant.id === _this2.selectedVariants[0].id ? 'selected' : '', ">\n                    ").concat(variant.title, "\n                  </option>\n                ");
      }).join(''), "\n              </select>") : '', "\n            <label class='block mb-2 text-gray-800 font-bold text-sm'>Enter your email:</label>\n            <input type='email' id='klaviyo-email' class='border pt-2 px-3 w-full rounded-full  focus:ring focus:ring-green-300' required />\n            <p id='klaviyo-error' class='text-red-900 text-sm mt-1 hidden'>Please enter a valid email.</p>\n            <button id='klaviyo-submit' class='bg-green-800 text-white w-full mt-4 py-3 rounded-full  hover:bg-green-700 transition font-bold uppercase text-sm tracking-[.1em]'>Notify me when back in stock</button>\n            <p id='klaviyo-success' class='text-green-600 mt-2 hidden text-sm'>Thank you! You will be notified.</p>\n          </div>\n        </div>");
      document.body.appendChild(modal);
      var closeModal = function closeModal() {
        document.body.removeChild(modal);
      };
      document.getElementById('klaviyo-close').addEventListener('click', closeModal);
      document.getElementById('klaviyo-overlay').addEventListener('click', function (event) {
        if (!document.getElementById('klaviyo-content').contains(event.target)) {
          closeModal();
        }
      });
      document.getElementById('klaviyo-submit').addEventListener('click', /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var emailField, errorMsg, successMsg, variantId, payload, response;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              emailField = document.getElementById('klaviyo-email');
              errorMsg = document.getElementById('klaviyo-error');
              successMsg = document.getElementById('klaviyo-success');
              variantId = hasMultipleVariants ? document.getElementById('klaviyo-variant').value : defaultVariantId;
              if (!(!emailField.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField.value))) {
                _context.next = 7;
                break;
              }
              errorMsg.classList.remove('hidden');
              return _context.abrupt("return");
            case 7:
              errorMsg.classList.add('hidden'); // Hide error if email is valid
              payload = {
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: emailField.value
                        }
                      }
                    },
                    channels: ['EMAIL']
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: "$shopify:::$default:::".concat(variantId)
                      }
                    }
                  }
                }
              };
              _context.prev = 9;
              _context.next = 12;
              return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=PqM29e', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'REVISION': '2024-02-15' // Ensure correct Klaviyo API version
                },

                body: JSON.stringify(payload)
              });
            case 12:
              response = _context.sent;
              if (response.ok) {
                _context.next = 15;
                break;
              }
              throw new Error('Failed to subscribe');
            case 15:
              successMsg.classList.remove('hidden');
              setTimeout(closeModal, 3000); // Close the modal after 3 seconds
              _context.next = 23;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](9);
              errorMsg.textContent = 'Error: ' + _context.t0.message;
              errorMsg.classList.remove('hidden');
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[9, 19]]);
      })));
    },
    calculateOptionsAndVariants: function calculateOptionsAndVariants(selectedOptionsArray) {
      var availableVariants = product.variants;
      var correctSelectedOptions = {};
      var _iterator = _createForOfIteratorHelper(selectedOptionsArray),
        _step;
      try {
        var _loop = function _loop() {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
            name = _step$value[0],
            value = _step$value[1];
          var previousVariants = availableVariants;
          availableVariants = availableVariants.filter(function (variant) {
            return variant.selectedOptions.some(function (option) {
              return option.name === name && option.value === value;
            });
          });
          if (availableVariants.length === 0) {
            availableVariants = previousVariants;
            var newValue = availableVariants[0].selectedOptions.find(function (option) {
              return option.name === name;
            }).value;
            correctSelectedOptions[name] = newValue;
            availableVariants = availableVariants.filter(function (variant) {
              return variant.selectedOptions.some(function (option) {
                return option.name === name && option.value === newValue;
              });
            });
          } else {
            correctSelectedOptions[name] = value;
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        availableVariants: availableVariants,
        correctSelectedOptions: correctSelectedOptions
      };
    },
    normalizeOptionsAndVariants: function normalizeOptionsAndVariants(selectedOptionsArray) {
      var _this$calculateOption2 = this.calculateOptionsAndVariants(selectedOptionsArray),
        availableVariants = _this$calculateOption2.availableVariants,
        correctSelectedOptions = _this$calculateOption2.correctSelectedOptions;
      this.selectedOptions = correctSelectedOptions;
      this.selectedVariants = availableVariants;
      this.$dispatch('hero-product-variant-trustscore', this.selectedVariants[0].metafield.trustScore || '');
    },
    handleInitialVariantSlide: function handleInitialVariantSlide() {
      var _this3 = this;
      var currentVariant = product.firstAvailableOrSelectedVariant;
      if (currentVariant && currentVariant.media_id) {
        var media_id = currentVariant.media_id;
        setTimeout(function () {
          _this3.$dispatch('hero-product-variant-slide', {
            media_id: media_id
          });
        }, 100);
      }
      this.$dispatch('hero-product-variant-trustscore', this.selectedVariants[0].metafield.trustScore || '');
    },
    handleOptionChange: function handleOptionChange(name, value, media_id) {
      var newSelectedOptions = product_variant_selection_objectSpread({}, this.selectedOptions);
      delete newSelectedOptions[name];
      var newSelectedOptionsArray = [[name, value]].concat((0,toConsumableArray/* default */.Z)(Object.entries(newSelectedOptions)));
      this.normalizeOptionsAndVariants(newSelectedOptionsArray);
      if (media_id) {
        this.$dispatch('hero-product-variant-slide', {
          media_id: media_id
        });
      }
    },
    addToCart: function addToCart() {
      var _this4 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _this4$product$hazard, _this4$product$hazard2;
        var selectedVariants, _selectedVariants2, selectedVariant, simpleId, payload, res, description, data;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this4.isWorking) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              selectedVariants = _this4.selectedVariants;
              _selectedVariants2 = (0,slicedToArray/* default */.Z)(selectedVariants, 1), selectedVariant = _selectedVariants2[0];
              simpleId = typeof selectedVariant.id === 'number' ? selectedVariant.id : Number(selectedVariant.id.split('gid://shopify/ProductVariant/')[1]);
              payload = {
                items: [product_variant_selection_objectSpread({
                  id: simpleId,
                  selling_plan: _this4.purchaseType === 'one-time' ? null : _this4.sellingPlanId
                }, Object.hasOwn(_this4.product, 'hazardous_metafield') && {
                  properties: {
                    _hazardous_product_title: (_this4$product$hazard = _this4.product.hazardous_metafield) === null || _this4$product$hazard === void 0 ? void 0 : _this4$product$hazard.notificationTitle,
                    _hazardous_product_content: (_this4$product$hazard2 = _this4.product.hazardous_metafield) === null || _this4$product$hazard2 === void 0 ? void 0 : _this4$product$hazard2.notificationContent
                  }
                })]
              };
              _context2.prev = 6;
              _this4.isWorking = true;
              _context2.next = 10;
              return fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
                method: 'post',
                body: JSON.stringify(payload),
                headers: {
                  'content-type': 'application/json'
                }
              });
            case 10:
              res = _context2.sent;
              if (res.ok) {
                _context2.next = 23;
                break;
              }
              description = '';
              _context2.prev = 13;
              _context2.next = 16;
              return res.json();
            case 16:
              data = _context2.sent;
              description = data === null || data === void 0 ? void 0 : data.description;
              _context2.next = 22;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](13);
            case 22:
              throw new Error(["Failed to add to bag!", description, "(status: ".concat(res.status, ")")].filter(Boolean).join('\n'));
            case 23:
              _context2.next = 30;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t1 = _context2["catch"](6);
              alert(_context2.t1.message);
              _this4.isWorking = false;
              throw _context2.t1;
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[6, 25], [13, 20]]);
      }))();
    }
  };
};
;// CONCATENATED MODULE: ./src/js/bundles/snippets/product-trust-score.js
var productTrustScore = function productTrustScore(initialTrustScoreValue) {
  return {
    trustScore: initialTrustScoreValue,
    init: function init() {
      this.updateShadowRoot(this.$el);
    },
    updateTrustScoreLink: function updateTrustScoreLink(event) {
      var _this = this;
      this.trustScore = null;
      this.$nextTick(function () {
        _this.trustScore = event.detail || '';
        _this.updateShadowRoot(_this.$el);
      });
    },
    updateShadowRoot: function updateShadowRoot(element) {
      var observer = new MutationObserver(function () {
        var _el$getElementsByTagN;
        var el = element.querySelector('.trust-info-widget');
        var innerDivShadow = (_el$getElementsByTagN = el.getElementsByTagName('div')[0]) === null || _el$getElementsByTagN === void 0 ? void 0 : _el$getElementsByTagN.shadowRoot;
        if (innerDivShadow) {
          // Example: listen for something inside the shadow root
          var trustContainer = innerDivShadow.querySelector('.supp-trust-info');
          if (trustContainer) {
            trustContainer.style.maxWidth = '100%';
            observer.disconnect(); // Stop once found
          }
        }
      });

      observer.observe(element, {
        childList: true,
        subtree: true
      });
    }
  };
};
;// CONCATENATED MODULE: ./src/js/bundles/snippets/quick-buy-modal.js


/* eslint-disable */

var quickBuyModal = function quickBuyModal() {
  return {
    isVisible: false,
    body: document.body,
    productHtml: '',
    isLoading: false,
    modalLoaded: false,
    dialog: null,
    set_dialog: function set_dialog(dialog) {
      this.dialog = dialog;
    },
    show: function show() {
      var _this = this;
      if (this.isVisible) return;
      this.dialog.showModal();
      this.body.classList.add('scroll-lock');
      this.isVisible = true;
      setTimeout(function () {
        _this.modalLoaded = true;
      }, 10);
      window.isMobile && disableScrollForInputDrawer();
    },
    hide: function hide() {
      if (!this.isVisible) return;
      this.body.classList.remove('scroll-lock');
      this.isVisible = false;
      this.dialog.close();
      this.modalLoaded = false;
      this.productHtml = '';
      window.isMobile && enableScrollForInputDrawer();
    },
    loadModal: function () {
      var _loadModal = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(productHandle) {
        var _this2 = this;
        var event,
          defaultPurchaseType,
          triggerButton,
          triggerButtonText,
          res,
          parsedRes,
          setPurchaseType,
          attempts,
          maxAttempts,
          checkInterval,
          _args = arguments;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
              defaultPurchaseType = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
              if (this.dialog) {
                _context.next = 6;
                break;
              }
              console.error('Quick Buy Dialog not set');
              alert("Sorry, we couldn't load the Quick Buy feature");
              return _context.abrupt("return");
            case 6:
              if (!this.isLoading) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              this.isLoading = true;
              triggerButton = null;
              triggerButtonText = '';
              if (event !== null && event !== void 0 && event.target) {
                triggerButton = event.target;
                triggerButton.classList.add('loading-indicator');
              }
              _context.prev = 12;
              _context.next = 15;
              return fetch("/products/".concat(productHandle, "?section_id=quick-buy-product"));
            case 15:
              res = _context.sent;
              if (res.ok) {
                _context.next = 18;
                break;
              }
              throw new Error("Fetch of quickBuyModal failed");
            case 18:
              _context.next = 20;
              return res.text();
            case 20:
              parsedRes = _context.sent;
              // Get the complete HTML response

              this.productHtml = parsedRes;
              this.show();

              // Set default purchase type if provided
              if (defaultPurchaseType) {
                // Store the default purchase type to be applied after modal loads
                this.defaultPurchaseType = defaultPurchaseType;

                // Wait for the modal to fully load and Alpine to initialize
                setPurchaseType = function setPurchaseType() {
                  // Look for the heroProduct component within the modal
                  var modalContent = _this2.dialog.querySelector('[x-data*="heroProduct"]');
                  if (modalContent && modalContent._x_dataStack) {
                    // Find the heroProduct component in the Alpine data stack
                    var heroProductComponent = modalContent._x_dataStack.find(function (component) {
                      return component.purchaseType !== undefined;
                    });
                    if (heroProductComponent) {
                      heroProductComponent.purchaseType = defaultPurchaseType;
                      return true;
                    }
                  }
                  return false;
                }; // Try immediately
                if (!setPurchaseType()) {
                  // If not available immediately, retry with increasing delays
                  attempts = 0;
                  maxAttempts = 20;
                  checkInterval = setInterval(function () {
                    attempts++;
                    if (setPurchaseType() || attempts >= maxAttempts) {
                      clearInterval(checkInterval);
                    }
                  }, 100);
                }
              }
              _context.next = 30;
              break;
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](12);
              console.error(_context.t0.message);
              alert("Sorry, we couldn't load the Quick Buy feature");
            case 30:
              _context.prev = 30;
              if (triggerButton) triggerButton.classList.remove('loading-indicator');
              this.isLoading = false;
              return _context.finish(30);
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[12, 26, 30, 34]]);
      }));
      function loadModal(_x) {
        return _loadModal.apply(this, arguments);
      }
      return loadModal;
    }()
  };
};
;// CONCATENATED MODULE: ./src/js/utils/product.js
var getHighestDiscountPercentage = function getHighestDiscountPercentage(product) {
  var _product$variants;
  return (product === null || product === void 0 ? void 0 : (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants.reduce(function (highest, variant) {
    var _variant$compareAtPri, _variant$price, _variant$compareAtPri2;
    var discount = Math.round((((_variant$compareAtPri = variant.compareAtPrice) === null || _variant$compareAtPri === void 0 ? void 0 : _variant$compareAtPri.amount) - ((_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : _variant$price.amount)) * 100 / ((_variant$compareAtPri2 = variant.compareAtPrice) === null || _variant$compareAtPri2 === void 0 ? void 0 : _variant$compareAtPri2.amount));
    return discount && discount > highest ? discount : highest;
  }, 0)) || 0;
};
var isNew = function isNew(product) {
  var _product$launchDate;
  var launchDateISO = product === null || product === void 0 ? void 0 : (_product$launchDate = product.launchDate) === null || _product$launchDate === void 0 ? void 0 : _product$launchDate.value;
  if (!launchDateISO) {
    return false;
  }
  var now = new Date();
  var launch = new Date(launchDateISO);
  var thirtyDaysAgo = new Date(new Date().setDate(now.getDate() - 30));

  // Product is considered new if it was launched within the last 30 days
  return launch > thirtyDaysAgo;
};
var getProductBadges = function getProductBadges(product) {
  var _product$tags;
  if (!product) return [];
  var BADGE_LIMIT = 1;
  var tags = product === null || product === void 0 ? void 0 : (_product$tags = product.tags) === null || _product$tags === void 0 ? void 0 : _product$tags.map(function (tag) {
    return tag.toLowerCase();
  });
  var getBadge = {
    'coming-soon': function comingSoon() {
      return tags.includes('coming soon') && {
        label: 'Coming Soon'
      };
    },
    discount: function discount() {
      var discount = getHighestDiscountPercentage(product);
      return tags.includes('salemd') && discount > 0 && {
        label: "".concat(discount, "% off")
      };
    },
    "new": function _new() {
      return isNew(product) && {
        label: 'New'
      };
    },
    preorder: function preorder() {
      return tags.includes('preorder') && {
        label: 'Pre-Order'
      };
    },
    'sold-out': function soldOut() {
      return !(product !== null && product !== void 0 && product.availableForSale) && {
        label: 'Sold Out'
      };
    }
  };
  var badgePriority = ['preorder', 'coming-soon', 'sold-out', 'discount', 'new'];
  var allBadges = badgePriority.map(function (badge) {
    var badgeData = typeof getBadge[badge] === 'function' && getBadge[badge]();
    if (badgeData) {
      badgeData.type = badge;
      return badgeData;
    }
  }).filter(function (badge) {
    return !!badge;
  });
  return allBadges.slice(0, BADGE_LIMIT);
};
;// CONCATENATED MODULE: ./src/js/utils/inventory.js


/*
 * Fetch the inventory levels for a product from the inventory API
 *
 * @param productSku {string} productSku: the SKU of the product to fetch
 *
 * @return {promise}: the promise of the fetch with all the response data included
 */

var getIfsInventoryLevels = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(productSku) {
    var mainUrl, urlWithParams, ifsData;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          mainUrl = 'https://x66ix5nef4.execute-api.us-east-1.amazonaws.com/default/ifs_product_inventory';
          urlWithParams = "".concat(mainUrl, "?skus=").concat(productSku);
          _context.next = 4;
          return fetch(urlWithParams).then(function (res) {
            return res.json();
          }).then(function (data) {
            return data;
          })["catch"](function (err) {
            return console.error(err);
          });
        case 4:
          ifsData = _context.sent;
          return _context.abrupt("return", ifsData);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getIfsInventoryLevels(_x) {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/js/bundles/sections/hero-product.js


var heroProduct = function heroProduct(id, variantsSkus, images) {
  var shopifyData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var hideSubscriptionOption = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var defaultPurchaseType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'one-time';
  return {
    id: id,
    variantsSkus: variantsSkus,
    loading: false,
    shopifyData: shopifyData,
    parentSelectedVariants: [],
    images: images,
    error: '',
    purchaseType: defaultPurchaseType,
    sellingPlanId: null,
    hideSubscriptionOption: hideSubscriptionOption,
    init: function init() {
      var _this$subscriptionPla, _this$subscriptionPla2;
      window.heroProduct = this;
      this.sellingPlanId = (_this$subscriptionPla = this.subscriptionPlans) === null || _this$subscriptionPla === void 0 ? void 0 : (_this$subscriptionPla2 = _this$subscriptionPla[0]) === null || _this$subscriptionPla2 === void 0 ? void 0 : _this$subscriptionPla2.id;

      // We no longer need this, as we update the Shopify inventory. Also this has and causes issues.
      // Keeping the code for reference.
      // this.updateInventoryLevels();
    },

    get ready() {
      return Boolean(!this.loading && this.shopifyData);
    },
    get badges() {
      return this.shopifyData ? getProductBadges(this.shopifyData) : [];
    },
    get subscriptionPlans() {
      var _this$shopifyData, _this$shopifyData$sel, _this$shopifyData$sel2;
      return (_this$shopifyData = this.shopifyData) === null || _this$shopifyData === void 0 ? void 0 : (_this$shopifyData$sel = _this$shopifyData.sellingPlanGroups) === null || _this$shopifyData$sel === void 0 ? void 0 : (_this$shopifyData$sel2 = _this$shopifyData$sel[0]) === null || _this$shopifyData$sel2 === void 0 ? void 0 : _this$shopifyData$sel2.selling_plans;
    },
    get finalPrice() {
      var variant = this.selectedVariants[0];
      if (!variant) return '';
      return this.purchaseType === 'one-time' ? variant.priceFormatted : variant.sellingPlanAllocationsPrice;
    },
    updateInventoryLevels: function updateInventoryLevels() {
      var _this = this;
      var inventoryPromises = [];
      variantsSkus.forEach(function (sku) {
        var inventoryPromise = getIfsInventoryLevels(sku);
        inventoryPromises.push(inventoryPromise);
      });
      Promise.all(inventoryPromises).then(function (inventoryLevels) {
        inventoryLevels.forEach(function (inventoryLevel, index) {
          return _this.updateVariantAvailability(inventoryLevel, index);
        });
      })["catch"](function (error) {
        return console.error(error);
      }); // eslint-disable-line no-console
    },
    updateVariantAvailability: function updateVariantAvailability(inventoryLevel, index) {
      var _variant$metafield;
      var variant = this.shopifyData.variants[index];
      if (!variant) return;
      if (typeof inventoryLevel !== 'number') return;
      if (variant !== null && variant !== void 0 && (_variant$metafield = variant.metafield) !== null && _variant$metafield !== void 0 && _variant$metafield.hideVariant) {
        this.updateVariantAvailabilityData(variant);
        return;
      }
      if (inventoryLevel > variant.quantityAvailable) {
        this.updateVariantAvailabilityData(variant, true, inventoryLevel);
      } else {
        this.updateVariantAvailabilityData(variant);
      }
    },
    updateVariantAvailabilityData: function updateVariantAvailabilityData(variant) {
      var isAvailable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      variant.availableForSale = isAvailable;
      variant.available = isAvailable;
      variant.inventoryQuantity = quantity;
      variant.quantityAvailable = quantity;
    }
  };
};
/* harmony default export */ const hero_product = (heroProduct);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.js
var autoplay_autoplay = __webpack_require__(127);
;// CONCATENATED MODULE: ./src/js/bundles/sections/content-with-steps.js

var desktopStepsSlider = function desktopStepsSlider() {
  var sliders = document.querySelectorAll('.desktop-steps');
  sliders.forEach(function (slider) {
    var autoplay = slider.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(slider.dataset.autoplayDelay);
    var swiperOptions = {
      modules: [scrollbar/* default */.Z],
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      speed: 400,
      spaceBetween: 20,
      slidesPerView: 6,
      breakpoints: {
        1200: {
          slidesPerView: 1.6,
          dragSize: 600
        },
        900: {
          slidesPerView: 1.5,
          dragSize: 300
        },
        600: {
          slidesPerView: 1.2,
          dragSize: 150
        },
        320: {
          slidesPerView: 1,
          dragSize: 150
        }
      }
    };
    if (autoplay) {
      swiperOptions.modules.push(autoplay_autoplay/* default */.Z);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }
    new core/* default */.Z(slider, swiperOptions);
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/product-grid-carousel.js

var productGridCarousel = function productGridCarousel() {
  var sliders = document.querySelectorAll('.product-list-grid');
  sliders.forEach(function (slider) {
    var autoplay = slider.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(slider.dataset.autoplayDelay);
    var swiperOptions = {
      modules: [scrollbar/* default */.Z],
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      speed: 400,
      spaceBetween: 20,
      slidesPerView: 6,
      breakpoints: {
        1200: {
          slidesPerView: 4.2,
          dragSize: 600
        },
        900: {
          slidesPerView: 3.8,
          dragSize: 300
        },
        600: {
          slidesPerView: 2.7,
          dragSize: 150
        },
        320: {
          slidesPerView: 1.2,
          dragSize: 150
        }
      }
    };
    if (autoplay) {
      swiperOptions.modules.push(autoplay_autoplay/* default */.Z);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }
    new core/* default */.Z(slider, swiperOptions);
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/blog-grid-carousel.js

var blogGridCarousel = function blogGridCarousel() {
  var sliders = document.querySelectorAll('.blog-list-grid');
  sliders.forEach(function (slider) {
    var autoplay = slider.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(slider.dataset.autoplayDelay);
    var swiperOptions = {
      modules: [scrollbar/* default */.Z],
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      speed: 400,
      spaceBetween: 32,
      slidesPerView: 3,
      breakpoints: {
        1200: {
          slidesPerView: 3,
          dragSize: 600
        },
        900: {
          slidesPerView: 3,
          dragSize: 300,
          spaceBetween: 16
        },
        600: {
          slidesPerView: 2.2,
          dragSize: 150,
          spaceBetween: 16
        },
        320: {
          slidesPerView: 1.38,
          dragSize: 150,
          spaceBetween: 16
        }
      }
    };
    if (autoplay) {
      swiperOptions.modules.push(autoplay_autoplay/* default */.Z);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }
    new core/* default */.Z(slider, swiperOptions);
  });
};
// EXTERNAL MODULE: ./node_modules/swiper/modules/zoom/zoom.js
var zoom = __webpack_require__(790);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.js
var pagination = __webpack_require__(224);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/hero-product-gallery.js

function hero_product_gallery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function hero_product_gallery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? hero_product_gallery_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : hero_product_gallery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var heroProductGallery = function heroProductGallery(isInline) {
  return {
    currentSlide: 0,
    swiper: null,
    swiperThumbnails: null,
    swiperEl: null,
    swiperThumbnailsEl: null,
    cachedVideoElements: null,
    trustScoreLink: null,
    init: function init() {
      var _this = this;
      this.$nextTick(function () {
        _this.initializeThumbnails();
        _this.initializeGallery();
        _this.initVideoAutoPause();
        _this.initResizeHandler();
      });
    },
    initResizeHandler: function initResizeHandler() {
      var _this2 = this;
      // Track current breakpoint to detect changes
      this.currentBreakpoint = this.getCurrentBreakpoint();

      // Handle resize events to update Swiper instances
      var handleResize = function handleResize() {
        var newBreakpoint = _this2.getCurrentBreakpoint();

        // Always update swiper dimensions first (immediate)
        if (_this2.swiper) {
          _this2.swiper.update();
        }
        if (_this2.swiperThumbnailsDesktop) {
          _this2.swiperThumbnailsDesktop.update();
        }
        if (_this2.swiperThumbnailsMobile) {
          _this2.swiperThumbnailsMobile.update();
        }

        // Only reinitialize if breakpoint actually changed
        if (newBreakpoint !== _this2.currentBreakpoint) {
          _this2.currentBreakpoint = newBreakpoint;
          _this2.reinitializeSwipers();
        }
      };

      // Immediate resize handler (no debounce for update calls)
      var immediateResize = function immediateResize() {
        if (_this2.swiper) {
          _this2.swiper.update();
        }
        if (_this2.swiperThumbnailsDesktop) {
          _this2.swiperThumbnailsDesktop.update();
        }
        if (_this2.swiperThumbnailsMobile) {
          _this2.swiperThumbnailsMobile.update();
        }
      };

      // Debounce resize events for full reinitialization
      this.resizeTimeout = null;
      this.resizeHandler = function () {
        // Immediate update for responsiveness
        immediateResize();

        // Debounced full resize handling
        clearTimeout(_this2.resizeTimeout);
        _this2.resizeTimeout = setTimeout(handleResize, 150);
      };
      window.addEventListener('resize', this.resizeHandler);
    },
    getCurrentBreakpoint: function getCurrentBreakpoint() {
      var width = window.innerWidth;
      if (width >= 1280) return 'desktop';
      if (width >= 768) return 'tablet';
      return 'mobile';
    },
    reinitializeSwipers: function reinitializeSwipers() {
      var _this3 = this;
      // Store current slide before destroying
      var currentSlide = this.currentSlide;

      // Destroy existing Swiper instances
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (this.swiperThumbnails) {
        this.swiperThumbnails.destroy(true, true);
        this.swiperThumbnails = null;
      }
      if (this.swiperThumbnailsDesktop) {
        this.swiperThumbnailsDesktop.destroy(true, true);
        this.swiperThumbnailsDesktop = null;
      }
      if (this.swiperThumbnailsMobile) {
        this.swiperThumbnailsMobile.destroy(true, true);
        this.swiperThumbnailsMobile = null;
      }

      // Reinitialize Swiper instances
      this.initializeThumbnails();
      this.initializeGallery();

      // Force update all swipers after reinitialization
      this.$nextTick(function () {
        _this3.updateAllSwipers();

        // Restore current slide
        if (_this3.swiper && currentSlide !== 0) {
          _this3.swiper.slideTo(currentSlide, 0);
        }
      });
    },
    updateAllSwipers: function updateAllSwipers() {
      if (this.swiper) {
        this.swiper.update();
      }
      if (this.swiperThumbnailsDesktop) {
        this.swiperThumbnailsDesktop.update();
      }
      if (this.swiperThumbnailsMobile) {
        this.swiperThumbnailsMobile.update();
      }
    },
    updateSlideStatus: function updateSlideStatus(swiper) {
      // Announce current slide for screen readers (similar to product-explorer)
      var currentSlide = swiper.activeIndex + 1;
      var totalSlides = swiper.slides.length;

      // Filter out dummy slides (those added for vertical spacing)
      var realSlides = Array.from(swiper.slides).filter(function (slide) {
        return !slide.classList.contains('max-xl:!hidden');
      });
      var realTotalSlides = realSlides.length;
      var statusText = "Viewing image ".concat(Math.min(currentSlide, realTotalSlides), " of ").concat(realTotalSlides);

      // Update the status element for screen readers
      var slideStatusEl = this.$root.querySelector('[x-ref="slideStatus"]');
      if (slideStatusEl) {
        slideStatusEl.textContent = statusText;
      }

      // Also announce via aria-live for immediate feedback
      var announceEl = this.$root.querySelector('#hero-gallery-slide-status');
      if (announceEl) {
        announceEl.textContent = statusText;
      }
    },
    initializeThumbnails: function initializeThumbnails() {
      // Desktop thumbnails (vertical)
      var desktopEl = this.$root.querySelector('.js-gallery-thumbnails-swiper-desktop');
      if (desktopEl) {
        this.swiperThumbnailsDesktopEl = desktopEl;
        this.swiperThumbnailsDesktop = new core/* default */.Z(desktopEl, {
          slidesPerView: 'auto',
          direction: 'vertical',
          spaceBetween: 12,
          modules: [mousewheel/* default */.Z],
          mousewheel: {
            forceToAxis: true
          }
        });
      }

      // Mobile thumbnails (horizontal)
      var mobileEl = this.$root.querySelector('.js-gallery-thumbnails-swiper-mobile');
      if (mobileEl) {
        this.swiperThumbnailsMobileEl = mobileEl;
        this.swiperThumbnailsMobile = new core/* default */.Z(mobileEl, {
          slidesPerView: 'auto',
          direction: 'horizontal',
          spaceBetween: 8,
          modules: [mousewheel/* default */.Z],
          mousewheel: {
            forceToAxis: true
          }
        });
      }

      // Set the main reference to desktop for backward compatibility
      this.swiperThumbnailsEl = desktopEl;
      this.swiperThumbnails = this.swiperThumbnailsDesktop;
    },
    initializeGallery: function initializeGallery() {
      var _this4 = this;
      var el = this.$root.querySelector('.js-gallery-swiper');
      if (!el) return;
      this.swiperEl = el;
      // Get custom accessibility messages from data attributes
      var customA11y = {
        prevSlideMessage: el.dataset.prevSlideMsg || 'Previous image',
        nextSlideMessage: el.dataset.nextSlideMsg || 'Next image',
        firstSlideMessage: el.dataset.firstSlideMsg || 'This is the first image',
        lastSlideMessage: el.dataset.lastSlideMsg || 'This is the last image'
      };
      this.swiper = new core/* default */.Z(el, {
        modules: [navigation/* default */.Z, scrollbar/* default */.Z, !isInline && zoom/* default */.Z, pagination/* default */.Z, a11y/* default */.Z, keyboard/* default */.Z].filter(Boolean),
        zoom: !isInline,
        keyboard: {
          enabled: true,
          onlyInViewport: false
        },
        a11y: hero_product_gallery_objectSpread({
          enabled: true
        }, customA11y),
        allowTouchMove: true,
        simulateTouch: true,
        breakpoints: {
          0: {
            direction: 'horizontal',
            spaceBetween: 12,
            allowTouchMove: true,
            simulateTouch: true,
            slidesPerView: 1.2,
            centeredSlides: true,
            pagination: {
              el: this.swiperEl.querySelector('.swiper-pagination'),
              type: 'fraction'
            },
            navigation: {
              nextEl: this.swiperEl.querySelector('.swiper-btn-next'),
              prevEl: this.swiperEl.querySelector('.swiper-btn-prev'),
              disabledClass: 'pointer-events-none opacity-30'
            }
          },
          768: {
            direction: 'horizontal',
            spaceBetween: 16,
            allowTouchMove: true,
            simulateTouch: true,
            slidesPerView: 2.5,
            centeredSlides: false,
            pagination: {
              el: this.swiperEl.querySelector('.swiper-pagination'),
              type: 'fraction'
            },
            navigation: {
              nextEl: this.swiperEl.querySelector('.swiper-btn-next'),
              prevEl: this.swiperEl.querySelector('.swiper-btn-prev'),
              disabledClass: 'pointer-events-none opacity-30'
            }
          },
          1280: {
            direction: 'vertical',
            allowTouchMove: false,
            simulateTouch: false,
            navigation: false,
            slidesPerView: 'auto',
            centeredSlides: false
          }
        },
        slidesPerView: 'auto',
        preloadImages: false,
        on: {
          afterInit: function afterInit(swiper) {
            if (_this4.currentSlide !== 0) {
              swiper.slideTo(_this4.currentSlide, 0);
            }
            // Initialize VoiceOver status
            _this4.updateSlideStatus(swiper);
          },
          slideChange: function slideChange(swiper) {
            _this4.currentSlide = swiper.activeIndex;

            // Sync both thumbnail swipers
            if (_this4.swiperThumbnailsDesktop) {
              _this4.swiperThumbnailsDesktop.slideTo(swiper.activeIndex);
            }
            if (_this4.swiperThumbnailsMobile) {
              _this4.swiperThumbnailsMobile.slideTo(swiper.activeIndex);
            }

            // Update VoiceOver announcements
            _this4.updateSlideStatus(swiper);
            _this4.handleVideoPlayback(swiper); // Handle video playback on slide change

            if (!isInline) {
              // defined in modal components
              _this4.currentSlideInfo = "".concat(swiper.activeIndex + 1, "/").concat(swiper.slides.length);
            }
          },
          resize: function resize(swiper) {
            // Force update on swiper's internal resize event
            swiper.update();
          }
        },
        scrollbar: isInline && {
          el: this.swiperEl.querySelector('.swiper-scrollbar')
        }
      });
    },
    initVideoAutoPause: function initVideoAutoPause() {
      var _this5 = this;
      var gallerySection = this.$root.querySelector('.main-hero-carousel');
      if (!gallerySection || !this.swiperEl) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            _this5.pauseAllVideos(); // Pause videos when the gallery is out of view
          }
        });
      }, {
        threshold: 0.1
      });
      observer.observe(gallerySection);
    },
    pauseAllVideos: function pauseAllVideos() {
      var videoElements = this.cachedVideoElements || this.swiperEl.querySelectorAll('.swiper-slide.has-video video');
      videoElements.forEach(function (video) {
        video.pause();
      });
    },
    handleVideoPlayback: function handleVideoPlayback(swiper) {
      var videoElements = this.cachedVideoElements || swiper.el.querySelectorAll('.swiper-slide.has-video video');

      // Cache the video elements for future use
      if (!this.cachedVideoElements) {
        this.cachedVideoElements = videoElements;
      }

      // Pause video in all Video slides
      videoElements.forEach(function (videoElement) {
        videoElement.pause();
      });
      var currentSlideEl = swiper.slides[swiper.activeIndex];
      if (!currentSlideEl || !currentSlideEl.classList.contains('has-video')) return;
      var currentVideoEl = currentSlideEl.querySelector('video');
      if (!currentVideoEl) return;
      currentVideoEl.play(); // Autoplay the video on the current slide
    },
    navigateToVariantSlide: function navigateToVariantSlide(_ref) {
      var media_id = _ref.media_id;
      if (!this.swiper || !media_id) return;
      var targetIndex = this.swiper.slides.findIndex(function (slide) {
        return slide.dataset.mediaId === media_id.toString();
      });
      if (targetIndex !== -1 && targetIndex !== this.swiper.activeIndex) {
        this.swiper.slideTo(targetIndex);
      }
    },
    updateTrustScoreLink: function updateTrustScoreLink(event) {
      var _this6 = this;
      this.trustScoreLink = null;
      this.$nextTick(function () {
        _this6.trustScoreLink = event.detail || '';
      });
    },
    openModal: function openModal() {
      this.$dispatch('hero-product-gallery-open-modal-image', this.currentSlide);
      this.$root.parentElement.querySelector('dialog').showModal();
    },
    handleOpenModalImage: function handleOpenModalImage(_ref2) {
      var idx = _ref2.detail;
      if (!isInline) {
        this.swiper.slideTo(idx, 0);
      }
    },
    destroy: function destroy() {
      // Cleanup resize event listener
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }
  };
};
/* harmony default export */ const hero_product_gallery = (heroProductGallery);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/hero-product-gallery-modal.js

var heroProductGalleryModal = function heroProductGalleryModal() {
  return {
    currentSlideInfo: '',
    open: false,
    init: function init() {
      this.currentSlideInfo = "1/".concat(this.images.length);
      this.mutationObserver = new MutationObserver(this.handleMutation.bind(this));
      this.mutationObserver.observe(this.$el, {
        attributes: true,
        attributeFilter: ['open']
      });
    },
    destroy: function destroy() {
      this.mutationObserver.disconnect();
    },
    handleMutation: function handleMutation() {
      this.open = this.$el.open;
      if (this.open) {
        disableScrollForInputDrawer();
      } else {
        enableScrollForInputDrawer();
      }
    }
  };
};
/* harmony default export */ const hero_product_gallery_modal = (heroProductGalleryModal);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/hero-product-add.js



var heroProductAdd = function heroProductAdd() {
  var hideSubscriptionOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    drawerSide: '',
    stickyButtonVisible: false,
    hideSubscriptionOption: hideSubscriptionOption,
    get selectedVariantsIds() {
      return this.selectedVariants.map(function (variant) {
        return variant.id;
      }).join(',');
    },
    init: function init() {
      var _this = this;
      this.setupStickyButton();
      this.parentSelectedVariants = this.selectedVariants;
      this.$watch('selectedVariantsIds', function (val) {
        _this.parentSelectedVariants = _this.selectedVariants;
        if (_this.selectedVariants.length === 1) {
          var id = val;
          try {
            var url = new URL(window.location.href);
            if (url.searchParams.get('variant') !== id) {
              url.searchParams.set('variant', id);
              window.history.pushState({}, '', url.toString());
            }
          } catch (error) {
            console.warn('Could not update URL with variant:', error);
          }
        }
      });
      this.loadVariantFromUrl();
    },
    destroy: function destroy() {
      var _this$intersectionObs;
      (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 ? void 0 : _this$intersectionObs.disconnect();
    },
    handleButtonClick: function handleButtonClick() {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var stateBase;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              stateBase = _this2.stateBase;
              if (!(stateBase === 'available')) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return _this2.addToCart();
            case 4:
              _this2.isWorking = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loadVariantFromUrl: function loadVariantFromUrl() {
      try {
        var url = new URL(window.location.href);
        var variantId = url.searchParams.get('variant');
        if (variantId) {
          var variant = this.product.variants.find(function (variant) {
            return variant.id.toString() === variantId;
          });
          if (variant) {
            Object.assign(this.selectedOptions, Object.fromEntries(variant.selectedOptions.map(function (_ref) {
              var name = _ref.name,
                value = _ref.value;
              return [name, value];
            })));
            this.normalizeOptionsAndVariants(Object.entries(this.selectedOptions));
          }
        }
      } catch (error) {
        console.warn('Could not load variant from URL:', error);
      }
    },
    handlePopstate: function handlePopstate() {
      this.loadVariantFromUrl();
    },
    setupStickyButton: function setupStickyButton() {
      var _this3 = this;
      this.intersectionObserver = new IntersectionObserver(function (_ref2) {
        var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
          entry = _ref3[0];
        _this3.stickyButtonVisible = !entry.isIntersecting;
      }, {});
      this.intersectionObserver.observe(this.$refs.button);
    }
  };
};
/* harmony default export */ const hero_product_add = (heroProductAdd);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/hero-product-info.js


var computePrice = function computePrice(variants, field, ignoreZeros) {
  var _variants$0$field;
  if (variants.length === 0) {
    return "\u200B";
  }
  if (variants.length === 1) {
    var price = variants[0][field];
    if (!price) return '';
    return formatPrice(price, ignoreZeros);
  }
  var minPrice = Math.min.apply(Math, (0,toConsumableArray/* default */.Z)(variants.map(function (variant) {
    var _variant$field;
    return Number((_variant$field = variant[field]) === null || _variant$field === void 0 ? void 0 : _variant$field.amount);
  })));
  var maxPrice = Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(variants.map(function (variant) {
    var _variant$field2;
    return Number((_variant$field2 = variant[field]) === null || _variant$field2 === void 0 ? void 0 : _variant$field2.amount);
  })));
  var currencyCode = (_variants$0$field = variants[0][field]) === null || _variants$0$field === void 0 ? void 0 : _variants$0$field.currencyCode;
  if (isNaN(minPrice) || isNaN(maxPrice)) return '';
  if (!currencyCode) return '';
  return formatPriceRange({
    amount: minPrice,
    currencyCode: currencyCode
  }, {
    amount: maxPrice,
    currencyCode: currencyCode
  }, ignoreZeros);
};
var heroProductInfo = function heroProductInfo() {
  return {
    get price() {
      return computePrice(this.parentSelectedVariants, 'price', false);
    },
    get priceRegular() {
      return computePrice(this.parentSelectedVariants, 'compareAtPrice', true);
    },
    get hasReducedPrice() {
      var priceRegular = this.priceRegular,
        price = this.price;
      return priceRegular && priceRegular !== price;
    },
    get pricingText() {
      return "reduced price: ".concat(this.price, ", regular price: ").concat(this.priceRegular);
    },
    init: function init() {}
  };
};
/* harmony default export */ const hero_product_info = (heroProductInfo);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/hero-product-accordion.js
var heroProductAccordion = function heroProductAccordion() {
  return {
    open: '',
    toggle: function toggle(id) {
      if (this.open === id) {
        this.open = '';
        return;
      }
      this.open = id;
    }
  };
};
/* harmony default export */ const hero_product_accordion = (heroProductAccordion);
;// CONCATENATED MODULE: ./src/js/bundles/sections/product-explorer.js



function product_explorer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function product_explorer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? product_explorer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : product_explorer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var swiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
  watchSlidesProgress: true,
  slideVisibleClass: 'swiper-slide-visible',
  modules: [navigation/* default */.Z, mousewheel/* default */.Z, a11y/* default */.Z, keyboard/* default */.Z],
  keyboard: {
    enabled: false,
    onlyInViewport: false
  },
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next',
    disabledClass: 'swiper-button-hidden'
  },
  a11y: {
    enabled: true,
    prevSlideMessage: '',
    nextSlideMessage: '',
    firstSlideMessage: '',
    lastSlideMessage: ''
  },
  mousewheel: {
    forceToAxis: true
  },
  on: {
    init: updateSlideTabIndexes,
    slideChange: updateSlideTabIndexes,
    resize: updateSlideTabIndexes
  },
  breakpoints: {
    320: {
      slidesPerView: 1.3787,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16
    },
    640: {
      spaceBetween: 32,
      slidesPerView: 2.5,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    },
    1024: {
      spaceBetween: 32,
      slidesPerView: 3,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    },
    1280: {
      spaceBetween: 32,
      slidesPerView: 4,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    }
  }
};
function updateSlideTabIndexes(swiper) {
  var _swiper$navigation3;
  Array.from(swiper.slides).forEach(function (slide, index) {
    var isVisible = slide.classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible');
    var titleLink = slide.querySelector('h3 a');
    var addToBagBtn = slide.querySelector('button[data-gh-label="add_to_bag"]');
    if (titleLink) {
      titleLink.setAttribute('tabindex', isVisible ? '0' : '-1');
      titleLink.removeEventListener('keydown', titleLink._arrowNavHandler);
      if (isVisible) {
        var handler = function handler(e) {
          if (e.key === 'ArrowRight') {
            var _swiper$navigation, _swiper$navigation$ne;
            var next = findNextVisibleTitle(swiper, index);
            if (next) next.focus();else (_swiper$navigation = swiper.navigation) === null || _swiper$navigation === void 0 ? void 0 : (_swiper$navigation$ne = _swiper$navigation.nextEl) === null || _swiper$navigation$ne === void 0 ? void 0 : _swiper$navigation$ne.focus();
          } else if (e.key === 'ArrowLeft') {
            var _swiper$navigation2, _swiper$navigation2$p;
            var prev = findPrevVisibleTitle(swiper, index);
            if (prev) prev.focus();else (_swiper$navigation2 = swiper.navigation) === null || _swiper$navigation2 === void 0 ? void 0 : (_swiper$navigation2$p = _swiper$navigation2.prevEl) === null || _swiper$navigation2$p === void 0 ? void 0 : _swiper$navigation2$p.focus();
          }
        };
        titleLink._arrowNavHandler = handler;
        titleLink.addEventListener('keydown', handler);
      }
    }
    if (addToBagBtn) {
      addToBagBtn.setAttribute('tabindex', isVisible ? '0' : '-1');
    }
  });

  // ✅ Announce visible slide range for screen reader
  var visibleSlides = Array.from(swiper.slides).filter(function (slide) {
    return slide.classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible');
  });
  var firstVisible = Array.from(swiper.slides).indexOf(visibleSlides[0]) + 1;
  var lastVisible = Array.from(swiper.slides).indexOf(visibleSlides[visibleSlides.length - 1]) + 1;
  var totalSlides = swiper.slides.length;
  var statusText = "You are viewing ".concat(firstVisible, " to ").concat(lastVisible, " of ").concat(totalSlides, " slides");
  var alpineRoot = swiper.el.closest('[x-data]');
  var slideStatusEl = alpineRoot === null || alpineRoot === void 0 ? void 0 : alpineRoot.querySelector('[x-ref="slideStatus"]');
  if (slideStatusEl) {
    slideStatusEl.textContent = statusText;
  }

  // ✅ Safari VoiceOver fix
  var firstVisibleSlide = Array.from(swiper.slides).find(function (slide) {
    return slide.classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible');
  });
  var titleLink = firstVisibleSlide === null || firstVisibleSlide === void 0 ? void 0 : firstVisibleSlide.querySelector('h3 a');
  if (titleLink && document.activeElement === ((_swiper$navigation3 = swiper.navigation) === null || _swiper$navigation3 === void 0 ? void 0 : _swiper$navigation3.nextEl)) {
    setTimeout(function () {
      titleLink.focus();
    }, 10);
  }
}
function findNextVisibleTitle(swiper, currentIndex) {
  var slides = Array.from(swiper.slides);
  for (var i = currentIndex + 1; i < slides.length; i++) {
    if (slides[i].classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible')) {
      return slides[i].querySelector('h3 a');
    }
  }
  return null;
}
function findPrevVisibleTitle(swiper, currentIndex) {
  var slides = Array.from(swiper.slides);
  for (var i = currentIndex - 1; i >= 0; i--) {
    if (slides[i].classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible')) {
      return slides[i].querySelector('h3 a');
    }
  }
  return null;
}
var productExplorer = function productExplorer(numSlides) {
  return {
    numSlides: numSlides || 16,
    selectedIdx: 0,
    carouselData: [],
    get selectedProducts() {
      var _foundCarousel$result;
      var foundCarousel = this.carouselData[this.selectedIdx];
      var firstNumProducts = (foundCarousel === null || foundCarousel === void 0 ? void 0 : (_foundCarousel$result = foundCarousel.results) === null || _foundCarousel$result === void 0 ? void 0 : _foundCarousel$result.slice(0, this.numSlides)) || [];
      return firstNumProducts;
    },
    get selectedCollectionHandle() {
      var _this$carouselData$th;
      return (_this$carouselData$th = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th === void 0 ? void 0 : _this$carouselData$th.handle;
    },
    get selectedCollectionTitle() {
      var _this$carouselData$th2;
      return (_this$carouselData$th2 = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th2 === void 0 ? void 0 : _this$carouselData$th2.title;
    },
    get selectedCollectionCount() {
      var _this$carouselData$th3;
      return (_this$carouselData$th3 = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th3 === void 0 ? void 0 : _this$carouselData$th3.count;
    },
    get selectedCollectionUrl() {
      var _this$carouselData$th4;
      return (_this$carouselData$th4 = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th4 === void 0 ? void 0 : _this$carouselData$th4.url;
    },
    // TODO: consider not using Searchspring
    /**
     * Fetch carousel data from Searchspring API.
     * - Currently only supports fetching either collections data or recommendations, not both
     * - This could be extended to support some tabs being collections and others being
     *   product recommendations.
     */
    getCarouselData: function getCarouselData() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var carouselData, mapSSData, productRequests;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              carouselData = [];
              /**
               * Map the swiper element to an object containing data about the carousel.
               */
              mapSSData = function mapSSData(swiper) {
                var type = swiper.dataset.type;
                return product_explorer_objectSpread(product_explorer_objectSpread({
                  type: type,
                  results: []
                }, type === 'products_by_collection' && {
                  handle: swiper.dataset.collectionHandle,
                  title: swiper.dataset.collectionTitle,
                  url: swiper.dataset.collectionUrl,
                  count: swiper.dataset.collectionCount
                }), type === 'product_recommendations' && {
                  intent: swiper.dataset.recommendationsIntent,
                  productId: swiper.dataset.recommendationsProductId
                });
              };
              carouselData = Array.from(_this.swiperContentEls).map(mapSSData);
              productRequests = carouselData.map(function (entry) {
                return entry.type === 'products_by_collection' ? fetchCollection(entry.handle, null, _this.numSlides) : entry.type === 'product_recommendations' ? fetchRecommendedProducts(entry.intent, "gid://shopify/Product/".concat(entry.productId)) : null;
              });
              _context.next = 6;
              return Promise.all(productRequests).then(function (responses) {
                return responses.forEach(function (response, idx) {
                  var _response$products;
                  carouselData[idx].results = response === null || response === void 0 ? void 0 : (_response$products = response.products) === null || _response$products === void 0 ? void 0 : _response$products.nodes;
                });
              });
            case 6:
              return _context.abrupt("return", carouselData);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    buildSwipers: function buildSwipers() {
      if (this.swiperContentEls) {
        this.swiperContentInstances = Array.from(this.swiperContentEls).map(function (swiperEl) {
          var customA11y = {
            prevSlideMessage: swiperEl.dataset.prevSlideMsg || 'Previous slide',
            nextSlideMessage: swiperEl.dataset.nextSlideMsg || 'Next slide',
            firstSlideMessage: swiperEl.dataset.firstSlideMsg || 'This is the first slide',
            lastSlideMessage: swiperEl.dataset.lastSlideMsg || 'This is the last slide'
          };
          var instance = new core/* default */.Z(swiperEl, product_explorer_objectSpread(product_explorer_objectSpread({}, swiperConfig), {}, {
            a11y: product_explorer_objectSpread(product_explorer_objectSpread({}, swiperConfig.a11y), customA11y)
          }));
          // Set tabindexes initially
          updateSlideTabIndexes(instance);
          // Update tabindexes on every slide change
          instance.on('slideChange', function () {
            return updateSlideTabIndexes(instance);
          });
          // Also update on resize (in case visible slides change)
          instance.on('resize', function () {
            return updateSlideTabIndexes(instance);
          });
          return instance;
        });
      }
    },
    init: function init() {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _window, okeWidgetApi;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _window = window, okeWidgetApi = _window.okeWidgetApi;
              _this2.swiperContentEls = _this2.$el.querySelectorAll('.swiper');
              _this2.collectionCountSpan = _this2.$el.querySelector('#collection_count');
              _context2.next = 5;
              return _this2.getCarouselData();
            case 5:
              _this2.carouselData = _context2.sent;
              _this2.buildSwipers();
              okeWidgetApi === null || okeWidgetApi === void 0 ? void 0 : okeWidgetApi.initAllWidgets(); // eslint-disable-line no-undef

              _this2.$watch('selectedIdx', function (newIndex) {
                var swiperInstance = _this2.swiperContentInstances[newIndex];
                // update since swiper recommends it after you hide/show it
                // source: https://swiperjs.com/swiper-api#method-swiper-update
                swiperInstance.update();
                okeWidgetApi === null || okeWidgetApi === void 0 ? void 0 : okeWidgetApi.initAllWidgets(); // eslint-disable-line no-undef
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  };
};
/* harmony default export */ const product_explorer = (productExplorer);
;// CONCATENATED MODULE: ./src/js/bundles/sections/testimonials-carousel.js

var testimonialsCarousel = function testimonialsCarousel() {
  var sliders = document.querySelectorAll('.customer-testimonials');
  sliders.forEach(function (slider) {
    var sectionId = slider.dataset.sectionId;
    var testimonialSection = slider.closest('.customer-testimonial-section');
    var testimonialLayout = testimonialSection === null || testimonialSection === void 0 ? void 0 : testimonialSection.dataset.testimonialLayout;
    var autoplay = slider.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(slider.dataset.autoplayDelay);

    // Find navigation buttons scoped to this specific section
    var navContainer = testimonialSection === null || testimonialSection === void 0 ? void 0 : testimonialSection.querySelector('.customer-testimonial-navigation');
    var nextButton = navContainer === null || navContainer === void 0 ? void 0 : navContainer.querySelector('.swiper-btn-next');
    var prevButton = navContainer === null || navContainer === void 0 ? void 0 : navContainer.querySelector('.swiper-btn-prev');
    var swiperOptions = {
      modules: [scrollbar/* default */.Z, navigation/* default */.Z],
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      speed: 400,
      spaceBetween: 12,
      slidesPerView: 4,
      breakpoints: {
        1536: {
          slidesPerView: testimonialLayout === 'heading-left' ? 2.825 : 4,
          dragSize: 600,
          spaceBetween: 32
        },
        1200: {
          slidesPerView: 4,
          dragSize: 600,
          spaceBetween: 32
        },
        900: {
          slidesPerView: 2.3,
          dragSize: 150
        },
        600: {
          slidesPerView: 2.3,
          dragSize: 150
        },
        320: {
          slidesPerView: testimonialLayout === 'heading-left' ? 1.38573 : 1.3,
          dragSize: 150,
          spaceBetween: 16
        }
      }
    };
    if (autoplay) {
      swiperOptions.modules.push(autoplay_autoplay/* default */.Z);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }
    new core/* default */.Z(slider, swiperOptions);
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/where-is-my-herbId.js

var herbFinder = function herbFinder() {
  document.addEventListener('DOMContentLoaded', function () {
    // eslint-disable-next-line no-unused-vars
    var herbFinderSwiper = new core/* default */.Z('.herb-finder__instructionContainer', {
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 12
        },
        375: {
          slidesPerView: 1.56,
          spaceBetween: 16
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        700: {
          slidesPerView: 2.5,
          spaceBetween: 32
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 32
        }
      },
      on: {
        afterInit: function afterInit() {
          var herbWrappers = document.querySelectorAll('.herb-finder__wrapper');
          herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
            herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'md:gap-8');
          });
        }
      }
    });
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/landing-page-newsletter.js
var changePlaceholderText = function changePlaceholderText() {
  window.onload = function () {
    var emailInput = document.querySelector(".landing-page__newsletter-form .klaviyo-form input[type='email']");
    if (emailInput) {
      emailInput.placeholder = 'Email address';
    }
  };
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/reviews-carousel.js

function reviews_carousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function reviews_carousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? reviews_carousel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : reviews_carousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// Function to update slide status for screen readers
function updateSlideStatus(swiper) {
  var currentSlide = swiper.activeIndex + 1;
  var totalSlides = swiper.slides.length;
  var statusText = "You are on slide ".concat(currentSlide, " of ").concat(totalSlides);

  // Find the slide status element
  var slideStatusEl = document.querySelector('#slide-status');
  if (slideStatusEl) {
    slideStatusEl.textContent = statusText;
  }
}
var initTestimonialCarousel = function initTestimonialCarousel() {
  document.addEventListener('DOMContentLoaded', function () {
    var swiperContainer = document.querySelector('.review_carousel__container');
    if (!swiperContainer) return;

    // Get custom accessibility messages from data attributes
    var customA11y = {
      prevSlideMessage: swiperContainer.dataset.prevSlideMsg || 'Previous testimonial',
      nextSlideMessage: swiperContainer.dataset.nextSlideMsg || 'Next testimonial',
      firstSlideMessage: swiperContainer.dataset.firstSlideMsg || 'This is the first testimonial',
      lastSlideMessage: swiperContainer.dataset.lastSlideMsg || 'This is the last testimonial'
    };
    var swiper = new core/* default */.Z('.review_carousel__container', {
      slidesPerView: 'auto',
      spaceBetween: 152,
      centeredSlides: true,
      touchEventsTarget: 'container',
      modules: [navigation/* default */.Z, a11y/* default */.Z],
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
        disabledClass: 'swiper-button-hidden'
      },
      a11y: reviews_carousel_objectSpread({
        enabled: true
      }, customA11y),
      on: {
        afterInit: function afterInit(swiper) {
          var reviewWrappers = document.querySelectorAll('.review_carousel__wrapper');
          reviewWrappers.forEach(function (reviewWrapper) {
            reviewWrapper.classList.remove('gap-[152px]');
          });
          // Update slide status on initialization
          updateSlideStatus(swiper);
        },
        slideChange: function slideChange(swiper) {
          // Update slide status when slide changes
          updateSlideStatus(swiper);
        }
      }
    });
    var reviewCarouselSection = document.querySelector('.review_carousel');
    if (reviewCarouselSection) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            swiper.slideTo(1, 600);
            observer.unobserve(reviewCarouselSection);
          }
        });
      }, {
        threshold: 0.5
      });
      observer.observe(reviewCarouselSection);
    }
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/image-carousel.js

var initImageCarousel = function initImageCarousel() {
  document.addEventListener('DOMContentLoaded', function () {
    new core/* default */.Z('.image-carousel__container', {
      slidesPerView: 'auto',
      breakpoints: {
        375: {
          slidesPerView: 1.16367,
          spaceBetween: 16
        },
        1536: {
          slidesPerView: 1.58064,
          spaceBetween: 32
        }
      },
      on: {
        afterInit: function afterInit() {
          var wrappers = document.querySelectorAll('.image-carousel__wrapper');
          wrappers.forEach(function (wrapper) {
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove('gap-4', 'lg:gap-8');
          });
        }
      }
    });
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/thumbnail-content.js

var initThumbnailSwiper = function initThumbnailSwiper() {
  document.addEventListener('DOMContentLoaded', function () {
    new core/* default */.Z('.thumbnail__container', {
      slidesPerView: 'auto',
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 12
        },
        375: {
          slidesPerView: 2.493,
          spaceBetween: 16
        },
        500: {
          slidesPerView: 2.8,
          spaceBetween: 16
        },
        700: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 32
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 32
        }
      },
      on: {
        afterInit: function afterInit() {
          var herbWrappers = document.querySelectorAll('.thumbnail__wrapper');
          herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
            herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'lg:gap-8');
          });
        }
      }
    });
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/ingredient-list.js

var initIngredientList = function initIngredientList() {
  document.addEventListener('DOMContentLoaded', function () {
    new core/* default */.Z('.ingredient__container', {
      slidesPerView: 'auto',
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 12
        },
        375: {
          slidesPerView: 2.2437,
          spaceBetween: 16
        },
        500: {
          slidesPerView: 2.8,
          spaceBetween: 16
        },
        700: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 32
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 32
        }
      },
      on: {
        afterInit: function afterInit() {
          var herbWrappers = document.querySelectorAll('.ingredient__wrapper');
          herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
            herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'lg:gap-8');
          });
        }
      }
    });
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/product-grid.js

var initProductGrid = function initProductGrid() {
  document.addEventListener('DOMContentLoaded', function () {
    new core/* default */.Z('.product-grid__container', {
      slidesPerView: 'auto',
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 12
        },
        375: {
          slidesPerView: 1.3007,
          spaceBetween: 16
        },
        500: {
          slidesPerView: 2.8,
          spaceBetween: 16
        },
        700: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 32
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 32
        }
      },
      on: {
        afterInit: function afterInit() {
          var herbWrappers = document.querySelectorAll('.product-grid__wrapper');
          herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
            herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'lg:gap-8');
          });
        }
      }
    });
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/featureProduct.js
/* eslint-disable prettier/prettier */

var initFeaturedProduct = function initFeaturedProduct() {
  new core/* default */.Z('.product__container', {
    slidesPerView: 'auto',
    breakpoints: {
      375: {
        slidesPerView: 1.3496,
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 32
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32
      }
    },
    on: {
      afterInit: function afterInit() {
        var herbWrappers = document.querySelectorAll('.product__wrapper');
        herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
          herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'lg:gap-8');
        });
      }
    }
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/blog.js


function blog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function blog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? blog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : blog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var DEFAULT_BLOGS_PER_PAGE = 9;
function fetchPost(_x) {
  return _fetchPost.apply(this, arguments);
}
function _fetchPost() {
  _fetchPost = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(body) {
    var response;
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return fetch("https://".concat(Shopify.shop, "/api/2023-07/graphql.json"), {
            method: 'POST',
            body: body,
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': window.STOREFRONT_ACCESS_TOKEN
            }
          });
        case 2:
          response = _context7.sent;
          _context7.next = 5;
          return response.json();
        case 5:
          return _context7.abrupt("return", _context7.sent);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _fetchPost.apply(this, arguments);
}
var blogsSection = function blogsSection() {
  var blogsPerPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BLOGS_PER_PAGE;
  return {
    loading: true,
    blogCategories: [],
    articles: [],
    blogsPerPage: blogsPerPage,
    blogHandle: '',
    pageType: '',
    cursor: '',
    endCursor: '',
    startCursor: '',
    hasPreviousPage: true,
    hasNextPage: true,
    searchTerm: '',
    searchResults: '',
    showResults: false,
    get showAllCategories() {
      return this.pageType === 'multiple';
    },
    initialSetup: function () {
      var _initialSetup = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var response, blogCategories, _response, articles, endCursor, hasNextPage, hasPreviousPage, startCursor;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              response = null;
              if (!this.showAllCategories) {
                _context.next = 8;
                break;
              }
              _context.next = 4;
              return this.fetchBlogsCategory();
            case 4:
              blogCategories = _context.sent;
              this.blogCategories = sortAlpha(blogCategories, 'handle');
              _context.next = 9;
              break;
            case 8:
              this.blogCategories = [];
            case 9:
              if (!(this.blogHandle !== 'all')) {
                _context.next = 15;
                break;
              }
              _context.next = 12;
              return this.fetchArticlesByHandle(this.blogsPerPage, this.blogHandle, this.cursor);
            case 12:
              response = _context.sent;
              _context.next = 18;
              break;
            case 15:
              _context.next = 17;
              return this.fetchAllArticles(this.blogsPerPage, this.cursor);
            case 17:
              response = _context.sent;
            case 18:
              _response = response, articles = _response.articles, endCursor = _response.endCursor, hasNextPage = _response.hasNextPage, hasPreviousPage = _response.hasPreviousPage, startCursor = _response.startCursor;
              this.endCursor = endCursor;
              this.startCursor = startCursor;
              this.hasPreviousPage = hasPreviousPage;
              this.hasNextPage = hasNextPage;
              this.articles = articles;
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initialSetup() {
        return _initialSetup.apply(this, arguments);
      }
      return initialSetup;
    }(),
    fetchAllArticles: function () {
      var _fetchAllArticles = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(blogsPerPage, cursor) {
        var _window$hidden_blogs;
        var cursorQuery, filterQuery, BLOGS_DATA_QUERY, _yield$fetchPost, data, pageInfo, articles;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cursorQuery = cursor ? "after: \"".concat(cursor, "\"") : '';
              filterQuery = '';
              if (((_window$hidden_blogs = window.hidden_blogs) === null || _window$hidden_blogs === void 0 ? void 0 : _window$hidden_blogs.length) > 0) {
                filterQuery = "query:\"tag_not:hide\"";
              }
              BLOGS_DATA_QUERY = "{\n      articles(first: ".concat(blogsPerPage, ", ").concat(filterQuery, ", ").concat(cursorQuery, ")\n      {\n          nodes\n          {\n              title\n              blog{\n                  handle\n              }\n              onlineStoreUrl\n              publishedAt\n              excerpt\n              handle\n              author{\n                  name\n              }\n              image{\n                url(transform:{maxHeight: 320}),\n                altText\n              }\n          }\n          pageInfo\n          {\n              endCursor,\n              hasNextPage\n              hasPreviousPage\n              startCursor\n          }\n      }\n  }");
              _context2.next = 6;
              return fetchPost(JSON.stringify({
                query: BLOGS_DATA_QUERY
              }));
            case 6:
              _yield$fetchPost = _context2.sent;
              data = _yield$fetchPost.data;
              pageInfo = data.articles.pageInfo;
              articles = data.articles.nodes.map(function (article) {
                return {
                  title: article.title,
                  blogHandle: article.blog.handle,
                  articleHandle: article.handle,
                  url: article.onlineStoreUrl,
                  publishedAt: article.publishedAt,
                  author: article.author.name,
                  image: article.image
                };
              });
              return _context2.abrupt("return", blog_objectSpread({
                articles: articles
              }, pageInfo));
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function fetchAllArticles(_x2, _x3) {
        return _fetchAllArticles.apply(this, arguments);
      }
      return fetchAllArticles;
    }(),
    fetchArticlesByHandle: function () {
      var _fetchArticlesByHandle = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(blogsPerPage, blogHandle, cursor) {
        var cursorQuery, BLOGS_DATA_QUERY, _yield$fetchPost2, blog, pageInfo, articles;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              cursorQuery = cursor ? "after: \"".concat(cursor, "\"") : '';
              BLOGS_DATA_QUERY = /* GraphQL */"{\n      blog(handle:\"".concat(blogHandle, "\"){\n          articles(first : ").concat(blogsPerPage, ",").concat(cursorQuery, "){\n            nodes{\n              title\n              blog{\n                  handle\n              }\n              onlineStoreUrl\n              publishedAt\n              excerpt\n              handle\n              author{\n                  name\n              }\n              image{\n                url(transform:{maxHeight: 320}),\n                altText\n              }\n            }\n            pageInfo{\n              endCursor,\n              hasNextPage\n              hasPreviousPage\n              startCursor\n            }\n          }\n        }\n      }");
              _context3.next = 4;
              return fetchPost(JSON.stringify({
                query: BLOGS_DATA_QUERY
              }));
            case 4:
              _yield$fetchPost2 = _context3.sent;
              blog = _yield$fetchPost2.data.blog;
              pageInfo = blog.articles.pageInfo;
              articles = blog.articles.nodes.map(function (node) {
                return {
                  title: node.title,
                  blogHandle: blog.handle,
                  articleHandle: node.handle,
                  url: node.onlineStoreUrl,
                  publishedAt: node.publishedAt,
                  author: node.author.name,
                  image: node.image
                };
              });
              return _context3.abrupt("return", blog_objectSpread({
                articles: articles
              }, pageInfo));
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function fetchArticlesByHandle(_x4, _x5, _x6) {
        return _fetchArticlesByHandle.apply(this, arguments);
      }
      return fetchArticlesByHandle;
    }(),
    fetchBlogsCategory: function () {
      var _fetchBlogsCategory = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
        var _window$hidden_blogs2;
        var filterQuery, BLOGS_DATA_QUERY, _yield$fetchPost3, blogs;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              filterQuery = '';
              if (((_window$hidden_blogs2 = window.hidden_blogs) === null || _window$hidden_blogs2 === void 0 ? void 0 : _window$hidden_blogs2.length) > 0) {
                window.hidden_blogs.forEach(function (element, index) {
                  filterQuery += "-handle:'".concat(element, "'");
                  if (index < window.hidden_blogs.length - 1) filterQuery += ' AND ';
                });
                filterQuery = "query:\"".concat(filterQuery, "\"");
              }
              BLOGS_DATA_QUERY = /* GraphQL */"{\n        blogs(first: 10, ".concat(filterQuery, ") {\n          edges {\n            node {\n              title\n              handle\n            }\n          }\n        }\n      }");
              _context4.next = 5;
              return fetchPost(JSON.stringify({
                query: BLOGS_DATA_QUERY
              }));
            case 5:
              _yield$fetchPost3 = _context4.sent;
              blogs = _yield$fetchPost3.data.blogs;
              return _context4.abrupt("return", blogs.edges.map(function (edge) {
                return {
                  handle: edge.node.handle,
                  title: edge.node.title
                };
              }));
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function fetchBlogsCategory() {
        return _fetchBlogsCategory.apply(this, arguments);
      }
      return fetchBlogsCategory;
    }(),
    goNextPage: function goNextPage() {
      var params = '?' + new URLSearchParams({
        page: this.page + 1,
        cursor: this.endCursor
      }).toString();
      window.location.href = window.location.pathname + params;
    },
    goPreviousPage: function goPreviousPage() {
      var params = '';
      if (this.page > 2) params = '?' + new URLSearchParams({
        page: this.page - 1,
        cursor: this.startCursor
      }).toString();
      window.location.href = window.location.pathname + params;
    },
    isActiveRoute: function isActiveRoute(handle) {
      return handle === this.blogHandle;
    },
    getDate: function getDate(dateString) {
      var date = new Date(dateString);
      var month = date.toLocaleString('default', {
        month: 'long'
      });
      var year = date.toLocaleString('default', {
        year: 'numeric'
      });
      var day = date.toLocaleString('default', {
        day: 'numeric'
      });
      return "".concat(month, " ").concat(day, ", ").concat(year);
    },
    formatDate: function formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    // Add search functionality
    search: function search(term) {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
        var response, data;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this.searchTerm = term.trim();
              if (!(_this.searchTerm.length < 1)) {
                _context5.next = 4;
                break;
              }
              _this.searchResults = '';
              return _context5.abrupt("return", '');
            case 4:
              _context5.prev = 4;
              _context5.next = 7;
              return fetch("/search/suggest?q=".concat(_this.searchTerm, "&resources[limit]=8&resources[type]=article&resources[imit_scope]=each&section_id=predictive-search"), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': window.STOREFRONT_ACCESS_TOKEN
                }
              });
            case 7:
              response = _context5.sent;
              _context5.next = 10;
              return response.text();
            case 10:
              data = _context5.sent;
              _this.searchResults = data;
              _this.showResults = true;
              _context5.next = 20;
              break;
            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](4);
              window.console.error('Error fetching search results:', _context5.t0);
              _this.showResults = false;
              return _context5.abrupt("return", []);
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[4, 15]]);
      }))();
    },
    init: function () {
      var _init = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
        var _URLSearchParams$get;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.pageType = window.category_page_type;
              this.blogHandle = window.location.pathname.split('/')[2];
              this.page = new URLSearchParams(window.location.search).get('page') ? Number(new URLSearchParams(window.location.search).get('page')) : 1;
              this.cursor = (_URLSearchParams$get = new URLSearchParams(window.location.search).get('cursor')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : '';
              _context6.next = 6;
              return this.initialSetup();
            case 6:
              this.loading = false;
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  };
};
/* harmony default export */ const blog = (blogsSection);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/account-menu.js

var dom = {
  accountLink: 'data-account-nav-link'
};
var setup = function setup() {
  var href = window.location.href;
  if (!href.includes('/tools/recurring') && !href.includes('/account')) {
    return;
  }
  var links = document.querySelectorAll("[".concat(dom.accountLink, "]")) || [];
  var activeLink = (0,toConsumableArray/* default */.Z)(links).reverse().find(function (link) {
    var linkURL = link.getAttribute(dom.accountLink);
    if (href.includes(linkURL)) {
      return true;
    }
    return false;
  }) || false;
  activeLink && activeLink.classList.add('active');

  // Set selected option in the default HTML select based on current URL
  var selectElement = document.getElementById('accountNav');
  if (selectElement) {
    var selectOptions = selectElement.querySelectorAll('option') || [];
    var found = false;
    (0,toConsumableArray/* default */.Z)(selectOptions).reverse().forEach(function (option) {
      if (href.includes(option.value) && found === false) {
        option.setAttribute('selected', 'selected');
        found = true;
      }
    });
  }

  /* BACKUP: CUSTOM SELECT IMPLEMENTATION (COMMENTED OUT FOR ADA COMPLIANCE)
  // CUSTOM SELECT
  let numOfParentOptions, parentSelElmnt, selectDiv, pseudoSelectDiv, pseudoOptionDiv;
  const parentSelectContainers = document.getElementsByClassName('gh-custom-select');
  const pSelContLen = parentSelectContainers.length;
  for (let i = 0; i < pSelContLen; i++) {
    parentSelElmnt = parentSelectContainers[i].getElementsByTagName('select')[0];
    numOfParentOptions = parentSelElmnt.length;
    selectDiv = document.createElement('div');
    selectDiv.setAttribute('class', 'select-selected');
    const selectedText = parentSelElmnt.options[parentSelElmnt.selectedIndex].innerHTML;
    selectDiv.innerHTML = selectedText;
    parentSelectContainers[i].appendChild(selectDiv);
    pseudoSelectDiv = document.createElement('div');
    pseudoSelectDiv.setAttribute('class', 'select-items');
    for (let j = 0; j < numOfParentOptions; j++) {
      const pseudoOptionHref = parentSelElmnt.options[j].value;
      const pseudoOptionTitle = parentSelElmnt.options[j].innerHTML;
      const pseudoOptionClasses = parentSelElmnt.options[j].className;
      if (pseudoOptionTitle !== selectedText) {
        pseudoOptionDiv = document.createElement('div');
        pseudoOptionDiv.innerHTML = `<a class="${pseudoOptionClasses}" href="${pseudoOptionHref}">${pseudoOptionTitle}</a>`;
        pseudoSelectDiv.appendChild(pseudoOptionDiv);
      }
    }
    parentSelectContainers[i].appendChild(pseudoSelectDiv);
    selectDiv.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('active');
      this.classList.toggle('select-arrow-active');
    });
  }
  // launches the spinner overlay and navigates to href
  pseudoSelectDiv.addEventListener('click', function (e) {
    e.target.parentElement.parentElement.classList.remove('active');
    const navSpinner = document.getElementById('rc__overlay');
    navSpinner.style.display = 'block';
    navSpinner.addEventListener('click', function () {
      navSpinner.style.display = 'none';
    });
    if (e.target.tagName === 'DIV') {
      window.location.replace(e.target.firstChild.href);
    } else {
      window.location.replace(e.target.href);
    }
    e.preventDefault();
  });
   function closeAllSelect(elmnt) {
    let i;
    const arrNo = [];
    const x = document.getElementsByClassName('select-items');
    const y = document.getElementsByClassName('select-selected');
    const xl = x.length;
    const yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) { // eslint-disable-line
        arrNo.push(i);
      } else {
        x[i].classList.remove('active');
        y[i].classList.remove('select-arrow-active');
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add('select-hide');
      }
    }
  }
  document.addEventListener('click', closeAllSelect);
  // END CUSTOM SELECT CODE
  */
};

/* harmony default export */ const account_menu = ({
  setup: setup
});
;// CONCATENATED MODULE: ./src/js/bundles/layout/theme.js
/*
 * Basic file with global javascript.
 * Files imported here will be available on every page.
 */








 // tailwind
 // subscription account nav

/** Global Scripts */











/** Collection Scripts */








/** Cart Scripts */







/** Product Detail Page Scripts */











/** Components */











/** Blogs & Articles */


// create an event listener here
document.addEventListener('cart-updated', function (_ref) {
  var detail = _ref.detail;
  var cartCountSelector = document.querySelector('.notification-badge');
  cartCountSelector.innerHTML = detail.cart.item_count;
});

/** Global Components */
module_esm/* default.plugin */.Z.plugin(dist_module_esm/* default */.Z);
module_esm/* default.data */.Z.data('navDesktop', navDesktopComponent);
module_esm/* default.data */.Z.data('navMobile', navMobileComponent);
module_esm/* default.data */.Z.data('drawerV2', drawer_v2);
module_esm/* default.data */.Z.data('responsiveImageV2', responsive_image_v2);
module_esm/* default.data */.Z.data('searchComponent', searchComponent);

/** Collection Components */
module_esm/* default.data */.Z.data('productsBrowser', products_browser);
module_esm/* default.data */.Z.data('productsBrowserFacet', products_browser_facet);
module_esm/* default.data */.Z.data('productsBrowserFacetSlider', products_browser_facet_slider);
module_esm/* default.data */.Z.data('productsBrowserFacetsWrapper', products_browser_facets_wrapper);
module_esm/* default.data */.Z.data('productCard', product_card);
module_esm/* default.data */.Z.data('productsBrowserSort', products_browser_sort);
module_esm/* default.data */.Z.data('subscribeSave', subscribe_save);

/** Load Cart Components */
module_esm/* default.data */.Z.data('cartComponent', cartComponent);
module_esm/* default.data */.Z.data('productData', productData);
module_esm/* default.data */.Z.data('productTrustScore', productTrustScore);
module_esm/* default.data */.Z.data('lineItemComponent', line_item);
module_esm/* default.data */.Z.data('recommendedProducts', recommended_products);

/**Load Product Detail Page Components */
module_esm/* default.data */.Z.data('heroProduct', hero_product);
module_esm/* default.data */.Z.data('heroProductGallery', hero_product_gallery);
module_esm/* default.data */.Z.data('heroProductGalleryModal', hero_product_gallery_modal);
module_esm/* default.data */.Z.data('heroProductAdd', hero_product_add);
module_esm/* default.data */.Z.data('heroProductInfo', hero_product_info);
module_esm/* default.data */.Z.data('heroProductAccordion', hero_product_accordion);
module_esm/* default.data */.Z.data('pdpCompareComponent', pdpCompareComponent);
module_esm/* default.data */.Z.data('loadProductData', loadProductData);
module_esm/* default.data */.Z.data('plpCompareComponent', plpCompareComponent);
module_esm/* default.data */.Z.data('compareLoadProductData', loadProductData);

/** Account Nav  */


document.addEventListener('DOMContentLoaded', function () {
  account_menu.setup();
});

/** Blogs & Articles  */
module_esm/* default.data */.Z.data('blogsSection', blog);

/** Extra Components */
module_esm/* default.data */.Z.data('productExplorer', product_explorer);
var navStoreInstance = navStore();
module_esm/* default.store */.Z.store('nav', navStoreInstance);
var rebuyCartStateInstance = rebuyCartState();
module_esm/* default.store */.Z.store('rebuyCart', rebuyCartStateInstance);
var quickBuyModalInstance = quickBuyModal();
module_esm/* default.store */.Z.store('quickBuyModal', quickBuyModalInstance);
var cartStoreInstance = cartStore();
module_esm/* default.store */.Z.store('cart', cartStoreInstance);
window.cartStore = cartStoreInstance;

// No global compare store needed - components handle their own state

module_esm/* default.plugin */.Z.plugin(x_on_shopify);
evaluateScreenSize();
stickyHeader();
algoliaHandler().init();
rebuyCartHandler().init();
desktopStepsSlider();
productGridCarousel();
blogGridCarousel();
testimonialsCarousel();
herbFinder();
initThumbnailSwiper();
initIngredientList();
initProductGrid();
changePlaceholderText();
initTestimonialCarousel();
initImageCarousel();
initFeaturedProduct();

/*
  Observe the Email sign-up popup coming from the Attentive app 
  to make it appear behind the Rebuy Cart.
*/
observeAttentiveOverlay();
window.Alpine = module_esm/* default */.Z;
module_esm/* default.start */.Z.start();

// // BUGHERD
if (window.location.hostname !== '127.0.0.1' && !window.Shopify.designMode && window.Shopify.theme.role !== 'main') {
  var script = document.createElement('script');
  script.src = 'https://www.bugherd.com/sidebarv2.js?apikey=czwfalkp21nfn9k6j07x4q';
  document.head.append(script);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			505: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkAnatta_Shopify_Development"] = self["webpackChunkAnatta_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [604,147,216], () => (__webpack_require__(432)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;